//https://cdn.haworth.com/haworth-configurator/0.0.33/assets/w-cf/scripts/cf.min.js
'use strict';
var egr,
  __extends =
    (this && this.__extends) ||
    (function () {
      var n = function (e, t) {
        return (n =
          Object.setPrototypeOf ||
          ({ __proto__: [] } instanceof Array &&
            function (e, t) {
              e.__proto__ = t;
            }) ||
          function (e, t) {
            for (var r in t) t.hasOwnProperty(r) && (e[r] = t[r]);
          })(e, t);
      };
      return function (e, t) {
        function r() {
          this.constructor = e;
        }
        n(e, t),
          (e.prototype =
            null === t
              ? Object.create(t)
              : ((r.prototype = t.prototype), new r()));
      };
    })(),
  __awaiter =
    (this && this.__awaiter) ||
    function (e, s, o, l) {
      return new (o = o || Promise)(function (r, t) {
        function n(e) {
          try {
            a(l.next(e));
          } catch (e) {
            t(e);
          }
        }
        function i(e) {
          try {
            a(l.throw(e));
          } catch (e) {
            t(e);
          }
        }
        function a(e) {
          var t;
          e.done
            ? r(e.value)
            : ((t = e.value) instanceof o
                ? t
                : new o(function (e) {
                    e(t);
                  })
              ).then(n, i);
        }
        a((l = l.apply(e, s || [])).next());
      });
    },
  __generator =
    (this && this.__generator) ||
    function (r, n) {
      var i,
        a,
        s,
        o = {
          label: 0,
          sent: function () {
            if (1 & s[0]) throw s[1];
            return s[1];
          },
          trys: [],
          ops: [],
        },
        e = { next: t(0), throw: t(1), return: t(2) };
      return (
        'function' == typeof Symbol &&
          (e[Symbol.iterator] = function () {
            return this;
          }),
        e
      );
      function t(t) {
        return function (e) {
          return (function (t) {
            if (i) throw new TypeError('Generator is already executing.');
            for (; o; )
              try {
                if (
                  ((i = 1),
                  a &&
                    (s =
                      2 & t[0]
                        ? a.return
                        : t[0]
                        ? a.throw || ((s = a.return) && s.call(a), 0)
                        : a.next) &&
                    !(s = s.call(a, t[1])).done)
                )
                  return s;
                switch (((a = 0), s && (t = [2 & t[0], s.value]), t[0])) {
                  case 0:
                  case 1:
                    s = t;
                    break;
                  case 4:
                    return o.label++, { value: t[1], done: !1 };
                  case 5:
                    o.label++, (a = t[1]), (t = [0]);
                    continue;
                  case 7:
                    (t = o.ops.pop()), o.trys.pop();
                    continue;
                  default:
                    if (
                      !(s = 0 < (s = o.trys).length && s[s.length - 1]) &&
                      (6 === t[0] || 2 === t[0])
                    ) {
                      o = 0;
                      continue;
                    }
                    if (3 === t[0] && (!s || (t[1] > s[0] && t[1] < s[3]))) {
                      o.label = t[1];
                      break;
                    }
                    if (6 === t[0] && o.label < s[1]) {
                      (o.label = s[1]), (s = t);
                      break;
                    }
                    if (s && o.label < s[2]) {
                      (o.label = s[2]), o.ops.push(t);
                      break;
                    }
                    s[2] && o.ops.pop(), o.trys.pop();
                    continue;
                }
                t = n.call(r, o);
              } catch (e) {
                (t = [6, e]), (a = 0);
              } finally {
                i = s = 0;
              }
            if (5 & t[0]) throw t[1];
            return { value: t[0] ? t[1] : void 0, done: !0 };
          })([t, e]);
        };
      }
    };
!(function (e) {
  var u, t, r, n;
  function b(e) {
    var t = r.call(this) || this;
    return (t.mArticleManager = e), t;
  }
  (u = e.wcf || (e.wcf = {})),
    (t = u.cf || (u.cf = {})),
    (r = u.core.AppModule),
    __extends(b, r),
    Object.defineProperty(b.prototype, 'moduleId', {
      get: function () {
        return b.MODULE_KEY;
      },
      enumerable: !1,
      configurable: !0,
    }),
    Object.defineProperty(b.prototype, 'articleManager', {
      get: function () {
        return this.mArticleManager;
      },
      enumerable: !1,
      configurable: !0,
    }),
    (b.prototype.clearDocumentData = function () {
      this.mArticleManager._clear();
    }),
    (b.prototype.loadDocumentData = function (a, s) {
      return __awaiter(this, void 0, void 0, function () {
        var t, r, n, i;
        return __generator(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, a.getResource('project.obk', !0)];
            case 1:
              return (
                (t = e.sent()),
                (r = this.mArticleManager.session).isValid
                  ? ((n = new Blob([t])), [4, r.uploadFile('Project', n)])
                  : [3, 5]
              );
            case 2:
              if (((i = e.sent()), u.utils.string.isNullOrEmpty(i)))
                throw new Error('Failed to upload obk.');
              return [4, r.session.loadSession(i)];
            case 3:
              return e.sent(), [4, r.deleteFile(i)];
            case 4:
              return e.sent(), [3, 7];
            case 5:
              return [4, this.mArticleManager.offlineContext._loadObk(t)];
            case 6:
              e.sent(), (e.label = 7);
            case 7:
              return null == s ? [3, 9] : [4, this.loadCatalogImages(a, s)];
            case 8:
              e.sent(), (e.label = 9);
            case 9:
              return [2];
          }
        });
      });
    }),
    (b.prototype.saveDocumentData = function (i, a) {
      return __awaiter(this, void 0, void 0, function () {
        var t, r, n;
        return __generator(this, function (e) {
          switch (e.label) {
            case 0:
              return null == i
                ? [2, null]
                : a.embedAppModuleResources
                ? ((t = {}), [4, this.mArticleManager.saveToObk(!1)])
                : [3, 4];
            case 1:
              if (((r = e.sent()), u.utils.string.isNullOrEmpty(r)))
                throw new Error('Failed to get obk url.');
              return [4, i.addResourceFromUrl(r, 'project.obk', !0, !1)];
            case 2:
              return e.sent(), (n = t), [4, this.saveCatalogImages(i)];
            case 3:
              return (n.catalogImages = e.sent()), [2, t];
            case 4:
              return [2, null];
          }
        });
      });
    }),
    (b._GetCatalogImageIndex = function (e, t) {
      if (u.utils.string.isNullOrEmpty(e) || null == t) return null;
      var r = t.customState.getData(b.MODULE_KEY, b.STATE_CATALOGIMG_INDEX_MAP);
      return null == r ? null : r.get(e);
    }),
    (b._GetCatalogImageByIndex = function (e, t) {
      if (null == e || null == t) return null;
      var r = t.customState.getData(
        b.MODULE_KEY,
        b.STATE_CATALOGIMG_INDEX_ARRAY
      );
      return null == r ? null : r[e];
    }),
    (b.prototype.saveCatalogImages = function (A) {
      return __awaiter(this, void 0, void 0, function () {
        var t, r, n, i, a, s, o, l, c, u, m, h, p, d, g, f;
        return __generator(this, function (e) {
          switch (e.label) {
            case 0:
              for (
                t = new Set(),
                  r = this.mArticleManager.getAllMainArticles(),
                  n = 0,
                  i = r;
                n < i.length;
                n++
              )
                if (null != (a = i[n]).basketId)
                  for (
                    t.add(a._getCatalogImageId(a.basketId)),
                      s = a.getSubArticles(!1),
                      o = 0,
                      l = s;
                    o < l.length;
                    o++
                  )
                    null != (c = l[o]).basketId &&
                      t.add(a._getCatalogImageId(c.basketId));
              (u = new Array()),
                (m = new Map()),
                (h = t.values()),
                (p = h.next()),
                (e.label = 1);
            case 1:
              return p.done
                ? [3, 4]
                : ((d = p.value),
                  null ==
                    (g = this.mArticleManager._getCatalogImageFromCache(d)) ||
                  null == d
                    ? [3, 3]
                    : ((f = this.getCatalogImageResourcePath(d, g.name)),
                      [4, A.addResource(g.data, f, !1)]));
            case 2:
              e.sent(),
                m.set(d, u.length),
                u.push({ id: d, name: g.name }),
                (e.label = 3);
            case 3:
              return (p = h.next()), [3, 1];
            case 4:
              return (
                A.customState.setData(
                  b.MODULE_KEY,
                  b.STATE_CATALOGIMG_INDEX_MAP,
                  m
                ),
                [2, u]
              );
          }
        });
      });
    }),
    (b.prototype.loadCatalogImages = function (l, c) {
      return __awaiter(this, void 0, void 0, function () {
        var t, r, n, i, a, s, o;
        return __generator(this, function (e) {
          switch (e.label) {
            case 0:
              if (null == c || null == c.catalogImages) return [2];
              (t = new Array()), (r = 0), (n = c.catalogImages), (e.label = 1);
            case 1:
              if (!(r < n.length)) return [3, 6];
              (i = n[r]), (e.label = 2);
            case 2:
              return (
                e.trys.push([2, 4, , 5]),
                t.push(i.id),
                (a = this.getCatalogImageResourcePath(i.id, i.name)),
                [4, l.getResource(a, !0)]
              );
            case 3:
              return (
                null != (s = e.sent()) &&
                  this.mArticleManager._addCatalogImageToCache(i.id, {
                    data: s,
                    name: i.name,
                  }),
                [3, 5]
              );
            case 4:
              return (
                (o = e.sent()),
                u.utils.Log.error('Failed to load catalog image ' + i.id, o),
                [3, 5]
              );
            case 5:
              return r++, [3, 1];
            case 6:
              return (
                l.customState.setData(
                  b.MODULE_KEY,
                  b.STATE_CATALOGIMG_INDEX_ARRAY,
                  t
                ),
                [2]
              );
          }
        });
      });
    }),
    (b.prototype.getCatalogImageResourcePath = function (e, t) {
      return (
        'catalogimages/' + e + u.utils.string.getFileExtension(t).toLowerCase()
      );
    }),
    (b.MODULE_KEY = 'egr.wcf.cf'),
    (b.STATE_CATALOGIMG_INDEX_MAP = 'catalogImgIndexMap'),
    (b.STATE_CATALOGIMG_INDEX_ARRAY = 'IndexCatalogImgArray'),
    (n = b),
    (t.AppModule = n);
})((egr = egr || {})),
  (function (e) {
    var c, l, i, t;
    function r(e, t, r) {
      var n = i.call(this, t.app.model, r) || this;
      return (
        (n.onSetPropertyValue = function (e, t) {
          if (null == e) return Promise.resolve(0);
          var r = null;
          return (
            null != t && (r = t.toString()),
            n.setEaiwsPropertyValue(e.propClass, e.propName, r, !0)
          );
        }),
        (n.mBasketId = e),
        (n.mRecoveryBasketId = e),
        (n.mMngr = t),
        (n.mOapInteractors = new l.oap.Interactors(n, n.mMngr)),
        n.eventAdded.addListener(function () {
          return n.mMngr.eventArticleAdded.trigger(n);
        }),
        n.eventRemoved.addListener(function () {
          return n.mMngr.eventArticleRemoved.trigger(n);
        }),
        n
      );
    }
    (c = e.wcf || (e.wcf = {})),
      (l = c.cf || (c.cf = {})),
      (i = c.core.mdl.SceneElement),
      __extends(r, i),
      Object.defineProperty(r.prototype, 'basketId', {
        get: function () {
          return this.mBasketId;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'category', {
        get: function () {
          return 1;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'hasGeometry', {
        get: function () {
          return this.boundingBox.isValid();
        },
        enumerable: !1,
        configurable: !0,
      }),
      (r.prototype.showInteractors = function (e) {
        this.mOapInteractors.showInteractors(e);
      }),
      (r.prototype.dispose = function () {
        i.prototype.dispose.call(this), this.mOapInteractors.dispose();
      }),
      (r.prototype.getArticleData = function (e) {
        var t = this;
        return this.ensureIsInstanced().then(function () {
          return null == t.mBasketId
            ? c.utils.rejectError(c.utils.ERR_INVALID_STATE, 'basketId is null')
            : t.getMainArticle()._getArticleData(t.mBasketId, e);
        });
      }),
      (r.prototype.getCachedArticleData = function (e) {
        if (null != this.mBasketId)
          return this.getMainArticle()._getCachedArticleData(this.mBasketId, e);
      }),
      (r.prototype.getBasketItem = function () {
        var e = this;
        return this.ensureIsInstanced().then(function () {
          return null == e.mBasketId
            ? c.utils.rejectError(c.utils.ERR_INVALID_STATE, 'basketId is null')
            : e.getMainArticle()._getBasketItem(e.mBasketId);
        });
      }),
      (r.prototype.getCachedBasketItem = function () {
        if (null != this.mBasketId)
          return this.getMainArticle()._getCachedBasketItem(this.mBasketId);
      }),
      (r.prototype.getItemProperties = function () {
        var e = this;
        return this.ensureIsInstanced().then(function () {
          return null == e.mBasketId
            ? c.utils.rejectError(c.utils.ERR_INVALID_STATE, 'basketId is null')
            : e.getMainArticle()._getItemProperties(e.mBasketId);
        });
      }),
      (r.prototype.getCachedItemProperties = function () {
        if (null != this.mBasketId)
          return this.getMainArticle()._getCachedItemProperties(this.mBasketId);
      }),
      (r.prototype.getCalculation = function () {
        var e = this;
        return this.ensureIsInstanced().then(function () {
          return null == e.mBasketId
            ? c.utils.rejectError(c.utils.ERR_INVALID_STATE, 'basketId is null')
            : e.getMainArticle()._getCalculation(e.mBasketId);
        });
      }),
      (r.prototype.getCachedCalculation = function () {
        if (null != this.mBasketId)
          return this.getMainArticle()._getCachedCalculation(this.mBasketId);
      }),
      (r.prototype.getCachedConfigData = function () {
        if (null != this.mBasketId)
          return this.getMainArticle()._getCachedConfigData(this.mBasketId);
      }),
      (r.prototype.getCatalogImage = function () {
        var e = this;
        return this.ensureIsInstanced().then(function () {
          return null == e.mBasketId
            ? c.utils.rejectError(c.utils.ERR_INVALID_STATE, 'basketId is null')
            : e.getMainArticle()._getCatalogImage(e.mBasketId);
        });
      }),
      (r.prototype.getSubArticles = function (e) {
        var t = new Array();
        return this.collectSubArticles(this.mNode, t, e), t;
      }),
      (r.prototype.getSubArticleById = function (e) {
        return this.findSubArticle(this.mNode, e);
      }),
      (r.prototype.setEaiwsPropertyValue = function (a, s, o, l) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.ensureIsInstanced()];
              case 1:
                if ((e.sent(), null == this.mBasketId))
                  throw c.utils.newError(
                    c.utils.ERR_INVALID_STATE,
                    'basketId is null'
                  );
                e.label = 2;
              case 2:
                return (
                  e.trys.push([2, , 8, 9]),
                  this.mModel.beginModification(),
                  this.beginPropertyChange(),
                  [
                    4,
                    this.mMngr.session.basket.setPropertyValue(
                      this.mBasketId,
                      a,
                      s,
                      o
                    ),
                  ]
                );
              case 3:
                return null == (t = e.sent()) || 'U' === t
                  ? [3, 6]
                  : ((r = this.getMainArticle()),
                    (n = -1 !== t.indexOf('u')),
                    (i = -1 !== t.indexOf('r')),
                    r._clearCachedArticleInfo(this, n),
                    this.notifyChange(16),
                    l ? [4, r.updateGeometry(i)] : [3, 5]);
              case 4:
                e.sent(), (e.label = 5);
              case 5:
                return (
                  this.mMngr._notifyArticleChanged(n ? r : this, n), [2, 2]
                );
              case 6:
                return [2, 0];
              case 7:
                return [3, 9];
              case 8:
                return (
                  this.endPropertyChange(), this.mModel.endModification(), [7]
                );
              case 9:
                return [2];
            }
          });
        });
      }),
      (r.prototype.getProperties = function () {
        var t = this;
        return this.isDisposed
          ? Promise.resolve(null)
          : this.getArticleData().then(function (e) {
              return l.ArticlePropertyHelpers.GetProperties(
                t.basketId,
                t.mMngr.session,
                t,
                e,
                t.onSetPropertyValue
              );
            });
      }),
      (r.prototype.getPropertyClasses = function () {
        return this.isDisposed
          ? Promise.resolve(null)
          : this.getArticleData().then(function (e) {
              return l.ArticlePropertyHelpers.GetPropertyClasses(e);
            });
      }),
      (r.prototype.hasInteractors = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.getMainArticle()._getOapInteractors(this)];
              case 1:
                return [2, null != (t = e.sent()) && 0 < t.length];
            }
          });
        });
      }),
      (r.GetEaiwsProperty = function (e) {
        var t = l.ArticlePropertyHelpers.GetPropertyUserData(e);
        return null == t ? null : t.eaiwsProperty;
      }),
      (r.prototype._setBasketId = function (e) {
        (this.mBasketId = e),
          (this.mRecoveryBasketId = e),
          c.core.mdl.NodeUserData.SetData(this.mNode, r.NODEDATA_BASKETID, e);
      }),
      (r.prototype._getRecoveryBasketId = function () {
        return this.mRecoveryBasketId;
      }),
      (r._GetOfmlUpdateState = function (e, t, r) {
        if (
          null != r &&
          null != r.ofmlUpdateState &&
          'Unknown' !== r.ofmlUpdateState
        )
          return Promise.resolve(r.ofmlUpdateState);
        if (null == e || null == t)
          return Promise.reject(new Error(c.utils.ERR_INVALID_ARGUMENT));
        var n = new c.eaiws.basket.UpdateBasketArticlesOptions();
        return (
          (n.migrate = !1),
          (n.update = !1),
          e.basket.updateBasketArticles([t], null, n).then(function (e) {
            return null != e && 0 < e.length ? e[0].updateState : 'Unknown';
          })
        );
      }),
      (r.prototype.copyDataFrom = function (e) {
        i.prototype.copyDataFrom.call(this, e),
          null != e &&
            e instanceof r &&
            (this.mRecoveryBasketId = e.mRecoveryBasketId);
      }),
      (r.prototype.collectSubArticles = function (e, t, r) {
        if (null != e)
          for (var n = 0, i = e.getChildTransformNodes(!0); n < i.length; n++) {
            var a = i[n],
              s = !0,
              o = c.core.mdl.SceneElement.FromNode(a, !1);
            null != o &&
              o instanceof l.SubArticleElement &&
              (t.push(o), (s = !r)),
              s && this.collectSubArticles(a, t, r);
          }
      }),
      (r.prototype.findSubArticle = function (e, t) {
        if (null == e) return null;
        for (
          var r = null, n = 0, i = e.getChildTransformNodes(!0);
          n < i.length;
          n++
        ) {
          var a = i[n],
            s = c.core.mdl.SceneElement.FromNode(a, !1);
          if (
            null != s &&
            s instanceof l.SubArticleElement &&
            s.basketId === t
          ) {
            r = s;
            break;
          }
          if (null != (r = this.findSubArticle(a, t))) break;
        }
        return r;
      }),
      (r.NODEDATA_BASKETID = 'cf:basketId'),
      (r.NODEDATA_SELECTABLE = 'cf:selectable'),
      (t = r),
      (l.ArticleElement = t);
  })((egr = egr || {})),
  (function (e) {
    var A;
    (function (o) {
      var e =
        ((t.Import = function (t, r, n, i, a) {
          return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (e) {
              return [2, new s(t).import(r, n, i, a)];
            });
          });
        }),
        t);
      function t() {}
      o.ArticleImport = e;
      var s =
        ((r.prototype.import = function (p, d, g, f) {
          return __awaiter(this, void 0, void 0, function () {
            var t, r, n, i, a, s, o, l, c, u, m, h;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  if (0 === d.length || 0 === p.length) return [2, []];
                  for (
                    this.mImportNoPosArticles =
                      null != f && !0 === f.importArticlesWithoutPosition,
                      t = 0,
                      r = p;
                    t < r.length;
                    t++
                  )
                    (a = r[t]), this.mItemsMap.set(a.itemId, a);
                  for (n = 0, i = d; n < i.length; n++)
                    (l = i[n]),
                      this.mItemPropsMap.set(l.itemId, l),
                      null != l.itemId &&
                        null != l.article &&
                        null != (a = this.mItemsMap.get(l.itemId)) &&
                        a.getMainArticleId() === a.itemId &&
                        this.mMainArticles.push(l);
                  (s = 0), (o = this.mMainArticles), (e.label = 1);
                case 1:
                  return s < o.length
                    ? ((l = o[s]), [4, this.importArticle(l, g, f)])
                    : [3, 4];
                case 2:
                  e.sent(), (e.label = 3);
                case 3:
                  return s++, [3, 1];
                case 4:
                  this.placeNoPosArticles(),
                    (c = Array.from(this.mSetArticlesToReset)),
                    (u = 0),
                    (m = c),
                    (e.label = 5);
                case 5:
                  return u < m.length
                    ? ((h = m[u]), [4, this.resetQuantity(h)])
                    : [3, 8];
                case 6:
                  e.sent(), (e.label = 7);
                case 7:
                  return u++, [3, 5];
                case 8:
                  return [2, this.mLoadedArticles];
              }
            });
          });
        }),
        (r.prototype.importArticle = function (s, o, l) {
          return __awaiter(this, void 0, void 0, function () {
            var t, r, n, i, a;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  return (
                    (t =
                      null != s.composableGeometry &&
                      s.composableGeometry.enabled),
                    null == s.article ||
                    (!this.mImportNoPosArticles && !t) ||
                    'SetArticle' === s.itemType
                      ? [2]
                      : [4, this.getArticleQuantity(s)]
                  );
                case 1:
                  return (
                    e.sent(),
                    (r = s.itemId),
                    (n = !1),
                    (i = 'UserArticle' === s.itemType)
                      ? [3, 3]
                      : [4, this.updateOrMigrateArticle(s, l)]
                  );
                case 2:
                  (n = e.sent()), (e.label = 3);
                case 3:
                  return (
                    (a = null),
                    i
                      ? [
                          4,
                          this.mMngr._createUserArticleElement(
                            r,
                            this.mItemsMap,
                            this.mItemPropsMap
                          ),
                        ]
                      : [3, 5]
                  );
                case 4:
                  return (a = e.sent()), [3, 7];
                case 5:
                  return [
                    4,
                    this.mMngr._createArticleElement(
                      r,
                      n ? null : this.mItemsMap,
                      n ? null : this.mItemPropsMap
                    ),
                  ];
                case 6:
                  (a = e.sent()), (e.label = 7);
                case 7:
                  return null == a ? [3, 9] : [4, this.addArticle(a, s, o, l)];
                case 8:
                  return e.sent(), [3, 10];
                case 9:
                  A.utils.Log.warn(
                    'Failed to load article: ' +
                      s.article.manufacturerId +
                      ':' +
                      s.article.seriesId +
                      ':' +
                      s.article.baseArticleNumber +
                      ' (' +
                      s.itemId +
                      ')'
                  ),
                    (e.label = 10);
                case 10:
                  return [2];
              }
            });
          });
        }),
        (r.prototype.updateOrMigrateArticle = function (a, s) {
          return __awaiter(this, void 0, void 0, function () {
            var t, r, n, i;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  if (
                    null == s ||
                    null == s.shouldUpdateCallback ||
                    null == a.article
                  )
                    return [2, !1];
                  (t = a.itemId), (e.label = 1);
                case 1:
                  return (
                    e.trys.push([1, 3, , 4]),
                    (r = a.article),
                    [
                      4,
                      o.ArticleElement._GetOfmlUpdateState(
                        this.mMngr.session,
                        t,
                        a.article
                      ),
                    ]
                  );
                case 2:
                  return (r.ofmlUpdateState = e.sent()), [3, 4];
                case 3:
                  return (
                    (n = e.sent()),
                    A.utils.Log.error('Failed to get ofml update state', n),
                    [3, 4]
                  );
                case 4:
                  if (
                    ('Updatable' !== a.article.ofmlUpdateState &&
                      'Migratable' !== a.article.ofmlUpdateState) ||
                    !s.shouldUpdateCallback(a)
                  )
                    return [3, 8];
                  e.label = 5;
                case 5:
                  return (
                    e.trys.push([5, 7, , 8]),
                    [
                      4,
                      o.MainArticleElement._UpdateOfmlArticle(
                        this.mMngr.session,
                        t,
                        !0
                      ),
                    ]
                  );
                case 6:
                  return e.sent(), [2, !0];
                case 7:
                  return (
                    (i = e.sent()),
                    A.utils.Log.error('Failed to update article', i),
                    [3, 8]
                  );
                case 8:
                  return [2, !1];
              }
            });
          });
        }),
        (r.prototype.getArticleQuantity = function (i) {
          return __awaiter(this, void 0, void 0, function () {
            var t, r, n;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  return null == i.article || null == i.article.quantity
                    ? [2]
                    : ((t = i.itemId),
                      (r = i.article.quantity),
                      null != i.setArticleId &&
                        null != (n = this.mItemPropsMap.get(i.setArticleId)) &&
                        null != n.article &&
                        null != n.article.quantity &&
                        ((r *= n.article.quantity),
                        this.mSetArticlesToReset.add(n.itemId)),
                      this.mMainArticleQuantity.set(t, r),
                      1 < i.article.quantity
                        ? ((i.article.quantity = 1), [4, this.resetQuantity(t)])
                        : [3, 2]);
                case 1:
                  e.sent(), (e.label = 2);
                case 2:
                  return [2];
              }
            });
          });
        }),
        (r.prototype.resetQuantity = function (e) {
          var t = new A.eaiws.basket.ItemProperties();
          return (
            (t.article = new A.eaiws.basket.ArticleProperties()),
            (t.article.quantity = 1),
            this.mMngr.session.basket.setItemProperties(e, t)
          );
        }),
        (r.prototype.addArticle = function (i, a, s, e) {
          return __awaiter(this, void 0, void 0, function () {
            var t, r, n;
            return __generator(this, function (e) {
              if (
                (null == (t = this.mMainArticleQuantity.get(a.itemId)) &&
                  (t = 1),
                null != a.composableGeometry && a.composableGeometry.enabled
                  ? (i._loadEaiwsTransform(a.composableGeometry),
                    this.mLoadedArticles.push(i))
                  : this.mNoPosArticles.push(i),
                s && this.mMngr.app.model.addElement(i),
                this.mImportNoPosArticles)
              )
                for (r = 1; r < t; ++r)
                  null != (n = i.clone()) &&
                    (this.mNoPosArticles.push(n),
                    s && this.mMngr.app.model.addElement(n));
              return this.mMngr.app.viewer.requestRenderFrame(), [2];
            });
          });
        }),
        (r.prototype.placeNoPosArticles = function () {
          var e;
          if (0 !== this.mNoPosArticles.length) {
            for (
              var t = 0, r = 0, n = 0, i = this.mNoPosArticles;
              n < i.length;
              n++
            ) {
              (d = i[n]).setTransform(BABYLON.Matrix.Identity());
              var a = d.boundingBoxVisible.getSize(),
                t = Math.max(t, a.x),
                r = Math.max(r, a.z);
            }
            (t += 0.1), (r += 0.1);
            var s,
              o = Math.ceil(Math.sqrt(this.mNoPosArticles.length)),
              l = Math.ceil(this.mNoPosArticles.length / o),
              c = t * o * -0.5,
              u = r * l * -0.5;
            0 < this.mLoadedArticles.length &&
              ((c +=
                (s = A.core.mdl.BoundingBox.FromElements(
                  this.mLoadedArticles,
                  void 0,
                  !0
                )).max.x +
                t * o * 0.5 +
                t),
              (u -= s.min.z + r * l * 0.5));
            for (var m = 0; m < l; ++m)
              for (var h = 0; h < o; ++h) {
                var p = h + o * m;
                if (p >= this.mNoPosArticles.length) break;
                var d,
                  g = -(
                    0.5 *
                      (a = (d = this.mNoPosArticles[
                        p
                      ]).boundingBoxVisible.getSize()).x +
                    d.boundingBoxVisible.min.x
                  ),
                  f = 0.5 * a.z + d.boundingBoxVisible.min.z;
                (d.node.position.x = t * h + c + g),
                  (d.node.position.z = -(r * m + u + f)),
                  d.updateTransformation();
              }
            (e = this.mLoadedArticles).push.apply(e, this.mNoPosArticles),
              this.mMngr.app.viewer.requestRenderFrame();
          }
        }),
        r);
      function r(e) {
        (this.mMngr = e),
          (this.mImportNoPosArticles = !1),
          (this.mItemsMap = new Map()),
          (this.mItemPropsMap = new Map()),
          (this.mMainArticles = new Array()),
          (this.mMainArticleQuantity = new Map()),
          (this.mSetArticlesToReset = new Set()),
          (this.mLoadedArticles = new Array()),
          (this.mNoPosArticles = new Array());
      }
      o.ArticleImportImpl = s;
    })((A = e.wcf || (e.wcf = {})).cf || (A.cf = {}));
  })((egr = egr || {})),
  (function (e) {
    var w;
    (function (g) {
      var r = function (e, t) {
        (this.article = e), (this.wholeComposite = t);
      };
      g.ArticleChangedEventData = r;
      var e =
        (Object.defineProperty(n.prototype, 'app', {
          get: function () {
            return this.mApp;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(n.prototype, 'session', {
          get: function () {
            return this.mSession;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(n.prototype, 'offlineContext', {
          get: function () {
            return this.mOfflineContext;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(n.prototype, 'maxGfjTextureSize', {
          get: function () {
            return this.mMaxGfjTextureSize;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(n.prototype, 'pricingProcedure', {
          get: function () {
            return this.mPricingProcedure;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (n.prototype.initializeSession = function (e) {
          if (!this.mSession.isValid)
            throw w.utils.newError(
              w.utils.ERR_INVALID_STATE,
              'eaiws session is not valid'
            );
          var t = ['MultiActionChoice'];
          return (
            null != e && !0 === e.oapPlanningMode && t.push('PlanningMode'),
            this.mSession.basket.oapSetClientCapabilities(t)
          );
        }),
        (n.prototype.insertArticle = function (e) {
          var t = this;
          if (null == e)
            return Promise.reject(new Error(w.utils.ERR_INVALID_ARGUMENT));
          var r = new w.eaiws.basket.InsertInfo();
          return (
            (r.articlePackageId = e.articlePackageId),
            (r.baseArticleNumber = e.baseArticleNumber),
            (r.catalogId = e.catalogId),
            (r.catalogPackageId = e.catalogPackageId),
            'OFML' === e.varCodeType
              ? (r.ofmlVariantCode = e.variantCode)
              : (r.variantCode = e.variantCode),
            this.mSession.basket
              .insertOFMLArticle(this.fatherItemId, null, r)
              .then(function (e) {
                return t.createArticleById(e);
              })
          );
        }),
        (n.prototype.insertSubArticle = function (i, a) {
          return __awaiter(this, void 0, void 0, function () {
            var t, r, n;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  if (null == a || null == i)
                    throw new Error(w.utils.ERR_INVALID_ARGUMENT);
                  return [4, i.ensureIsInstanced()];
                case 1:
                  if ((e.sent(), null == i.basketId))
                    throw w.utils.newError(
                      w.utils.ERR_INVALID_STATE,
                      'basketId is null'
                    );
                  return (
                    ((t = new w.eaiws.basket.InsertInfo()).articlePackageId =
                      a.articlePackageId),
                    (t.baseArticleNumber = a.baseArticleNumber),
                    (t.catalogId = a.catalogId),
                    (t.catalogPackageId = a.catalogPackageId),
                    ((r = new w.eaiws.basket.InsertArticleOptions()).attachmentMode =
                      'Composite'),
                    [
                      4,
                      this.mSession.basket.insertOFMLArticle(
                        i.basketId,
                        null,
                        t,
                        r
                      ),
                    ]
                  );
                case 2:
                  if (((n = e.sent()), !w.utils.string.isNullOrEmpty(n)))
                    return [3, 3];
                  throw new Error(
                    'Failed to create sub article ' + a.baseArticleNumber
                  );
                case 3:
                  return [4, i.updateGeometry()];
                case 4:
                  return e.sent(), i.notifyArticleChanged(i, !1), [2, n];
              }
            });
          });
        }),
        (n.prototype.createArticleById = function (t, e, r) {
          return this.createArticlesById([t], e, r).then(function (e) {
            return e.length < 1
              ? Promise.reject('Failed to create article ' + t)
              : Promise.resolve(e[0]);
          });
        }),
        (n.prototype.createArticlesById = function (b, I, y, v) {
          return __awaiter(this, void 0, void 0, function () {
            var t, r, n, i, a, s, o, l, c, u, m, h, p, d, g, f, A;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  return b.length <= 0
                    ? [2, []]
                    : (((t = new w.eaiws.basket.GetAllItemsOptions()).wholeComposite = !0),
                      (t.geometryIds = !0),
                      (t.setArticleIds = !0),
                      null != (r = y)
                        ? [3, 2]
                        : [4, this.mSession.basket.getAllItems(b, t)]);
                case 1:
                  if ((r = e.sent()).length < 1)
                    throw new Error('Failed to get items.');
                  e.label = 2;
                case 2:
                  for (n = new Map(), i = 0, a = r; i < a.length; i++)
                    (d = a[i]), n.set(d.itemId, d);
                  return (o = s = null) != I && I
                    ? [4, this.mSession.basket.getItemProperties(b, t)]
                    : [3, 4];
                case 3:
                  if ((s = e.sent()).length < 1)
                    throw new Error('Failed to get ItemProperties.');
                  for (o = new Map(), l = 0, c = s; l < c.length; l++)
                    (A = c[l]), o.set(A.itemId, A);
                  e.label = 4;
                case 4:
                  (u = new Array()), (m = 0), (h = b), (e.label = 5);
                case 5:
                  return m < h.length
                    ? ((p = h[m]),
                      null == (d = n.get(p))
                        ? (w.utils.Log.warn('Failed to get item for: ' + p),
                          [3, 10])
                        : 'Undefined' === d.itemType ||
                          'Folder' === d.itemType ||
                          'Text' === d.itemType ||
                          'SetArticle' === d.itemType
                        ? (w.utils.Log.warn(
                            'Item ' + p + ' is not an article.'
                          ),
                          [3, 10])
                        : ((g = void 0),
                          'UserArticle' !== d.itemType
                            ? [3, 7]
                            : [4, this._createUserArticleElement(p, n, o)]))
                    : [3, 11];
                case 6:
                  return (g = e.sent()), [3, 9];
                case 7:
                  return (
                    (f = null != v ? v.get(p) : void 0),
                    [4, this._createArticleElement(p, n, o, f)]
                  );
                case 8:
                  (g = e.sent()), (e.label = 9);
                case 9:
                  I &&
                    null != s &&
                    null != o &&
                    (null == (A = o.get(p)) &&
                      w.utils.Log.warn(
                        'Failed to get item properties for: ' + p
                      ),
                    null != A &&
                      null != A.composableGeometry &&
                      g._loadEaiwsTransform(A.composableGeometry)),
                    u.push(g),
                    (e.label = 10);
                case 10:
                  return m++, [3, 5];
                case 11:
                  return [2, u];
              }
            });
          });
        }),
        (n.prototype.setGfjLayerControl = function (e) {
          -1 !==
          this.mGfjOptions[this.mGfjOptions.length - 1].indexOf('layerControl')
            ? w.utils.string.isNullOrEmpty(e)
              ? this.mGfjOptions.pop()
              : (this.mGfjOptions[this.mGfjOptions.length - 1] =
                  'layerControl=' + e)
            : w.utils.string.isNullOrEmpty(e) ||
              this.mGfjOptions.push('layerControl=' + e);
        }),
        (n.prototype.setGfjBasketIdsEnabled = function (e) {
          for (var t = 0; t < this.mGfjOptions.length; ++t)
            if (this.mGfjOptions[t].startsWith('basketIds=')) {
              this.mGfjOptions[t] = 'basketIds=' + (e ? 'true' : 'false');
              break;
            }
        }),
        (n.prototype.setGfjMaxTextureSize = function (e) {
          this.mMaxGfjTextureSize = e;
          for (var t = 0; t < this.mGfjOptions.length; ++t)
            if (this.mGfjOptions[t].startsWith('maxImageSize=')) {
              this.mGfjOptions[t] = 'maxImageSize=' + this.mMaxGfjTextureSize;
              break;
            }
        }),
        (n.prototype.synchronizeSession = function (e) {
          var n = this,
            i = new Array(),
            a = new Array(),
            t = this.getAllMainArticles(),
            r = this.ensureArticlesAreInstanced(t);
          return (
            e &&
              (r = r.then(function () {
                return n.saveArticleTransformations(t);
              })),
            (r = r.then(function () {
              for (var e = 0, t = n.mInstancedArticles; e < t.length; e++) {
                var r = t[e];
                r.isInScene() ? a.push(r) : i.push(r);
              }
              return (n.mInstancedArticles = a), n.deleteArticlesFromSession(i);
            }))
          );
        }),
        (n.prototype.importFromSession = function (s) {
          return __awaiter(this, void 0, void 0, function () {
            var t, r, n, i, a;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  return [4, this.mSession.basket.getTopFolderId()];
                case 1:
                  return (
                    (t = e.sent()),
                    ((r = new w.eaiws.basket.GetAllItemsOptions()).subItems = !0),
                    (r.wholeComposite = !0),
                    (r.geometryIds = !0),
                    (r.setArticleIds = !0),
                    (n = [t]),
                    [4, this.mSession.basket.getAllItems(n, r)]
                  );
                case 2:
                  return (
                    (i = e.sent()),
                    [4, this.mSession.basket.getItemProperties(n, r)]
                  );
                case 3:
                  return (
                    (a = e.sent()),
                    [4, g.ArticleImport.Import(this, i, a, !0, s)]
                  );
                case 4:
                  return e.sent(), [2];
              }
            });
          });
        }),
        (n.prototype.importObx = function (l, c) {
          return __awaiter(this, void 0, void 0, function () {
            var t, r, n, i, a, s, o;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  if (null == l) throw new Error(w.utils.ERR_INVALID_ARGUMENT);
                  return (
                    (t = l instanceof ArrayBuffer ? new Blob([l]) : l),
                    [4, this.mSession.uploadFile('CutBuffer', t)]
                  );
                case 1:
                  if (((r = e.sent()), w.utils.string.isNullOrEmpty(r)))
                    throw new Error('Failed to upload obx.');
                  return [
                    4,
                    this.mSession.basket.paste(this.fatherItemId, null, r),
                  ];
                case 2:
                  return null == (n = e.sent()) || 0 === n.length
                    ? [2, []]
                    : (((i = new w.eaiws.basket.GetAllItemsOptions()).subItems = !0),
                      (i.wholeComposite = !0),
                      (i.geometryIds = !0),
                      (i.setArticleIds = !0),
                      [4, this.mSession.basket.getAllItems(n, i)]);
                case 3:
                  return (
                    (a = e.sent()),
                    [4, this.mSession.basket.getItemProperties(n, i)]
                  );
                case 4:
                  return (
                    (s = e.sent()),
                    [4, g.ArticleImport.Import(this, a, s, !1, c)]
                  );
                case 5:
                  return (o = e.sent()), [4, this.mSession.deleteFile(r)];
                case 6:
                  return e.sent(), [2, o];
              }
            });
          });
        }),
        (n.prototype.exportObx = function (a) {
          return __awaiter(this, void 0, void 0, function () {
            var t, r, n, i;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  if (null == a) throw new Error(w.utils.ERR_INVALID_ARGUMENT);
                  return [4, this.ensureArticlesAreInstanced(a)];
                case 1:
                  return e.sent(), [4, this.saveArticleTransformations(a)];
                case 2:
                  for (
                    e.sent(), t = new Array(), r = 0, n = a;
                    r < n.length;
                    r++
                  )
                    null != (i = n[r]).basketId && t.push(i.basketId);
                  return [4, this.mSession.basket.copy(t, null, null)];
                case 3:
                  return [2, e.sent()];
              }
            });
          });
        }),
        (n.prototype.saveToObk = function (e) {
          var t = this;
          return this.synchronizeSession(e).then(function () {
            return t.mSession.session.saveSession(null);
          });
        }),
        (n.prototype.getAllMainArticles = function () {
          for (
            var e = new Array(), t = 0, r = this.mApp.model.elements;
            t < r.length;
            t++
          ) {
            var n = r[t];
            n instanceof g.MainArticleElement && e.push(n),
              n instanceof w.core.mdl.GroupElement &&
                this.collectMainArticlesInGroup(n, e);
          }
          return e;
        }),
        (n.prototype.getArticleById = function (e) {
          for (var t = 0, r = this.mInstancedArticles; t < r.length; t++) {
            var n = r[t];
            if (n.isInScene()) {
              if (n.basketId === e) return n;
              var i = n.getSubArticleById(e);
              if (null != i) return i;
            }
          }
          return null;
        }),
        (n.prototype.setPricingProcedure = function (e) {
          this.mPricingProcedure != e &&
            ((this.mPricingProcedure = e), this.resetCachedArticleInfos(!0));
        }),
        (n.prototype.resetCachedArticleInfos = function (e) {
          for (var t = 0, r = this.mInstancedArticles; t < r.length; t++)
            (n = r[t]).notifyArticleChanged(n, !0);
          if (e) {
            this.app.model.selectionProperties.beginPropertyChange();
            for (var n, i = 0, a = this.mInstancedArticles; i < a.length; i++) {
              (n = a[i]).notifyChange(16);
              for (var s = 0, o = n.getSubArticles(!1); s < o.length; s++)
                o[s].notifyChange(16);
            }
            this.app.model.selectionProperties.endPropertyChange();
          }
        }),
        (n.prototype.createArticleScreenshot = function (a, s, e) {
          var o = this;
          if (null == a || null == a.node || null == s)
            return Promise.reject(new Error(w.utils.ERR_INVALID_ARGUMENT));
          null == this.mScreenshotView &&
            (this.mScreenshotView = new w.core.view.ScreenshotView(
              this.mApp.viewer
            ));
          for (
            var l = null,
              t = Math.round(s.width),
              r = Math.round(s.height),
              c = null != s.margin ? s.margin : 0.05,
              u = null != s.orthographic && s.orthographic,
              n = null != s.hideSubArticles && s.hideSubArticles,
              m = null != s.cameraAlpha ? s.cameraAlpha : -15,
              h = null != s.cameraBeta ? s.cameraBeta : 20,
              p = null != s.cameraFov ? s.cameraFov : 30,
              d = a.getNodes(!n),
              i = new Array(),
              g = 0,
              f = d;
            g < f.length;
            g++
          ) {
            var A = f[g];
            A instanceof BABYLON.AbstractMesh && i.push(A);
          }
          var b = Object.assign({}, s);
          return (
            (b.width = t),
            (b.height = r),
            (b.meshesToRender = i),
            (b.onBeforeRender = function () {
              var e;
              null != s.onBeforeRender && s.onBeforeRender(),
                (l = a.transform.clone()),
                null != a.node.parent &&
                a.node.parent instanceof BABYLON.TransformNode
                  ? ((e = a.node.parent.getWorldMatrix()),
                    w.utils.mesh.setLocalMatrix(
                      a.node,
                      BABYLON.Matrix.Invert(e)
                    ))
                  : w.utils.mesh.setLocalMatrix(
                      a.node,
                      BABYLON.Matrix.Identity()
                    );
              for (var t = 0, r = d; t < r.length; t++) {
                var n = r[t];
                n.isWorldMatrixFrozen
                  ? w.utils.mesh.updateFrozenWorldMatrix(n, !1)
                  : n.computeWorldMatrix(!0);
              }
              u
                ? (o.mScreenshotView.cameraControl.cameraMode = 6)
                : ((o.mScreenshotView.cameraControl.cameraMode = 7),
                  o.mScreenshotView.cameraControl.setFov(
                    w.utils.math.degToRad(p)
                  ));
              var i = BABYLON.Quaternion.RotationYawPitchRoll(
                w.utils.math.degToRad(-m),
                w.utils.math.degToRad(h),
                0
              );
              o.mScreenshotView.cameraControl.setDirection(
                w.utils.math.rotateVector3(w.utils.math.VECTOR3_Z, i)
              ),
                o.mScreenshotView.cameraControl.zoomToFitNodes(d, {
                  margin: c,
                });
            }),
            (b.onAfterRender = function () {
              if (null != l) {
                w.utils.mesh.setLocalMatrix(a.node, l);
                for (var e = 0, t = d; e < t.length; e++) {
                  var r = t[e];
                  r.isWorldMatrixFrozen
                    ? w.utils.mesh.updateFrozenWorldMatrix(r, !1)
                    : r.computeWorldMatrix(!0);
                }
              }
              null != s.onAfterRender && s.onAfterRender();
            }),
            this.mApp.viewer.createScreenshot(this.mScreenshotView, b, e)
          );
        }),
        (n.prototype._clear = function () {
          (this.mInstancedArticles = new Array()),
            this.mOfflineContext._clear(),
            this.mCatalogImageCache.clear();
        }),
        (n.prototype._registerInstancedArticle = function (e) {
          this.mInstancedArticles.push(e);
        }),
        (n.prototype._notifyArticleChanged = function (e, t) {
          null != e &&
            this.eventArticleChanged.hasListeners &&
            this.eventArticleChanged.trigger(new r(e, t));
        }),
        (n.prototype._importGfj = function (o, l, c) {
          return __awaiter(this, void 0, void 0, function () {
            var t, r, n, i, a, s;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  return w.utils.string.isNullOrEmpty(o)
                    ? [2, null]
                    : null == l
                    ? [3, 1]
                    : ((t = this._getCompositeItems(o, l)), [3, 3]);
                case 1:
                  return (
                    ((r = new w.eaiws.basket.GetAllItemsOptions()).wholeComposite = !0),
                    (r.geometryIds = !0),
                    (r.setArticleIds = !0),
                    [4, this.mSession.basket.getAllItems([o], r)]
                  );
                case 2:
                  (t = e.sent()), (e.label = 3);
                case 3:
                  if (!w.utils.string.isNullOrEmpty(c)) return [3, 8];
                  e.label = 4;
                case 4:
                  return (
                    e.trys.push([4, 6, , 7]),
                    [
                      4,
                      this.mSession.basket.getExportedGeometry(
                        o,
                        this.mGfjOptions
                      ),
                    ]
                  );
                case 5:
                  return (n = e.sent()), [3, 7];
                case 6:
                  return (
                    (i = e.sent()),
                    (a = o),
                    0 < t.length && (a += ' ' + t[0].label),
                    w.utils.Log.error(
                      'getExportedGeometry failed for article ' + a,
                      i
                    ),
                    [3, 7]
                  );
                case 7:
                  return [3, 9];
                case 8:
                  (n = c), (e.label = 9);
                case 9:
                  return w.utils.string.isNullOrEmpty(n)
                    ? [3, 11]
                    : [4, this.mGfjLoader.load(n, o, t)];
                case 10:
                  if (null != (s = e.sent()) && 0 < s.length)
                    return [2, { node: s[0], items: t, gfjUrl: n }];
                  e.label = 11;
                case 11:
                  return [2, { node: null, items: t }];
              }
            });
          });
        }),
        (n.prototype._getCatalogImageFromCache = function (e) {
          return w.utils.string.isNullOrEmpty(e)
            ? null
            : this.mCatalogImageCache.get(e);
        }),
        (n.prototype._addCatalogImageToCache = function (e, t) {
          null != t && this.mCatalogImageCache.add(e, t);
        }),
        (n.prototype._getCompositeItems = function (e, a) {
          var s = new Array(),
            o = function (e) {
              if (null != e.subArticleIds)
                for (var t = 0, r = e.subArticleIds; t < r.length; t++) {
                  var n = r[t],
                    i = a.get(n);
                  null != i
                    ? (s.push(i), o(i))
                    : w.utils.Log.warn('Sub article not found: ' + n);
                }
            },
            t = a.get(e);
          return (
            null != t
              ? (s.push(t), o(t))
              : w.utils.Log.warn('Main article not found: ' + e),
            s
          );
        }),
        (n.prototype._createArticleElement = function (m, h, p, d) {
          return __awaiter(this, void 0, void 0, function () {
            var t, r, n, i, a, s, o, l, c, u;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  if (w.utils.string.isNullOrEmpty(m))
                    throw new Error(w.utils.ERR_INVALID_ARGUMENT);
                  return (r = t = null), [4, this._importGfj(m, h, d)];
                case 1:
                  if (
                    (null != (i = e.sent()) &&
                      ((t = i.node), (r = i.items), (n = i.gfjUrl)),
                    (a = new g.MainArticleElement(m, this, t))._setGfjUrl(n),
                    null != r && a.fillBasketItemCache(r),
                    null != p && null != r)
                  ) {
                    for (s = new Array(), o = 0, l = r; o < l.length; o++)
                      (c = l[o]), null != (u = p.get(c.itemId)) && s.push(u);
                    a.fillItemPropertiesCache(s);
                  }
                  return null != a.node
                    ? [3, 3]
                    : [4, a._initPlaceholderGeometry(r)];
                case 2:
                  e.sent(), (e.label = 3);
                case 3:
                  return [2, a];
              }
            });
          });
        }),
        (n.prototype._createUserArticleElement = function (i, a, s) {
          return __awaiter(this, void 0, void 0, function () {
            var t, r, n;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  if (w.utils.string.isNullOrEmpty(i))
                    throw new Error(w.utils.ERR_INVALID_ARGUMENT);
                  return (
                    (t = this._getCompositeItems(i, a)),
                    (r = new g.UserArticleElement(
                      i,
                      this,
                      null
                    )).fillBasketItemCache(t),
                    null != s &&
                      null != (n = s.get(i)) &&
                      r.fillItemPropertiesCache([n]),
                    [4, r._initPlaceholderGeometry(t)]
                  );
                case 1:
                  return e.sent(), [2, r];
              }
            });
          });
        }),
        (n.prototype.ensureArticlesAreInstanced = function (e) {
          return w.utils.async
            .forEachParallel(
              e,
              function (e, t) {
                return t.ensureIsInstanced();
              },
              n.MAX_CONCURRENT_TASKS
            )
            .then(function () {});
        }),
        (n.prototype.saveArticleTransformations = function (e) {
          return w.utils.async
            .forEachParallel(
              e,
              function (e, t) {
                return t._saveTransformToEaiws();
              },
              n.MAX_CONCURRENT_TASKS
            )
            .then(function () {});
        }),
        (n.prototype.deleteArticlesFromSession = function (e) {
          var t = this;
          if (null == e || 0 === e.length) return Promise.resolve();
          var r = new Array();
          return w.utils.async
            .forEachParallel(
              e,
              function (e, t) {
                return t._prepareInstanceRecoveryData().then(function () {
                  null != t.basketId &&
                    (r.push(t.basketId), t._resetInstance());
                });
              },
              n.MAX_CONCURRENT_TASKS
            )
            .then(function () {
              return t.mSession.basket.deleteItems(r);
            });
        }),
        (n.prototype.collectMainArticlesInGroup = function (e, t) {
          if (null != e)
            for (var r = 0, n = e.childElements; r < n.length; r++) {
              var i = n[r];
              i instanceof g.MainArticleElement && t.push(i),
                i instanceof w.core.mdl.GroupElement &&
                  this.collectMainArticlesInGroup(i, t);
            }
        }),
        (n.MAX_CONCURRENT_TASKS = 10),
        n);
      function n(e, t) {
        (this.eventArticleChanged = new w.utils.ListenableEvent(this)),
          (this.eventArticleAdded = new w.utils.ListenableEvent(this)),
          (this.eventArticleRemoved = new w.utils.ListenableEvent(this)),
          (this.eventArticleInstanceRestored = new w.utils.ListenableEvent(
            this
          )),
          (this.mApp = e),
          (this.mSession = t),
          (this.mOfflineContext = new g.io.ObkReader()),
          (this.mCatalogImageCache = new w.core.mdl.ResourceCache()),
          (this.mPricingProcedure = null),
          (this.fatherItemId = null),
          (this.mInstancedArticles = new Array()),
          (this.mGfjLoader = new g.io.GfjLoader(e.model)),
          (this.mGfjOptions = new Array()),
          this.mGfjOptions.push('format=GFJ'),
          this.mGfjOptions.push('hideSubArticles=false'),
          this.mGfjOptions.push('basketIds=false'),
          this.mGfjOptions.push('geometryExtensions=.glb'),
          this.mGfjOptions.push('maxImageSize=1024'),
          (this.mMaxGfjTextureSize = 1024),
          (this.placeholderCreator = new g.DefaultPlaceholderCreator(this)),
          this.mApp.registerModule(new g.AppModule(this)),
          this.mApp.model.registerElementLoader(
            g.MainArticleElement.CLASS_ID,
            g.MainArticleElement._LoadArticleElement
          ),
          this.mApp.model.registerElementLoader(
            g.UserArticleElement.CLASS_ID,
            g.UserArticleElement._LoadArticleElement
          );
      }
      g.ArticleManager = e;
    })((w = e.wcf || (e.wcf = {})).cf || (w.cf = {}));
  })((egr = egr || {})),
  (function (e) {
    var h, t, r;
    function p() {}
    (h = e.wcf || (e.wcf = {})),
      (t = h.cf || (h.cf = {})),
      (p.GetProperties = function (e, t, r, n, i) {
        var a = null;
        if (null != n && null != n.properties) {
          a = new Array();
          for (var s = 0, o = n.properties; s < o.length; s++) {
            var l = o[s],
              c = p.CreateProperty(e, t, r, l, n, i);
            null != c && a.push(c);
          }
        }
        return a;
      }),
      (p.GetPropertyClasses = function (e) {
        var t = null;
        if (null != e && null != e.propertyClasses) {
          t = new Array();
          for (var r = 0, n = e.propertyClasses; r < n.length; r++) {
            var i = n[r];
            'OI_NONE_PROPCLASS' != i.name &&
              t.push(
                new h.core.prop.PropertyClass(
                  this.GetClassKey(i.name, e),
                  i.description
                )
              );
          }
        }
        return t;
      }),
      (p.GetPropertyUserData = function (e) {
        if (null == e || null == e.userData) return null;
        var t = e.userData;
        return null == t.eaiwsProperty || null == t.eaiwsArticleData ? null : t;
      }),
      (p.GetClassKey = function (e, t) {
        return t.manufacturerId + '_' + t.seriesId + '_' + e;
      }),
      (p.CreateProperty = function (e, t, r, n, i, a) {
        if (null == n || null == i) return null;
        var s,
          o = { eaiwsProperty: n, eaiwsArticleData: i },
          l =
            '[' +
            n.type +
            ']' +
            i.manufacturerId +
            '_' +
            i.seriesId +
            '_' +
            n.propName;
        if ('Numeric' === n.type || 'Length' === n.type) {
          var c =
            'Length' === n.type
              ? new h.core.prop.LengthProperty(r, l, n.propText)
              : new h.core.prop.NumberProperty(r, l, n.propText);
          if (
            (null != n.digits && (c.numDigits = n.digits),
            null != n.decDigits && (c.numDecDigits = n.decDigits),
            null != n.intervals && 0 < n.intervals.length)
          ) {
            (c.minValue = n.intervals[0].minValue),
              (c.maxValue = n.intervals[0].maxValue);
            for (var u = 1; u < n.intervals.length; ++u)
              n.intervals[u].minValue < c.minValue &&
                (c.minValue = n.intervals[u].minValue),
                n.intervals[u].maxValue > c.maxValue &&
                  (c.maxValue = n.intervals[u].maxValue);
          }
          s = c;
        } else {
          var m = new h.core.prop.StringProperty(r, l, n.propText);
          null != n.width && (m.maxLength = n.width), (s = m);
        }
        return (
          'OI_NONE_PROPCLASS' != n.propClass &&
            (s.class = this.GetClassKey(n.propClass, i)),
          (s.visible = n.visible),
          (s.editable = n.editable),
          (s.choiceList = n.choiceList),
          (s.allowCustomChoice = n.addValues),
          (s.undoable = !1),
          (s.userData = o),
          (s.getValue = function () {
            return p.CreatePropertyValue(n.value);
          }),
          (s.setValue = function (e) {
            return a(n, e);
          }),
          s.choiceList &&
            (s.getChoices = function () {
              return p.GetPropertyChoices(e, t, n);
            }),
          s
        );
      }),
      (p.CreatePropertyValue = function (e) {
        var t = new h.core.prop.PropertyValue(e.value, e.text);
        return (t.smallIcon = e.smallIcon), (t.largeIcon = e.largeIcon), t;
      }),
      (p.GetPropertyChoices = function (e, t, r) {
        return null != r && r.choiceList
          ? t.basket
              .getChoiceList(e, r.propClass, r.propName)
              .then(function (e) {
                for (var t = new Array(), r = 0, n = e; r < n.length; r++) {
                  var i = n[r];
                  t.push(p.CreatePropertyValue(i));
                }
                return t;
              })
          : Promise.resolve(null);
      }),
      (r = p),
      (t.ArticlePropertyHelpers = r);
  })((egr = egr || {})),
  (function (e) {
    var w;
    (function (e) {
      var t =
        ((r.prototype.dispose = function () {
          this.disposeDimension(this.mDimensionX),
            this.disposeDimension(this.mDimensionY),
            this.disposeDimension(this.mDimensionZ),
            this.mMngr.app.model.scene.onBeforeCameraRenderObservable.removeCallback(
              this.onBeforeCameraRender
            ),
            this.mArticle.eventBoundingBoxChanged.removeListener(
              this.onResetBounds
            ),
            this.mArticle.eventTransformationChanged.removeListener(
              this.onResetBounds
            ),
            this.mMngr.app.viewer.requestRenderFrame();
        }),
        (r.prototype.prepareDimension = function () {
          var e = this.mMngr.app.model.scene,
            t = {};
          return (
            (t.textTexture = new BABYLON.DynamicTexture(
              'dimension_textTexture',
              { width: 256, height: 64 },
              e,
              !1
            )),
            (t.textTexture.hasAlpha = !0),
            (t.textMaterial = new BABYLON.StandardMaterial(
              'dimension_textMaterial',
              e
            )),
            (t.textMaterial.diffuseColor = BABYLON.Color3.White()),
            (t.textMaterial.emissiveColor = BABYLON.Color3.White()),
            (t.textMaterial.disableLighting = !0),
            (t.textMaterial.diffuseTexture = t.textTexture),
            (t.textMaterial.backFaceCulling = !1),
            t.textMaterial.freeze(),
            (t.textNode = new BABYLON.TransformNode('dimension_textNode', e)),
            (t.textNode.rotationQuaternion = new BABYLON.Quaternion()),
            (t.textPlane = BABYLON.MeshBuilder.CreatePlane(
              'dimension_textPlane',
              { width: 1, height: 0.25 },
              e
            )),
            (t.textPlane.material = t.textMaterial),
            (t.textPlane.parent = t.textNode),
            (t.textPlane.position.y = 0.125),
            (t.textPlane.isPickable = !1),
            (t.textPlane.renderingGroupId = 1),
            (t.textPlane.alwaysSelectAsActiveMesh = !0),
            (t.lines = BABYLON.MeshBuilder.CreateLineSystem(
              'dimension_line',
              {
                lines: [
                  [BABYLON.Vector3.Zero(), BABYLON.Vector3.Zero()],
                  [BABYLON.Vector3.Zero(), BABYLON.Vector3.Zero()],
                  [BABYLON.Vector3.Zero(), BABYLON.Vector3.Zero()],
                ],
                updatable: !0,
                instance: null,
                useVertexAlpha: !1,
              },
              e
            )),
            (t.lines.color = BABYLON.Color3.FromHexString('#595959')),
            (t.lines.isPickable = !1),
            (t.lines.renderingGroupId = 1),
            (t.lines.alwaysSelectAsActiveMesh = !0),
            t
          );
        }),
        (r.prototype.disposeDimension = function (e) {
          e.textMaterial.dispose(),
            e.textTexture.dispose(),
            e.textNode.dispose(),
            e.lines.dispose();
        }),
        (r.prototype.updateDimensions = function (e) {
          this.updateBoundingBox();
          var t = e.projectedDistance(
              this.mBoxCenter,
              this.mBoxCenter.add(e.cameraControl.right.scale(0.1))
            ),
            r = null != t ? 1 / t : 0.1;
          (r *= this.mArticle.dimensionsScaleFactor), (r *= e.pixelScaleFactor);
          var n,
            i,
            a = e.camera.position;
          7 !== e.cameraControl.cameraMode &&
            ((n = this.mBoxPoints[5].subtract(this.mBoxPoints[0]).length()),
            (i = e.cameraControl.direction.negate()).scaleInPlace(2 * n),
            (a = this.mBoxCenter.add(i))),
            this.updateDimension(e, this.mDimensionX, a, r),
            this.updateDimension(e, this.mDimensionY, a, r),
            this.updateDimension(e, this.mDimensionZ, a, r);
        }),
        (r.prototype.updateBoundingBox = function () {
          var e, t, r, n;
          null == this.mBoxPoints &&
            ((this.mBoxPoints = this.mArticle.boundingBoxVisible.getPoints(
              this.mArticle.worldTransform
            )),
            (this.mBoxCenter = this.mArticle.boundingBoxVisible.getCenter(
              this.mArticle.worldTransform
            )),
            this.updateDimensionLength(
              this.mDimensionX,
              BABYLON.Vector3.Distance(this.mBoxPoints[0], this.mBoxPoints[3])
            ),
            this.updateDimensionLength(
              this.mDimensionY,
              BABYLON.Vector3.Distance(this.mBoxPoints[0], this.mBoxPoints[1])
            ),
            this.updateDimensionLength(
              this.mDimensionZ,
              BABYLON.Vector3.Distance(this.mBoxPoints[0], this.mBoxPoints[7])
            ),
            (e = this.buildBoxEdge(0, 3)),
            (t = this.buildBoxEdge(1, 2)),
            (r = this.buildBoxEdge(5, 6)),
            (n = this.buildBoxEdge(4, 7)),
            (this.mDimensionX.boxSides = [
              this.buildBoxSide(e, t, !1, !0),
              this.buildBoxSide(n, r, !1, !0),
              this.buildBoxSide(e, n, !0),
            ]),
            (e = this.buildBoxEdge(0, 1)),
            (t = this.buildBoxEdge(2, 3)),
            (r = this.buildBoxEdge(4, 5)),
            (n = this.buildBoxEdge(6, 7)),
            (this.mDimensionY.boxSides = [
              this.buildBoxSide(e, t),
              this.buildBoxSide(r, n),
              this.buildBoxSide(t, r),
              this.buildBoxSide(e, n),
            ]),
            (e = this.buildBoxEdge(0, 7)),
            (t = this.buildBoxEdge(3, 4)),
            (r = this.buildBoxEdge(2, 5)),
            (n = this.buildBoxEdge(1, 6)),
            (this.mDimensionZ.boxSides = [
              this.buildBoxSide(e, t, !0),
              this.buildBoxSide(t, r, !1, !0),
              this.buildBoxSide(e, n, !1, !0),
            ]));
        }),
        (r.prototype.updateDimensionLength = function (e, t) {
          var r,
            n = w.utils.number.toLocaleLengthString(
              t,
              this.mMngr.app.i18n.locale,
              this.mMngr.app.i18n.lengthUnit,
              !0
            );
          null != n &&
            ((r = e.textTexture.getSize()),
            e.textTexture.getContext().clearRect(0, 0, r.width, r.height),
            e.textTexture.drawText(
              n,
              null,
              48,
              '48px ' + this.mMngr.app.theme.fontFamily,
              '#595959',
              'transparent'
            ));
        }),
        (r.prototype.buildBoxEdge = function (e, t) {
          var r = {};
          return (
            (r.p1 = this.mBoxPoints[e]),
            (r.p2 = this.mBoxPoints[t]),
            (r.center = BABYLON.Vector3.Center(r.p1, r.p2)),
            r
          );
        }),
        (r.prototype.buildBoxSide = function (e, t, r, n) {
          void 0 === r && (r = !1), void 0 === n && (n = !1);
          var i = {};
          return (
            (i.e1 = e),
            (i.e2 = t),
            (i.ignoreE2 = n),
            (i.isBottomSide = r),
            (i.center = BABYLON.Vector3.Center(e.center, t.center)),
            (i.normal = i.center.subtract(this.mBoxCenter).normalize()),
            i
          );
        }),
        (r.prototype.getCameraDirectionToPoint = function (e, t) {
          return 7 === e.cameraControl.cameraMode
            ? t.subtract(e.camera.position).normalize()
            : e.cameraControl.direction;
        }),
        (r.prototype.updateDimension = function (e, t, r, n) {
          t.textNode.setEnabled(!0), t.lines.setEnabled(!0);
          for (var i = 0, a = null, s = 0, o = t.boxSides; s < o.length; s++) {
            var l = o[s],
              c = this.getCameraDirectionToPoint(e, l.center),
              u = BABYLON.Vector3.Dot(c, l.normal);
            l.isBottomSide && (0 < u && (u = -u), u < -0.05 && (u = -1)),
              (null == a || u < i) && ((i = u), (a = l));
          }
          var m,
            h,
            p,
            d,
            g,
            f,
            A = a,
            b = A.e1;
          A.ignoreE2 ||
            ((m = BABYLON.Vector3.Distance(A.e1.center, r)),
            (h = BABYLON.Vector3.Distance(A.e2.center, r)),
            w.utils.math.eq(m, h)
              ? ((p = w.utils.math.projectPointOnPlane(
                  A.e1.center,
                  e.cameraControl.viewPlane
                )),
                (d = w.utils.math.projectPointOnPlane(
                  this.mBoxCenter,
                  e.cameraControl.viewPlane
                )),
                (g = p.subtract(d).normalize()),
                (f = w.utils.math.signedAngleBetweenVectors3(
                  g,
                  e.cameraControl.right,
                  e.cameraControl.direction
                )),
                ((f = w.utils.math.radToDeg(f)) < -135 || 45 < f) && (b = A.e2))
              : (b = A.isBottomSide
                  ? m < h
                    ? A.e1
                    : A.e2
                  : h < m
                  ? A.e1
                  : A.e2));
          var I = b.p2.subtract(b.p1).normalize(),
            y = this.getCameraDirectionToPoint(e, b.center);
          if (0.999 < Math.abs(BABYLON.Vector3.Dot(y, I)))
            return t.textNode.setEnabled(!1), void t.lines.setEnabled(!1);
          var v = this.updateDimensionLines(t, A, b, n);
          this.updateDimensionText(e, t, A, b, v, n);
        }),
        (r.prototype.updateDimensionLines = function (e, t, r, n) {
          var i = r.center.subtract(t.center).normalize(),
            a = i.scale(2 * n),
            s = i.scale(1.5 * n),
            o = i.scale(2.5 * n),
            l = r.p1.add(a),
            c = r.p2.add(a),
            u = BABYLON.Vector3.Center(l, c);
          return (
            BABYLON.MeshBuilder.CreateLineSystem(
              'dimension_line',
              {
                lines: [
                  [l, c],
                  [r.p1.add(s), r.p1.add(o)],
                  [r.p2.add(s), r.p2.add(o)],
                ],
                updatable: !0,
                instance: e.lines,
                useVertexAlpha: !1,
              },
              this.mMngr.app.model.scene
            ),
            u
          );
        }),
        (r.prototype.updateDimensionText = function (e, t, r, n, i, a) {
          var s,
            o,
            l,
            c,
            u,
            m,
            h,
            p,
            d = e.projectPoint3(n.p1, 3),
            g = e.projectPoint3(n.p2, 3);
          null != d && null != g
            ? ((s = d.subtract(g).normalize()),
              (d.z = 0),
              e.unprojectPointToRef(d, 3, null, d),
              (g.z = 0),
              e.unprojectPointToRef(g, 3, null, g),
              (o = d.subtract(g).normalize()),
              (l = e.cameraControl.direction),
              (c = o),
              (u = BABYLON.Vector3.Cross(l, c)).normalize(),
              w.utils.math.quaternionFromAxesToRef(
                c,
                u,
                l,
                t.textNode.rotationQuaternion
              ),
              (t.textNode.position = i),
              (t.textNode.scaling.x = 7 * a),
              (t.textNode.scaling.y = 7 * a),
              (t.textNode.scaling.z = 7 * a),
              (m = w.utils.math.signedAngleBetweenVectors2(
                w.utils.math.VECTOR2_X,
                new BABYLON.Vector2(s.x, s.y)
              )),
              (m += Math.PI),
              (h = w.utils.math.radToDeg(m)),
              (t.textPlane.rotation.z = 88 < h && h < 268 ? 0 : Math.PI),
              w.utils.mesh.getLocalMatrixToRef(t.textNode, f),
              (p = BABYLON.Vector3.TransformCoordinates(
                t.textPlane.position,
                f
              )),
              BABYLON.Vector3.Distance(r.center, p) <
                BABYLON.Vector3.Distance(r.center, i) &&
                (t.textPlane.position.y = -t.textPlane.position.y))
            : t.textNode.setEnabled(!1);
        }),
        r);
      function r(e, t) {
        var r = this;
        (this.onResetBounds = function () {
          (r.mBoxPoints = null), r.mMngr.app.viewer.requestRenderFrame();
        }),
          (this.onBeforeCameraRender = function (e) {
            e instanceof w.core.view.Camera && r.updateDimensions(e.view);
          }),
          (this.mMngr = t),
          (this.mArticle = e),
          (this.mBoxPoints = null),
          (this.mBoxCenter = void 0),
          (this.mDimensionX = this.prepareDimension()),
          (this.mDimensionY = this.prepareDimension()),
          (this.mDimensionZ = this.prepareDimension()),
          this.mMngr.app.model.scene.onBeforeCameraRenderObservable.add(
            this.onBeforeCameraRender
          ),
          this.mArticle.eventBoundingBoxChanged.addListener(this.onResetBounds),
          this.mArticle.eventTransformationChanged.addListener(
            this.onResetBounds
          ),
          this.mMngr.app.viewer.requestRenderFrame();
      }
      e.BoundingBoxDimensions = t;
      var f = BABYLON.Matrix.Identity();
    })((w = e.wcf || (e.wcf = {})).cf || (w.cf = {}));
  })((egr = egr || {})),
  (function (e) {
    var t, r, n;
    function i() {}
    (t = e.wcf || (e.wcf = {})),
      (r = t.cf || (t.cf = {})),
      (i.Vector3FromEaiwsVector = function (e) {
        var t = new BABYLON.Vector3();
        return i.Vector3CopyFromEaiwsVector(t, e), t;
      }),
      (i.Vector3CopyFromEaiwsVector = function (e, t) {
        null != t ? ((e.x = t.x), (e.y = t.y), (e.z = -t.z)) : e.set(0, 0, 0);
      }),
      (i.QuaternionFromEaiwsRotation = function (e) {
        return null == e || null == e.axis || t.utils.math.eq(e.angle, 0)
          ? new BABYLON.Quaternion()
          : BABYLON.Quaternion.RotationAxis(
              new BABYLON.Vector3(e.axis.x, e.axis.y, -e.axis.z),
              -e.angle
            );
      }),
      (n = i),
      (r.Helpers = n);
  })((egr = egr || {})),
  (function (e) {
    var h, p, i, t;
    function c(e, t, r) {
      var n = i.call(this, e, t, r) || this;
      return (
        (n.eventGeometryChanged = new h.utils.ListenableEvent(n)),
        (n.mArticleDataCache = new Map()),
        (n.mArticleDataOptionsCache = new Map()),
        (n.mBasketItemCache = new Map()),
        (n.mItemPropertiesCache = new Map()),
        (n.mCalculationCache = new Map()),
        (n.mCatalogImageIdCache = new Map()),
        (n.mOapInteractorsCache = new Map()),
        (n.mOapInteractorsCacheLock = new h.utils.async.Lock()),
        (n.mSubArticleCache = null),
        (n.mHasSubArticles = !1),
        (n.mHasSelectableSubArticles = !1),
        (n.mLastKnownUpdateState = 'Unknown'),
        (n.mUpdateGeometryDepth = 0),
        (n.mPendingGeometryUpdate = !1),
        (n.mWaitGeometryUpdatePromise = null),
        (n.mWaitGeometryUpdateResolve = null),
        (n.mObxUrl = null),
        (n.mEnsureObxPromise = null),
        (n.mEnsureIsInstancedPromise = null),
        (n.mHideMainArticle = !1),
        (n.mVisibleSubArticles = null),
        (n.mSubArticleHighlights = null),
        (n.mEaiwsTransformUpToDate = !1),
        (n.mHasPlaceholderGeometry = !1),
        (n.mBoxDimensions = null),
        (n.dimensionsScaleFactor = 1),
        n.mModel.beginModification(),
        n.createOrUpdateSubArticleElements(),
        n.mModel.endModification(),
        n.isInstanced() && n.mMngr._registerInstancedArticle(n),
        n
      );
    }
    (h = e.wcf || (e.wcf = {})),
      (p = h.cf || (h.cf = {})),
      (i = p.ArticleElement),
      __extends(c, i),
      Object.defineProperty(c.prototype, 'hasPlaceholderGeometry', {
        get: function () {
          return this.mHasPlaceholderGeometry;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(c.prototype, 'hideMainArticle', {
        get: function () {
          return this.mHideMainArticle;
        },
        set: function (e) {
          e !== this.mHideMainArticle &&
            ((this.mHideMainArticle = e), this.updateMainArticleVisibility());
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(c.prototype, 'visibleSubArticles', {
        get: function () {
          return this.mVisibleSubArticles;
        },
        set: function (e) {
          e !== this.mVisibleSubArticles &&
            ((this.mVisibleSubArticles = e), this.updateSubArticleVisibility());
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(c.prototype, 'showDimensions', {
        get: function () {
          return null != this.mBoxDimensions;
        },
        set: function (e) {
          e && null == this.mBoxDimensions
            ? (this.mBoxDimensions = new p.BoundingBoxDimensions(
                this,
                this.mMngr
              ))
            : e ||
              null == this.mBoxDimensions ||
              (this.mBoxDimensions.dispose(), (this.mBoxDimensions = null));
        },
        enumerable: !1,
        configurable: !0,
      }),
      (c.prototype.canSelectSubElement = function () {
        return !0;
      }),
      (c.prototype.dispose = function () {
        (this.showDimensions = !1),
          null != this.mSubArticleHighlights &&
            this.mSubArticleHighlights.dispose(),
          null != this.mSubArticleCache &&
            this.mSubArticleCache.forEach(function (e) {
              e.dispose();
            }),
          i.prototype.dispose.call(this);
      }),
      (c.prototype.isInstanced = function () {
        return !h.utils.string.isNullOrEmpty(this.mBasketId);
      }),
      (c.prototype.ensureIsInstanced = function () {
        var t = this;
        return null != this.mEnsureIsInstancedPromise
          ? this.mEnsureIsInstancedPromise
          : this.isInstanced()
          ? Promise.resolve()
          : ((this.mEnsureIsInstancedPromise = this.ensureObx()
              .then(function () {
                var e = new h.eaiws.basket.PasteOptions();
                return (
                  (e.reuseItemIds = !0),
                  (e.returnOriginalItemIds = !0),
                  t.mMngr.session.basket.paste(
                    t.mMngr.fatherItemId,
                    null,
                    t.mObxUrl,
                    e
                  )
                );
              })
              .then(function (e) {
                t.recoverInstance(e),
                  (t.mEnsureIsInstancedPromise = null),
                  t.mMngr.eventArticleInstanceRestored.trigger(t);
              })
              .catch(function (e) {
                h.utils.Log.error('Failed to instantiate article', e),
                  (t.mEnsureIsInstancedPromise = null);
              })),
            this.mEnsureIsInstancedPromise);
      }),
      (c.prototype.getMainArticle = function () {
        return this;
      }),
      (c.prototype.getParentArticle = function () {
        return null;
      }),
      (c.prototype.hasSubArticles = function (e) {
        return e ? this.mHasSelectableSubArticles : this.mHasSubArticles;
      }),
      (c.prototype.fetchBasketItems = function () {
        var i = this;
        return this.ensureIsInstanced().then(function () {
          if (null == i.mBasketId)
            return h.utils.rejectError(
              h.utils.ERR_INVALID_STATE,
              'basketId is null'
            );
          var e = new Array();
          null == i.getCachedBasketItem() && e.push(i.mBasketId);
          for (var t = 0, r = i.getSubArticles(!1); t < r.length; t++) {
            var n = r[t];
            null == n.getCachedBasketItem() &&
              null != n.basketId &&
              e.push(n.basketId);
          }
          return 0 === e.length
            ? Promise.resolve()
            : i.getEaiwsBasketItems(e).then(function (e) {
                if (null != e)
                  for (var t = 0, r = e; t < r.length; t++) {
                    var n = r[t];
                    i.mBasketItemCache.set(n.itemId, n);
                  }
              });
        });
      }),
      (c.prototype.fillBasketItemCache = function (e) {
        for (var t = 0, r = e; t < r.length; t++) {
          var n = r[t];
          this.mBasketItemCache.set(n.itemId, n);
        }
      }),
      (c.prototype.fetchItemProperties = function () {
        var i = this;
        return this.ensureIsInstanced().then(function () {
          if (null == i.mBasketId)
            return h.utils.rejectError(
              h.utils.ERR_INVALID_STATE,
              'basketId is null'
            );
          var e = new Array();
          null == i.getCachedItemProperties() && e.push(i.mBasketId);
          for (var t = 0, r = i.getSubArticles(!1); t < r.length; t++) {
            var n = r[t];
            null == n.getCachedItemProperties() &&
              null != n.basketId &&
              e.push(n.basketId);
          }
          return 0 === e.length
            ? Promise.resolve()
            : i.getEaiwsItemProps(e).then(function (e) {
                if (null != e)
                  for (var t = 0, r = e; t < r.length; t++) {
                    var n = r[t];
                    i.mItemPropertiesCache.set(n.itemId, n);
                  }
              });
        });
      }),
      (c.prototype.fillItemPropertiesCache = function (e) {
        for (var t = 0, r = e; t < r.length; t++) {
          var n = r[t];
          null != n.itemId && this.mItemPropertiesCache.set(n.itemId, n);
        }
      }),
      (c.prototype.fetchCalculations = function () {
        var s = this;
        return this.ensureIsInstanced().then(function () {
          if (null == s.mBasketId)
            return h.utils.rejectError(
              h.utils.ERR_INVALID_STATE,
              'basketId is null'
            );
          var a = s.mMngr.pricingProcedure;
          if (null == a)
            return h.utils.rejectError(
              h.utils.ERR_INVALID_STATE,
              'no active pricing procedure'
            );
          var e = new Array();
          null == s.getCachedCalculation() && e.push(s.mBasketId);
          for (var t = 0, r = s.getSubArticles(!1); t < r.length; t++) {
            var n = r[t];
            null == n.getCachedCalculation() &&
              null != n.basketId &&
              e.push(n.basketId);
          }
          return 0 === e.length
            ? Promise.resolve()
            : s.getEaiwsItemCalculation(e).then(function (e) {
                for (var t = 0, r = e; t < r.length; t++) {
                  var n = r[t],
                    i = new h.eaiws.basket.CalculationSheetInfo(a, n.sheet);
                  s.mCalculationCache.set(n.id, i);
                }
              });
        });
      }),
      (c.prototype.fillCalculationCache = function (e) {
        var r = this;
        e.forEach(function (e, t) {
          r.mCalculationCache.set(t, e);
        });
      }),
      (c.prototype.fillConfigDataCache = function (e) {
        var r = this;
        e.forEach(function (e, t) {
          null != e.articleData && r.mArticleDataCache.set(t, e.articleData),
            null != e.articleDataOptions &&
              r.mArticleDataOptionsCache.set(t, e.articleDataOptions),
            null != e.oapInteractors &&
              r.mOapInteractorsCache.set(t, e.oapInteractors);
        });
      }),
      (c.prototype.getCompositeCalculation = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.ensureIsInstanced()];
              case 1:
                if ((e.sent(), null == this.mBasketId))
                  throw h.utils.newError(
                    h.utils.ERR_INVALID_STATE,
                    'basketId is null'
                  );
                if (null == (t = this.mMngr.pricingProcedure))
                  throw h.utils.newError(
                    h.utils.ERR_INVALID_STATE,
                    'no active pricing procedure'
                  );
                return void 0 === this.mCompositeCalculation
                  ? [3, 2]
                  : [2, this.mCompositeCalculation];
              case 2:
                return [4, this.getEaiwsCompositeCalculation(this.mBasketId)];
              case 3:
                return null != (r = e.sent()).quantity
                  ? [3, 5]
                  : [4, this.getCalculation()];
              case 4:
                (n = e.sent()), (r.quantity = n.sheet.quantity), (e.label = 5);
              case 5:
                return (
                  (this.mCompositeCalculation = new h.eaiws.basket.CalculationSheetInfo(
                    t,
                    r
                  )),
                  [2, this.mCompositeCalculation]
                );
            }
          });
        });
      }),
      (c.prototype.notifyArticleChanged = function (e, t) {
        this._clearCachedArticleInfo(e, t),
          this.mMngr._notifyArticleChanged(t ? this : e, t);
      }),
      (c.prototype.updateGeometry = function (l) {
        return (
          void 0 === l && (l = !0),
          __awaiter(this, void 0, void 0, function () {
            var t, r, n, i, a, s, o;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  if (
                    ((this.mPendingGeometryUpdate = !0),
                    0 < this.mUpdateGeometryDepth)
                  )
                    return [2];
                  e.label = 1;
                case 1:
                  return (
                    e.trys.push([1, , 7, 8]),
                    this.mModel.beginModification(),
                    this.beginChange(),
                    [4, this.ensureIsInstanced()]
                  );
                case 2:
                  return (
                    e.sent(),
                    null == this.mBasketId
                      ? [
                          2,
                          h.utils.rejectError(
                            h.utils.ERR_INVALID_STATE,
                            'basketId is null'
                          ),
                        ]
                      : ((r = t = null),
                        [4, this.mMngr._importGfj(this.mBasketId, null)])
                  );
                case 3:
                  if (
                    (null != (n = e.sent()) &&
                      ((t = n.node),
                      (r = n.items),
                      this._setGfjUrl(n.gfjUrl),
                      this.fillBasketItemCache(n.items)),
                    null != t)
                  )
                    return [3, 5];
                  if (((i = new Array()), null != r))
                    for (a = 0, s = r; a < s.length; a++)
                      (o = s[a]).itemId != this.basketId && i.push(o.itemId);
                  return (
                    (this.mHasPlaceholderGeometry = !0),
                    [4, this.mMngr.placeholderCreator.create(this, i)]
                  );
                case 4:
                  return (t = e.sent()), [3, 6];
                case 5:
                  (this.mHasPlaceholderGeometry = !1), (e.label = 6);
                case 6:
                  return (
                    this.replaceNode(t, !0, !0),
                    this.createOrUpdateSubArticleElements(),
                    l && this.mMngr.app.model.validateSelection(),
                    this.mHideMainArticle && this.updateMainArticleVisibility(),
                    null != this.mVisibleSubArticles &&
                      this.updateSubArticleVisibility(),
                    this.eventGeometryChanged.trigger(),
                    [3, 8]
                  );
                case 7:
                  return (
                    (this.mPendingGeometryUpdate = !1),
                    this.endChange(),
                    this.mModel.endModification(),
                    null != this.mWaitGeometryUpdatePromise &&
                      (this.mWaitGeometryUpdateResolve(),
                      (this.mWaitGeometryUpdateResolve = null),
                      (this.mWaitGeometryUpdatePromise = null)),
                    [7]
                  );
                case 8:
                  return [2];
              }
            });
          })
        );
      }),
      (c.prototype.beginUpdateGeometry = function () {
        this.mUpdateGeometryDepth++;
      }),
      (c.prototype.endUpdateGeometry = function () {
        return (
          this.mUpdateGeometryDepth--,
          this.mUpdateGeometryDepth <= 0 &&
          ((this.mUpdateGeometryDepth = 0), this.mPendingGeometryUpdate)
            ? this.updateGeometry(!0)
            : Promise.resolve()
        );
      }),
      (c.prototype.waitUntilGeometryUpdated = function () {
        var t = this;
        return this.mPendingGeometryUpdate
          ? (null == this.mWaitGeometryUpdatePromise &&
              (this.mWaitGeometryUpdatePromise = new Promise(function (e) {
                t.mWaitGeometryUpdateResolve = e;
              })),
            this.mWaitGeometryUpdatePromise)
          : Promise.resolve();
      }),
      (c.prototype.clone = function (e) {
        var t = new c(
          null,
          this.mMngr,
          h.core.mdl.SceneElement.cloneNode(this.mNode, e)
        );
        return t.copyDataFrom(this), t;
      }),
      (c.prototype.serialize = function (o) {
        var l = this;
        if (null == this.mNode) return null;
        var e = {};
        return (
          (e.classId = c.CLASS_ID),
          this.mHasPlaceholderGeometry && (e.placeholderGeometry = !0),
          (e.node = h.core.mdl.io.serializeNode(
            this.mMngr.app.model,
            o,
            this.mNode,
            !0,
            function (e, t) {
              var r,
                n,
                i,
                a,
                s = h.core.mdl.NodeUserData.GetData(
                  e,
                  p.ArticleElement.NODEDATA_BASKETID
                );
              h.utils.string.isNullOrEmpty(s) ||
                (((r = t).basketId = s),
                void 0 !== (n = l._getCatalogImageId(s)) &&
                  ((i = p.AppModule._GetCatalogImageIndex(n, o)),
                  (r.catalogImage = null != i ? i : null)),
                null ==
                  (a = h.core.mdl.NodeUserData.GetData(
                    e,
                    p.ArticleElement.NODEDATA_SELECTABLE
                  )) ||
                  a ||
                  (r.selectable = !1));
            }
          )),
          e
        );
      }),
      (c.prototype.getKnownOfmlUpdateState = function () {
        var e = this.getCachedItemProperties();
        return (
          null != e &&
            null != e.article &&
            null != e.article.ofmlUpdateState &&
            'Unknown' != e.article.ofmlUpdateState &&
            (this.mLastKnownUpdateState = e.article.ofmlUpdateState),
          this.mLastKnownUpdateState
        );
      }),
      (c.prototype.getOfmlUpdateState = function () {
        var t = this,
          r = this.getCachedItemProperties();
        return this.ensureIsInstanced()
          .then(function () {
            return null == t.mBasketId
              ? h.utils.rejectError(
                  h.utils.ERR_INVALID_STATE,
                  'basketId is null'
                )
              : p.ArticleElement._GetOfmlUpdateState(
                  t.mMngr.session,
                  t.mBasketId,
                  null != r ? r.article : null
                );
          })
          .then(function (e) {
            return (
              null != r && null != r.article && (r.article.ofmlUpdateState = e),
              (t.mLastKnownUpdateState = e)
            );
          });
      }),
      (c.prototype.updateOfmlArticle = function (a, s) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.ensureIsInstanced()];
              case 1:
                if ((e.sent(), null == this.mBasketId))
                  throw h.utils.newError(
                    h.utils.ERR_INVALID_STATE,
                    'basketId is null'
                  );
                return [
                  4,
                  c._UpdateOfmlArticle(this.mMngr.session, this.mBasketId, a),
                ];
              case 2:
                if (!(t = e.sent())) return [3, 5];
                for (
                  this._clearCachedArticleInfo(this, !0),
                    this.notifyChange(16),
                    r = this.getSubArticles(!1),
                    n = 0,
                    i = r;
                  n < i.length;
                  n++
                )
                  i[n].notifyChange(16);
                return s ? [4, this.updateGeometry()] : [3, 4];
              case 3:
                e.sent(), (e.label = 4);
              case 4:
                this.mMngr._notifyArticleChanged(this, !0), (e.label = 5);
              case 5:
                return [2, t];
            }
          });
        });
      }),
      (c.prototype.highlightSubArticles = function (e, t) {
        var r = this;
        return (
          null == this.mSubArticleHighlights &&
          ((this.mSubArticleHighlights = p.SubArticleHighlights.Create(
            this,
            this.mMngr,
            e,
            function () {
              (r.mSubArticleHighlights = null) != t && t();
            }
          )),
          null != this.mSubArticleHighlights)
        );
      }),
      (c._InitClass = function () {
        (c.DefaultGetArticleDataOptions.noProperties = !1),
          (c.DefaultGetArticleDataOptions.fetchCatalogIcon = !1),
          (c.DefaultGetArticleDataOptions.fetchCatalogImage = !0);
      }),
      (c.prototype._initPlaceholderGeometry = function (m) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l, c, u;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (
                  (e.trys.push([0, , 2, 3]),
                  this.mModel.beginModification(),
                  (t = new Array()),
                  null != m)
                )
                  for (r = 0, n = m; r < n.length; r++)
                    (i = n[r]).itemId != this.basketId && t.push(i.itemId);
                else if (null != this.mNode)
                  for (
                    a = this.mNode.getChildTransformNodes(!1), s = 0, o = a;
                    s < o.length;
                    s++
                  )
                    (l = o[s]),
                      null !=
                        (c = h.core.mdl.NodeUserData.GetData(
                          l,
                          p.ArticleElement.NODEDATA_BASKETID
                        )) && t.push(c);
                return [4, this.mMngr.placeholderCreator.create(this, t)];
              case 1:
                return (
                  (u = e.sent()),
                  null == this.mNode
                    ? this.setNode(u)
                    : this.replaceNode(u, !0, !0),
                  (this.mHasPlaceholderGeometry = !0),
                  this.createOrUpdateSubArticleElements(),
                  this.mModel.endModification(),
                  [3, 3]
                );
              case 2:
                return this.mModel.endModification(), [7];
              case 3:
                return [2];
            }
          });
        });
      }),
      (c.prototype._clearCachedArticleInfo = function (e, t) {
        t
          ? (this.mArticleDataCache.clear(),
            this.mArticleDataOptionsCache.clear(),
            this.mBasketItemCache.clear(),
            this.mItemPropertiesCache.clear(),
            this.mCalculationCache.clear(),
            this.mCatalogImageIdCache.clear(),
            this.mOapInteractorsCache.clear())
          : null != e &&
            null != e.basketId &&
            (this.mArticleDataCache.delete(e.basketId),
            this.mArticleDataOptionsCache.delete(e.basketId),
            this.mBasketItemCache.delete(e.basketId),
            this.mItemPropertiesCache.delete(e.basketId),
            this.mCalculationCache.delete(e.basketId),
            this.mCatalogImageIdCache.delete(e.basketId),
            this.mOapInteractorsCache.delete(e.basketId)),
          (this.mCompositeCalculation = void 0),
          (this.mObxUrl = null) != this.mSubArticleHighlights &&
            this.mSubArticleHighlights.dispose();
      }),
      (c.prototype._getArticleData = function (a, s) {
        var o = this;
        if (null == a)
          return Promise.reject(new Error(h.utils.ERR_INVALID_ARGUMENT));
        var e = this._getCachedArticleData(a, s);
        return null != e
          ? Promise.resolve(e)
          : (this.mMngr.session.isValid
              ? this.mMngr.session.basket.getArticleData(a, s)
              : this.mMngr.offlineContext.isAvailable
              ? Promise.resolve(this.mMngr.offlineContext.getArticleData(a))
              : h.utils.rejectError(
                  h.utils.ERR_INVALID_STATE,
                  'offlineContext not available'
                )
            ).then(function (e) {
              var t = s;
              null == t && (t = c.DefaultGetArticleDataOptions);
              var r,
                n = o.mArticleDataOptionsCache.get(a),
                i = o.mArticleDataCache.get(a);
              return (
                null == n || null == i
                  ? ((r = new h.eaiws.basket.GetArticleDataOptions()),
                    Object.assign(r, t),
                    o.mArticleDataCache.set(a, e),
                    o.mArticleDataOptionsCache.set(a, r))
                  : null != e &&
                    (t.noProperties ||
                      ((n.noProperties = !1),
                      (i.properties = e.properties),
                      (i.propertyClasses = e.propertyClasses)),
                    t.fetchCatalogIcon &&
                      ((n.fetchCatalogIcon = !0),
                      (i.catalogIcon = e.catalogIcon)),
                    t.fetchCatalogImage &&
                      ((n.fetchCatalogImage = !0),
                      (i.catalogImage = e.catalogImage))),
                e
              );
            });
      }),
      (c.prototype._getCachedArticleData = function (e, t) {
        var r = t;
        null == r && (r = c.DefaultGetArticleDataOptions);
        var n = this.mArticleDataOptionsCache.get(e);
        if (
          null != n &&
          (!n.noProperties || r.noProperties) &&
          (n.fetchCatalogIcon || !r.fetchCatalogIcon) &&
          (n.fetchCatalogImage || !r.fetchCatalogImage)
        )
          return this.mArticleDataCache.get(e);
      }),
      (c.prototype._getBasketItem = function (t) {
        var r = this;
        if (null == t)
          return Promise.reject(new Error(h.utils.ERR_INVALID_ARGUMENT));
        var e = this.mBasketItemCache.get(t);
        return null != e
          ? Promise.resolve(e)
          : this.getEaiwsBasketItems([t]).then(function (e) {
              return 0 !== e.length
                ? (r.mBasketItemCache.set(t, e[0]), Promise.resolve(e[0]))
                : Promise.reject(new Error('Failed to get item ' + t));
            });
      }),
      (c.prototype._getCachedBasketItem = function (e) {
        return this.mBasketItemCache.get(e);
      }),
      (c.prototype._getItemProperties = function (t) {
        var r = this;
        if (null == t)
          return Promise.reject(new Error(h.utils.ERR_INVALID_ARGUMENT));
        var e = this.mItemPropertiesCache.get(t);
        return null != e
          ? Promise.resolve(e)
          : this.getEaiwsItemProps([t]).then(function (e) {
              return 0 !== e.length
                ? (r.mItemPropertiesCache.set(t, e[0]), Promise.resolve(e[0]))
                : Promise.reject(
                    new Error('Failed to get item properties for item ' + t)
                  );
            });
      }),
      (c.prototype._getCachedItemProperties = function (e) {
        return this.mItemPropertiesCache.get(e);
      }),
      (c.prototype._getCalculation = function (r) {
        var n = this;
        if (null == r)
          return Promise.reject(new Error(h.utils.ERR_INVALID_ARGUMENT));
        var e = this.mCalculationCache.get(r);
        if (null != e) return Promise.resolve(e);
        var i = this.mMngr.pricingProcedure;
        return null == i
          ? h.utils.rejectError(
              h.utils.ERR_INVALID_STATE,
              'no active pricing procedure'
            )
          : this.getEaiwsItemCalculation([r]).then(function (e) {
              if (0 === e.length)
                return Promise.reject(
                  new Error('Failed to get calculation for item ' + r)
                );
              var t = new h.eaiws.basket.CalculationSheetInfo(i, e[0].sheet);
              return n.mCalculationCache.set(r, t), Promise.resolve(t);
            });
      }),
      (c.prototype._getCachedCalculation = function (e) {
        return this.mCalculationCache.get(e);
      }),
      (c.prototype._getCatalogImage = function (o) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return null == o
                  ? [2, null]
                  : void 0 !== (t = this.mCatalogImageIdCache.get(o))
                  ? [
                      2,
                      Promise.resolve(this.mMngr._getCatalogImageFromCache(t)),
                    ]
                  : (((r = new h.eaiws.basket.GetArticleDataOptions()).noProperties = !0),
                    (r.fetchCatalogIcon = !0),
                    (r.fetchCatalogImage = !0),
                    [4, this._getArticleData(o, r)]);
              case 1:
                return (
                  (n = e.sent()),
                  (i = void 0),
                  (i = n.catalogImage),
                  h.utils.string.isNullOrEmpty(i) && (i = n.catalogIcon),
                  h.utils.string.isNullOrEmpty(i)
                    ? (this.mCatalogImageIdCache.set(o, null), [2, null])
                    : [3, 2]
                );
              case 2:
                return [
                  4,
                  h.utils.async.ajax('GET', i, null, {
                    responseType: 'arraybuffer',
                  }),
                ];
              case 3:
                return (
                  (a = e.sent()), [4, h.utils.arraybuffer.hash(a, 'SHA-256')]
                );
              case 4:
                return (
                  (t = (t = e.sent()).substr(0, 32)),
                  ((s = {}).data = a),
                  (s.name = h.utils.string.getFileName(i)),
                  this.mMngr._addCatalogImageToCache(t, s),
                  this.mCatalogImageIdCache.set(o, t),
                  [2, s]
                );
            }
          });
        });
      }),
      (c.prototype._getCatalogImageId = function (e) {
        if (null == e) return null;
        var t = this.mCatalogImageIdCache.get(e);
        return null != t ? t : null;
      }),
      (c.prototype._getCachedConfigData = function (e) {
        var t = {};
        return (
          (t.articleData = this.mArticleDataCache.get(e)),
          (t.articleDataOptions = this.mArticleDataOptionsCache.get(e)),
          (t.oapInteractors = this.mOapInteractorsCache.get(e)),
          (t.gfjUrl = this.basketId === e ? this.mGfjUrl : void 0),
          t
        );
      }),
      (c.prototype._resetInstance = function () {
        this.mBasketId = null;
      }),
      (c.prototype._prepareInstanceRecoveryData = function () {
        return this.ensureObx();
      }),
      (c.prototype._saveTransformToEaiws = function () {
        if (this.mEaiwsTransformUpToDate) return Promise.resolve();
        if (!this.isInstanced() || null == this.mNode || null == this.mBasketId)
          return h.utils.rejectError(h.utils.ERR_INVALID_STATE);
        this.mEaiwsTransformUpToDate = !0;
        var e = new h.eaiws.basket.ItemProperties();
        e.composableGeometry = new h.eaiws.basket.ComposableGeometryProperties();
        var t = e.composableGeometry;
        (t.enabled = !0),
          (t.position = new h.eaiws.basket.Vector3()),
          (t.position.x = this.mNode.position.x),
          (t.position.y = this.mNode.position.y),
          (t.position.z = -this.mNode.position.z);
        var r = h.utils.math.quaternionToAxisAngle(
          h.utils.mesh.getRotationQuaternion(this.mNode)
        );
        return (
          (t.rotation = new h.eaiws.basket.Rotation()),
          (t.rotation.axis = new h.eaiws.basket.Vector3()),
          (t.rotation.axis.x = r.x),
          (t.rotation.axis.y = r.y),
          (t.rotation.axis.z = -r.z),
          (t.rotation.angle = -r.w),
          this.supportScaleEaiwsTransform() &&
            ((t.scale = new h.eaiws.basket.Vector3()),
            (t.scale.x = this.mNode.scaling.x),
            (t.scale.y = this.mNode.scaling.y),
            (t.scale.z = this.mNode.scaling.z)),
          this.mMngr.session.basket
            .setItemProperties(this.mBasketId, e)
            .catch(function (e) {
              h.utils.Log.error('Failed to save transformation', e);
            })
        );
      }),
      (c.prototype._loadEaiwsTransform = function (e) {
        null != e &&
          e.enabled &&
          (p.Helpers.Vector3CopyFromEaiwsVector(
            this.mNode.position,
            e.position
          ),
          (this.mNode.rotationQuaternion = p.Helpers.QuaternionFromEaiwsRotation(
            e.rotation
          )),
          this.supportScaleEaiwsTransform() && null != e.scale
            ? ((this.mNode.scaling.x = e.scale.x),
              (this.mNode.scaling.y = e.scale.y),
              (this.mNode.scaling.z = e.scale.z))
            : this.mNode.scaling.set(1, 1, 1),
          (this.mEaiwsTransformUpToDate = !0),
          this.updateTransformation());
      }),
      (c.prototype._getOapInteractors = function (i) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return null != i && this.mMngr.session.isValid
                  ? [4, i.ensureIsInstanced()]
                  : [2, null];
              case 1:
                if ((e.sent(), null == i.basketId))
                  throw h.utils.newError(
                    h.utils.ERR_INVALID_STATE,
                    'basketId is null'
                  );
                return [4, this.mOapInteractorsCacheLock.acquireLock()];
              case 2:
                (t = e.sent()), (e.label = 3);
              case 3:
                return (
                  e.trys.push([3, , 5, 6]),
                  null != (r = this.mOapInteractorsCache.get(i.basketId))
                    ? [2, r]
                    : ((n = 1.5 < window.devicePixelRatio ? 2 : 1),
                      [
                        4,
                        this.mMngr.session.basket.oapGetInteractors(
                          i.basketId,
                          void 0,
                          n
                        ),
                      ])
                );
              case 4:
                return (
                  (r = e.sent()),
                  this.mOapInteractorsCache.set(i.basketId, r),
                  [2, r]
                );
              case 5:
                return t.unlock(), [7];
              case 6:
                return [2];
            }
          });
        });
      }),
      (c._LoadArticleElement = function (e, t, r) {
        if (null == r) return null;
        var n = null != r.placeholderGeometry && r.placeholderGeometry,
          i = e.getModule(p.AppModule.MODULE_KEY),
          a = c.LoadArticleElementNode(e, t, r);
        if (null == a || null == a.basketId || null == i) return null;
        var s = new c(a.basketId, i.articleManager, a.node);
        return (
          s.setCatalogImageIdCache(a.catalogImageIds),
          null == s.mNode && (n = !0),
          a.geometryIncomplete && i.articleManager.session.isValid
            ? t.registerPendingTask(function () {
                return s.updateGeometry(!1);
              })
            : n &&
              t.registerPendingTask(function () {
                return s._initPlaceholderGeometry(null);
              }),
          s
        );
      }),
      (c._UpdateOfmlArticle = function (e, a, t) {
        var r = new h.eaiws.basket.UpdateBasketArticlesOptions();
        return (
          (r.migrate = t),
          (r.update = !0),
          (r.wholeComposite = !0),
          e.basket.updateBasketArticles([a], null, r).then(function (e) {
            var t = !1;
            if (null != e)
              for (var r = 0, n = e; r < n.length; r++) {
                var i = n[r];
                if (i.itemId === a && 'UpToDate' === i.updateState) {
                  t = !0;
                  break;
                }
              }
            return t;
          })
        );
      }),
      (c.prototype._setGfjUrl = function (e) {
        this.mGfjUrl = e;
      }),
      (c.prototype.handleImmediateChanges = function () {
        i.prototype.handleImmediateChanges.call(this),
          this.wasFlagChanged(8) && (this.mEaiwsTransformUpToDate = !1),
          this.wasFlagChanged(2) && (this.showDimensions = !1);
      }),
      (c.prototype.copyDataFrom = function (e) {
        var t,
          r = this;
        i.prototype.copyDataFrom.call(this, e),
          null != e &&
            e instanceof c &&
            ((t = e),
            (this.mCatalogImageIdCache = new Map(t.mCatalogImageIdCache)),
            (this.mHasPlaceholderGeometry = t.mHasPlaceholderGeometry),
            null != this.mSubArticleCache &&
              this.mSubArticleCache.forEach(function (e) {
                e._setMainArticle(r);
              }),
            (this.mEnsureObxPromise = t.ensureObx().then(function () {
              (r.mObxUrl = t.mObxUrl), (r.mEnsureObxPromise = null);
            })));
      }),
      (c.prototype.setCatalogImageIdCache = function (e) {
        null != e && (this.mCatalogImageIdCache = e);
      }),
      (c.LoadArticleElementNode = function (a, s, e) {
        if (null == e) return null;
        var o = {
          node: null,
          basketId: null,
          geometryIncomplete: !1,
          catalogImageIds: new Map(),
        };
        return (
          (o.node = h.core.mdl.io.deserializeNode(
            a.model,
            s,
            e.node,
            null,
            function (e, t) {
              var r,
                n,
                i = e;
              null != i.basketId &&
                (h.core.mdl.NodeUserData.SetData(
                  t,
                  p.ArticleElement.NODEDATA_BASKETID,
                  i.basketId
                ),
                void 0 !== i.catalogImage &&
                  ((r = p.AppModule._GetCatalogImageByIndex(i.catalogImage, s)),
                  o.catalogImageIds.set(i.basketId, r)),
                (n = !0),
                null != i.selectable && (n = i.selectable),
                h.core.mdl.NodeUserData.SetData(
                  t,
                  p.ArticleElement.NODEDATA_SELECTABLE,
                  n
                )),
                t instanceof BABYLON.Mesh &&
                  (null == i.geometry ||
                    (null != t.geometry &&
                      !a.model.geometries.isFallbackGeometry(t.geometry)) ||
                    (o.geometryIncomplete = !0),
                  null != i.material &&
                    (null == t.material ||
                      (t.material instanceof h.core.mdl.PbrMaterial &&
                        t.material.hasFallbackTextures())) &&
                    (o.geometryIncomplete = !0));
            }
          )),
          (o.basketId = h.core.mdl.NodeUserData.GetData(
            o.node,
            p.ArticleElement.NODEDATA_BASKETID
          )),
          null == o.node || null == o.basketId ? null : o
        );
      }),
      (c.prototype.supportScaleEaiwsTransform = function () {
        return !1;
      }),
      (c.prototype.recoverInstance = function (e) {
        var n = this;
        if (null == this.mNode || null == e || e.length % 2 != 0) return !1;
        for (var t = new Map(), r = 0; r < e.length; r += 2)
          t.set(e[r + 1], e[r]);
        t.forEach(function (e, t) {
          var r = n.mCatalogImageIdCache.get(t);
          void 0 !== r && n.mCatalogImageIdCache.set(e, r);
        }),
          null == this.mSubArticleCache
            ? (this.mSubArticleCache = new Map())
            : this.mSubArticleCache.clear();
        for (var i = 0, a = this.getSubArticles(!1); i < a.length; i++) {
          var s = a[i],
            o = t.get(s._getRecoveryBasketId());
          null != o && (s._setBasketId(o), this.mSubArticleCache.set(o, s));
        }
        var l = t.get(this.mRecoveryBasketId);
        return (
          null != l &&
          ((this.mObxUrl = null),
          this._setBasketId(l),
          this.mMngr._registerInstancedArticle(this),
          !0)
        );
      }),
      (c.prototype.createOrUpdateSubArticleElements = function () {
        (this.mHasSubArticles = !1), (this.mHasSelectableSubArticles = !1);
        var r = new Map();
        this.createSubArticleElements(this.mNode, r),
          null != this.mSubArticleCache &&
            this.mSubArticleCache.forEach(function (e, t) {
              r.has(t) || (e.notifyChange(2), e.dispose());
            }),
          (this.mSubArticleCache = r);
      }),
      (c.prototype.createSubArticleElements = function (e, t) {
        if (null != e)
          for (var r = 0, n = e.getChildTransformNodes(!0); r < n.length; r++) {
            var i,
              a = n[r],
              s = h.core.mdl.NodeUserData.GetData(
                a,
                p.ArticleElement.NODEDATA_BASKETID
              );
            null != s &&
              ((i = null) != this.mSubArticleCache &&
                (i = this.mSubArticleCache.get(s)),
              null != i
                ? i.replaceNode(a, !1, !1, !1)
                : (i = new p.SubArticleElement(
                    this,
                    s,
                    this.mMngr,
                    a
                  )).notifyChange(1),
              (this.mHasSubArticles = !0),
              (this.mHasSelectableSubArticles =
                this.mHasSelectableSubArticles || i.canSelect()),
              t.set(s, i)),
              this.createSubArticleElements(a, t);
          }
      }),
      (c.prototype.ensureObx = function () {
        var t = this;
        return null != this.mEnsureObxPromise
          ? this.mEnsureObxPromise
          : h.utils.string.isNullOrEmpty(this.mObxUrl)
          ? null == this.mBasketId
            ? h.utils.rejectError(h.utils.ERR_INVALID_STATE, 'basketId is null')
            : ((this.mEnsureObxPromise = this.mMngr.session.basket
                .copy([this.mBasketId])
                .then(function (e) {
                  return (
                    (t.mObxUrl = e),
                    (t.mEnsureObxPromise = null),
                    Promise.resolve()
                  );
                })
                .catch(function (e) {
                  h.utils.Log.error('Failed to get obx', e),
                    (t.mEnsureObxPromise = null);
                })),
              this.mEnsureObxPromise)
          : Promise.resolve();
      }),
      (c.prototype.getEaiwsBasketItems = function (e) {
        var t,
          r = this.mMngr.session.isValid
            ? (((t = new h.eaiws.basket.GetAllItemsOptions()).geometryIds = !0),
              (t.setArticleIds = !0),
              this.mMngr.session.basket.getAllItems(e, t))
            : this.mMngr.offlineContext.isAvailable
            ? Promise.resolve(this.mMngr.offlineContext.getItems(e))
            : h.utils.rejectError(
                h.utils.ERR_INVALID_STATE,
                'offlineContext not available'
              );
        return r;
      }),
      (c.prototype.getEaiwsItemProps = function (e) {
        var t = this.mMngr.session.isValid
          ? this.mMngr.session.basket.getItemProperties(e)
          : this.mMngr.offlineContext.isAvailable
          ? Promise.resolve(this.mMngr.offlineContext.getItemProperties(e))
          : h.utils.rejectError(
              h.utils.ERR_INVALID_STATE,
              'offlineContext not available'
            );
        return t;
      }),
      (c.prototype.getEaiwsItemCalculation = function (e) {
        var t = this.mMngr.pricingProcedure;
        return null == t
          ? h.utils.rejectError(
              h.utils.ERR_INVALID_STATE,
              'no active pricing procedure'
            )
          : this.mMngr.session.isValid
          ? this.mMngr.session.basket.getPriceCalculationSheets(e, t.name)
          : h.utils.rejectError(h.utils.ERR_INVALID_STATE, 'session not valid');
      }),
      (c.prototype.getEaiwsCompositeCalculation = function (e) {
        var t = this.mMngr.pricingProcedure;
        if (null == t)
          return h.utils.rejectError(
            h.utils.ERR_INVALID_STATE,
            'no active pricing procedure'
          );
        var r = new h.eaiws.basket.GetPriceCalculationSheetOptions();
        return (
          (r.wholeComposite = !0),
          this.mMngr.session.isValid
            ? this.mMngr.session.basket.getPriceCalculationSheet([e], t.name, r)
            : h.utils.rejectError(
                h.utils.ERR_INVALID_STATE,
                'session not valid'
              )
        );
      }),
      (c.prototype.updateMainArticleVisibility = function () {
        for (var e = 0, t = this.getNodes(!1); e < t.length; e++) {
          var r = t[e];
          r instanceof BABYLON.AbstractMesh &&
            (r.isVisible = !this.mHideMainArticle);
        }
      }),
      (c.prototype.updateSubArticleVisibility = function () {
        for (var e = 0, t = this.getSubArticles(!1); e < t.length; e++)
          for (
            var r = t[e],
              n =
                null == this.mVisibleSubArticles ||
                h.utils.array.contains(this.mVisibleSubArticles, r.basketId),
              i = 0,
              a = r.getNodes(!1);
            i < a.length;
            i++
          ) {
            var s = a[i];
            s instanceof BABYLON.AbstractMesh && (s.isVisible = n);
          }
      }),
      (c.CLASS_ID = 'egr.wcf.cf:Article'),
      (c.DefaultGetArticleDataOptions = new h.eaiws.basket.GetArticleDataOptions()),
      (t = c),
      (p.MainArticleElement = t)._InitClass();
  })((egr = egr || {})),
  (function (e) {
    var h;
    (function (m) {
      var e =
        ((t.prototype.create = function (s, o) {
          return __awaiter(this, void 0, void 0, function () {
            var t, r, n, i, a;
            return __generator(this, function (e) {
              for (
                t = new BABYLON.TransformNode(
                  'article_dummyPlaceholder',
                  this.mApp.scene
                ),
                  h.core.mdl.NodeUserData.SetData(
                    t,
                    m.ArticleElement.NODEDATA_BASKETID,
                    s.basketId
                  ),
                  t.freezeWorldMatrix(),
                  r = 0,
                  n = o;
                r < n.length;
                r++
              )
                (i = n[r]),
                  (a = new BABYLON.TransformNode(
                    'subarticle_dummyPlaceholder',
                    this.mApp.scene
                  )),
                  h.core.mdl.NodeUserData.SetData(
                    a,
                    m.ArticleElement.NODEDATA_BASKETID,
                    i
                  ),
                  (a.parent = t),
                  a.freezeWorldMatrix();
              return [2, t];
            });
          });
        }),
        t);
      function t(e) {
        this.mApp = e.app;
      }
      m.DummyPlaceholderCreator = e;
      var r =
        ((n.prototype.create = function (c, u) {
          return __awaiter(this, void 0, void 0, function () {
            var t, r, n, i, a, s, o, l;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  return [4, c.getItemProperties()];
                case 1:
                  return (t = e.sent()), [4, c.getCatalogImage()];
                case 2:
                  return (r = e.sent()), [4, this.createTexture(t, r)];
                case 3:
                  return (n = e.sent()), [4, this.createMesh(t, n)];
                case 4:
                  for (i = e.sent(), a = 0, s = u; a < s.length; a++)
                    (o = s[a]),
                      (l = new BABYLON.TransformNode(
                        'subarticle_placeholder',
                        this.mApp.scene
                      )),
                      h.core.mdl.NodeUserData.SetData(
                        l,
                        m.ArticleElement.NODEDATA_BASKETID,
                        o
                      ),
                      (l.parent = i),
                      l.freezeWorldMatrix();
                  return [2, i];
              }
            });
          });
        }),
        (n.prototype.createTexture = function (f, A) {
          return __awaiter(this, void 0, void 0, function () {
            var t, r, n, i, a, s, o, l, c, u, m, h, p, d, g;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  return [4, this.loadFrameImg()];
                case 1:
                  return (
                    (t = e.sent()),
                    (r = null) == A
                      ? [3, 3]
                      : [4, this.loadImgFromBuffer(A.data)]
                  );
                case 2:
                  (r = e.sent()), (e.label = 3);
                case 3:
                  return null != r ? [3, 5] : [4, this.loadDefaultCatalogImg()];
                case 4:
                  (r = e.sent()), (e.label = 5);
                case 5:
                  if (
                    (((n = document.createElement('canvas')).width = 950),
                    (n.height = 346),
                    null == (i = n.getContext('2d')))
                  )
                    throw new Error(' Failed to get 2d canvas context');
                  for (
                    i.font = '400 36px ' + this.mApp.theme.fontFamily,
                      a = this.getTextLines(i, f.article.shortText, 545),
                      i.font = '400 24px ' + this.mApp.theme.fontFamily,
                      s = this.getTextLines(
                        i,
                        f.article.manufacturerName +
                          ' | ' +
                          f.article.seriesName,
                        545
                      ),
                      this.limitLines(a, 1 < s.length ? 2 : 3),
                      this.limitLines(s, 2),
                      i.drawImage(t, 0, 0),
                      null != r &&
                        (r.naturalWidth > r.naturalHeight
                          ? ((c = r.naturalHeight / r.naturalWidth),
                            (o = Math.round(250 * c)),
                            (l = Math.round(173 - 0.5 * o)),
                            i.drawImage(r, 48, l, 250, o))
                          : ((c = r.naturalWidth / r.naturalHeight),
                            (u = Math.round(250 * c)),
                            (m = Math.round(173 - 0.5 * u)),
                            i.drawImage(r, m, 48, u, 250))),
                      p = 0.15 * (h = 36),
                      d = 94,
                      i.font = '700 36px ' + this.mApp.theme.fontFamily,
                      i.fillStyle = '#4f4f4f',
                      i.fillText(f.article.baseArticleNumber, 335, d),
                      d += h + 15,
                      i.font = '400 36px ' + this.mApp.theme.fontFamily,
                      g = 0;
                    g < a.length;
                    ++g
                  )
                    0 < g && (d += h + p), i.fillText(a[g], 335, d);
                  for (
                    d += h + 15,
                      p = 0.15 * (h = 24),
                      i.fillStyle = '#b2b2b2',
                      i.font = '400 24px ' + this.mApp.theme.fontFamily,
                      g = 0;
                    g < s.length;
                    ++g
                  )
                    0 < g && (d += h + p), i.fillText(s[g], 335, d);
                  return [2, n.toDataURL('image/jpg')];
              }
            });
          });
        }),
        (n.prototype.createMesh = function (e, t) {
          var r = 'article_placeholder_' + e.article.baseArticleNumber,
            n = 'article_placeholder_' + e.itemId,
            i = this.mApp.scene.getMaterialByID(n);
          null != i && i.dispose(!1, !0);
          var a = new Array();
          a.push(new BABYLON.Vector4(1, 1, 0, 0)),
            a.push(new BABYLON.Vector4(0, 0, 1, 1)),
            a.push(new BABYLON.Vector4(0, 0, 0, 0)),
            a.push(new BABYLON.Vector4(0, 0, 0, 0)),
            a.push(new BABYLON.Vector4(0, 0, 0, 0)),
            a.push(new BABYLON.Vector4(0, 0, 0, 0));
          var s = BABYLON.MeshBuilder.CreateBox(
            r,
            { width: 1, height: 0.364, depth: 0.01, faceUV: a },
            this.mApp.scene
          );
          s.bakeTransformIntoVertices(
            BABYLON.Matrix.RotationX(h.utils.math.PI_DIV2)
          ),
            s.bakeTransformIntoVertices(
              BABYLON.Matrix.Translation(0.5, 0.005, -0.182)
            ),
            s.freezeWorldMatrix();
          var o = new h.core.mdl.PbrMaterial(r, this.mApp.model.materials);
          return (
            (o.id = n),
            (o.backFaceCulling = !1),
            (o.metallic = 0),
            (o.roughness = 1),
            (o.albedoTexture = BABYLON.Texture.LoadFromDataString(
              e.itemId,
              t,
              this.mApp.scene
            )),
            (o.albedoTexture.anisotropicFilteringLevel = this.mApp.engine.getCaps().maxAnisotropy),
            o.freeze(),
            (s.material = o),
            h.core.mdl.NodeUserData.SetData(
              s,
              m.ArticleElement.NODEDATA_BASKETID,
              e.itemId
            ),
            s.freezeWorldMatrix(),
            s
          );
        }),
        (n.prototype.loadFrameImg = function () {
          var t = this;
          return null != this.mFrameImg
            ? Promise.resolve(this.mFrameImg)
            : this.loadImg(
                this.mApp.dataPath + 'cf/images/placeholder_frame.png'
              ).then(function (e) {
                return null != e
                  ? ((t.mFrameImg = e), Promise.resolve(e))
                  : Promise.reject('Failed to load frame imange.');
              });
        }),
        (n.prototype.loadDefaultCatalogImg = function () {
          var t = this;
          return null != this.mDefaultCatalogImg
            ? Promise.resolve(this.mDefaultCatalogImg)
            : this.loadImg(
                this.mApp.dataPath + 'cf/images/placeholder_catalog_default.png'
              ).then(function (e) {
                return null != e
                  ? ((t.mDefaultCatalogImg = e), Promise.resolve(e))
                  : Promise.reject('Failed to load default catalog imange.');
              });
        }),
        (n.prototype.loadImgFromBuffer = function (e) {
          if (null == e) return Promise.resolve(null);
          var t = new Blob([e]),
            r = URL.createObjectURL(t);
          return this.loadImg(r).then(function (e) {
            return URL.revokeObjectURL(r), e;
          });
        }),
        (n.prototype.loadImg = function (r) {
          return h.utils.string.isNullOrEmpty(r)
            ? Promise.resolve(null)
            : new Promise(function (t) {
                var e = document.createElement('img');
                (e.onload = function () {
                  return t(e);
                }),
                  (e.onerror = function (e) {
                    h.utils.Log.error('Failed to load image.', e), t(null);
                  }),
                  (e.src = r);
              });
        }),
        (n.prototype.getTextLines = function (e, t, r) {
          if (null == t) return [''];
          for (
            var n = t.split(' '), i = [], a = n[0], s = 1;
            s < n.length;
            s++
          ) {
            var o = n[s];
            e.measureText(a + ' ' + o).width < r
              ? (a += ' ' + o)
              : (i.push(a), (a = o));
          }
          return i.push(a), i;
        }),
        (n.prototype.limitLines = function (e, t) {
          var r;
          e.length > t &&
            (e.splice(t),
            (r = (r = e[t - 1]).substr(0, r.length - 1)),
            (r += 'â€¦'),
            (e[t - 1] = r));
        }),
        n);
      function n(e) {
        (this.mApp = e.app),
          (this.mFrameImg = null),
          (this.mDefaultCatalogImg = null);
      }
      m.DefaultPlaceholderCreator = r;
    })((h = e.wcf || (e.wcf = {})).cf || (h.cf = {}));
  })((egr = egr || {})),
  (function (e) {
    var r, n, a, t;
    function i(e, t, r, n) {
      var i = a.call(this, t, r, n) || this;
      return (i.mMainArticle = e), i;
    }
    (r = e.wcf || (e.wcf = {})),
      (n = r.cf || (r.cf = {})),
      (a = n.ArticleElement),
      __extends(i, a),
      (i.prototype.canTranslate = function () {
        return !1;
      }),
      (i.prototype.canRotate = function () {
        return !1;
      }),
      (i.prototype.canDelete = function () {
        return !1;
      }),
      (i.prototype.canSelect = function () {
        var e,
          t = a.prototype.canSelect.call(this);
        return (
          !t ||
            (null !=
              (e = r.core.mdl.NodeUserData.GetData(
                this.mNode,
                n.ArticleElement.NODEDATA_SELECTABLE
              )) &&
              (t = e)),
          t
        );
      }),
      (i.prototype.isInstanced = function () {
        return this.mMainArticle.isInstanced();
      }),
      (i.prototype.ensureIsInstanced = function () {
        return this.mMainArticle.ensureIsInstanced();
      }),
      (i.prototype.getMainElement = function () {
        return this.mMainArticle;
      }),
      (i.prototype.getMainArticle = function () {
        return this.mMainArticle;
      }),
      (i.prototype.getParentArticle = function () {
        return this.getParentElement();
      }),
      (i.prototype.clone = function (e) {
        var t = new i(
          void 0,
          null,
          this.mMngr,
          r.core.mdl.SceneElement.cloneNode(this.mNode, e)
        );
        return t.copyDataFrom(this), t;
      }),
      (i.prototype._setMainArticle = function (e) {
        this.mMainArticle = e;
      }),
      (t = i),
      (n.SubArticleElement = t);
  })((egr = egr || {})),
  (function (e) {
    var a;
    (function (e) {
      var n,
        o =
          ((n = a.core.tool.Interactor),
          __extends(t, n),
          Object.defineProperty(t.prototype, 'article', {
            get: function () {
              return this.mArticle;
            },
            enumerable: !1,
            configurable: !0,
          }),
          t);
      function t(e, t) {
        var r =
          n.call(this, document.createElement('div'), t.app.viewer) || this;
        return (
          (r.mArticle = e),
          (r.type = 0),
          (r.customCssTransform = 'translate(-50%, -50%)'),
          (r.worldMatrix = r.mArticle.worldTransform),
          r.position.copyFrom(r.mArticle.boundingBoxVisible.getCenter()),
          r
        );
      }
      e.SubArticleHighlight = o;
      var r =
        ((i.Create = function (e, t, r, n) {
          return null == t.app.tools.defaultTool ||
            t.app.tools.isDefaultToolRunning()
            ? new i(e, t, r, n)
            : null;
        }),
        (i.prototype.dispose = function () {
          this.mInteractors.enabled &&
            (this.mMngr.app.model.eventSelectionChanged.removeListener(
              this.onSelectionChanged
            ),
            this.mMngr.app.tools.eventToolStarted.removeListener(
              this.onToolStart
            ),
            null != this.notifyDispose && this.notifyDispose(),
            this.mInteractors.dispose());
        }),
        (i.prototype.createHighlights = function (e) {
          for (
            var t = this.mArticle.getSubArticles(!1),
              r = new Array(),
              n = 0,
              i = t;
            n < i.length;
            n++
          ) {
            var a,
              s = i[n];
            s.canSelect() &&
              s.boundingBoxVisible.isValid() &&
              ((a = new o(s, this.mMngr)),
              this.mInteractors.addInteractor(a),
              r.push(a));
          }
          e(r);
        }),
        i);
      function i(e, t, r, n) {
        var i = this;
        (this.onSelectionChanged = function () {
          i.dispose();
        }),
          (this.onToolStart = function () {
            i.dispose();
          }),
          (this.mMngr = t),
          (this.mArticle = e),
          (this.mInteractors = new a.core.tool.InteractorManager(
            this.mMngr.app.viewer
          )),
          (this.notifyDispose = n),
          this.mMngr.app.model.eventSelectionChanged.addListener(
            this.onSelectionChanged
          ),
          this.mMngr.app.tools.eventToolStarted.addListener(this.onToolStart),
          this.mMngr.app.model.eventSelectionChanged.addListener(
            this.onSelectionChanged
          ),
          this.createHighlights(r);
      }
      e.SubArticleHighlights = r;
    })((a = e.wcf || (e.wcf = {})).cf || (a.cf = {}));
  })((egr = egr || {})),
  (function (e) {
    var r, o, n, t;
    function l() {
      return (null !== n && n.apply(this, arguments)) || this;
    }
    (r = e.wcf || (e.wcf = {})),
      (o = r.cf || (r.cf = {})),
      (n = o.MainArticleElement),
      __extends(l, n),
      (l.prototype.updateGeometry = function (e) {
        return void 0 === e && (e = !0), Promise.resolve();
      }),
      (l.prototype.clone = function (e) {
        void 0 === e && (e = null);
        var t = new l(
          null,
          this.mMngr,
          r.core.mdl.SceneElement.cloneNode(this.mNode, e)
        );
        return t.copyDataFrom(this), t;
      }),
      (l.prototype.serialize = function (e) {
        if (null == this.mNode) return null;
        var t = n.prototype.serialize.call(this, e);
        return (t.classId = l.CLASS_ID), t;
      }),
      (l.prototype._getCatalogImage = function (e) {
        return Promise.resolve(null);
      }),
      (l._LoadArticleElement = function (e, t, r) {
        if (null == r) return null;
        var n = null != r.placeholderGeometry && r.placeholderGeometry,
          i = e.getModule(o.AppModule.MODULE_KEY),
          a = o.MainArticleElement.LoadArticleElementNode(e, t, r);
        if (null == a || null == a.basketId || null == i) return null;
        var s = new l(a.basketId, i.articleManager, a.node);
        return (
          s.setCatalogImageIdCache(a.catalogImageIds),
          null == s.mNode && (n = !0),
          n &&
            t.registerPendingTask(function () {
              return s._initPlaceholderGeometry(null);
            }),
          s
        );
      }),
      (l.prototype._resetImpGeometry = function () {
        if (null == this.mBasketId)
          return r.utils.rejectError(
            r.utils.ERR_INVALID_STATE,
            'basketId is null'
          );
        var e = this.getCachedItemProperties();
        null != e &&
          null != e.composableGeometry &&
          (e.composableGeometry.geometry = '');
        var t = new r.eaiws.basket.ItemProperties();
        return (
          (t.composableGeometry = new r.eaiws.basket.ComposableGeometryProperties()),
          (t.composableGeometry.geometry = ''),
          this.mMngr.session.basket.setItemProperties(this.mBasketId, t)
        );
      }),
      (l.prototype.supportScaleEaiwsTransform = function () {
        return !0;
      }),
      (l.CLASS_ID = 'egr.wcf.cf:UserArticle'),
      (t = l),
      (o.UserArticleElement = t);
  })((egr = egr || {})),
  (function (e) {
    var y, v, t, r;
    function n(e) {
      (this.onResolveUrl = null),
        (this.mScene = e.scene),
        (this.mLayerManager = e.layers),
        (this.mGeometryManager = e.geometries),
        (this.mMaterialManager = e.materials),
        (this.mResourcesLock = new y.utils.async.Lock());
    }
    (y = e.wcf || (e.wcf = {})),
      (v = y.cf || (y.cf = {})),
      (t = v.io || (v.io = {})),
      (n.prototype.load = function (e, t, r, n) {
        var i = this;
        return y.utils.string.isNullOrEmpty(e)
          ? Promise.resolve(null)
          : (null == n ? y.utils.async.ajax('GET', e) : n.getFile(e, !1)).then(
              function (e) {
                return i.loadData(JSON.parse(e), t, r, n);
              }
            );
      }),
      (n.prototype.loadData = function (g, f, A, b) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l, c, u, m, h, p, d;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return y.utils.object.isNullOrEmpty(g.Geometries)
                  ? [2, null]
                  : [4, this.mResourcesLock.acquireLock()];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                return (
                  e.trys.push([2, , 4, 5]), [4, this.preLoadResources(g, b)]
                );
              case 3:
                return e.sent(), [3, 5];
              case 4:
                return t.unlock(), [7];
              case 5:
                if ((r = null) != A)
                  for (r = new Map(), n = 0, i = A; n < i.length; n++)
                    null != (d = i[n]).geometryId &&
                      r.set(d.geometryId, d.itemId);
                for (a = new Array(), s = 0, o = g.Objects; s < o.length; s++)
                  if (
                    ((l = o[s]),
                    (c = new Set()),
                    (u = new Array()),
                    null != (m = this.loadObject(g, l, null, f, r, c, u)) &&
                      0 < u.length &&
                      (a.push(m), null != A))
                  )
                    for (h = 0, p = A; h < p.length; h++)
                      (d = p[h]),
                        c.has(d.itemId) ||
                          this.createDummySubArticle(m, d.itemId);
                return [2, a];
            }
          });
        });
      }),
      (n.prototype.preLoadResources = function (l, c) {
        return __awaiter(this, void 0, void 0, function () {
          var t,
            r,
            n,
            i,
            a,
            s,
            o = this;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                for (r in ((t = new Array()), l.Geometries)) t.push(r);
                return [
                  4,
                  y.utils.async.forEachParallel(
                    t,
                    function (e, t) {
                      return o.loadGeometry(t, l.Geometries[t], c);
                    },
                    5
                  ),
                ];
              case 1:
                for (i in (e.sent(), (n = []), l.Materials)) n.push(i);
                (a = 0), (e.label = 2);
              case 2:
                return a < n.length
                  ? ((s = n[a]), [4, this.loadMaterial(s, l.Materials[s], c)])
                  : [3, 5];
              case 3:
                e.sent(), (e.label = 4);
              case 4:
                return a++, [3, 2];
              case 5:
                return [2];
            }
          });
        });
      }),
      (n.prototype.loadObject = function (e, t, r, n, i, a, s) {
        if (null == t) return null;
        var o,
          l = 'gfj_',
          c = null,
          u =
            null != t.Geometry
              ? ((l += 'mesh'),
                null != t.Layer && (l += '_' + t.Layer),
                (c = new BABYLON.Mesh(l, this.mScene)))
              : ((o = t.OrderNumber),
                (l +=
                  null == r
                    ? 'article_' + o
                    : null != o
                    ? 'subarticle_' + o
                    : 'group'),
                new BABYLON.TransformNode(l, this.mScene));
        u.parent = r;
        var m,
          h,
          p,
          d,
          g,
          f = null,
          f =
            null != t.GeometryId && null != i
              ? i.get(t.GeometryId)
              : t.BasketId;
        if (
          (null == r && null != n && null == f && (f = n),
          null != f &&
            (a.add(f),
            y.core.mdl.NodeUserData.SetData(
              u,
              v.ArticleElement.NODEDATA_BASKETID,
              f
            ),
            (m = null == t.Selectable || 'Self' === t.Selectable),
            y.core.mdl.NodeUserData.SetData(
              u,
              v.ArticleElement.NODEDATA_SELECTABLE,
              m
            )),
          null != t.Transform &&
            (null != t.Transform.Position &&
              (u.position = new BABYLON.Vector3(
                t.Transform.Position[0],
                t.Transform.Position[1],
                -t.Transform.Position[2]
              )),
            null != t.Transform.Rotation &&
              (u.rotationQuaternion = new BABYLON.Quaternion(
                t.Transform.Rotation[0],
                t.Transform.Rotation[1],
                -t.Transform.Rotation[2],
                -t.Transform.Rotation[3]
              )),
            null != t.Transform.Scale &&
              (u.scaling = new BABYLON.Vector3(
                t.Transform.Scale[0],
                t.Transform.Scale[1],
                t.Transform.Scale[2]
              ))),
          null != c &&
            (null == t.Geometry ||
              (null != (h = this.mGeometryManager.getGeometry(t.Geometry)) &&
                (h.applyToMesh(c), s.push(c))),
            (p = null),
            (d = t.Material),
            y.utils.string.isNullOrEmpty(d) ||
              (null != (g = e.Materials[d]) &&
                null != g.wcf_id &&
                (p = this.mMaterialManager.getMaterial(g.wcf_id))),
            null == p && (p = this.mMaterialManager.defaultMaterial),
            (c.material = p),
            null != t.Layer && this.mLayerManager.setMeshLayer(c, t.Layer)),
          null != t.Children)
        )
          for (var A = 0, b = t.Children; A < b.length; A++) {
            var I = b[A];
            this.loadObject(e, I, u, null, i, a, s);
          }
        return u.freezeWorldMatrix(), u;
      }),
      (n.prototype.createDummySubArticle = function (e, t) {
        var r = new BABYLON.TransformNode('gfj_dummy_subarticle', this.mScene);
        (r.parent = e),
          r.freezeWorldMatrix(),
          y.core.mdl.NodeUserData.SetData(
            r,
            v.ArticleElement.NODEDATA_BASKETID,
            t
          ),
          y.core.mdl.NodeUserData.SetData(
            r,
            v.ArticleElement.NODEDATA_SELECTABLE,
            !0
          );
      }),
      (n.prototype.loadGeometry = function (o, l, c) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (y.utils.string.isNullOrEmpty(o)) return [2];
                if (
                  null != (t = this.mGeometryManager.getGeometry(o)) &&
                  !this.mGeometryManager.isFallbackGeometry(t)
                )
                  return [2];
                e.label = 1;
              case 1:
                return (
                  e.trys.push([1, 7, , 8]),
                  (r = this.resolveUrl(l)),
                  (n = null) == c ? [3, 4] : [4, c.getFile(r, !0)]
                );
              case 2:
                return (
                  (i = e.sent()),
                  [4, y.core.mdl.io.GltfMesh.Import(i, this.mScene)]
                );
              case 3:
                return (n = e.sent()), [3, 6];
              case 4:
                return [
                  4,
                  y.core.mdl.io.GltfMesh.ImportFromUrl(r, this.mScene),
                ];
              case 5:
                (n = e.sent()), (e.label = 6);
              case 6:
                return (
                  (a = null) != n && 0 < n.length && (a = n[0]),
                  null != a &&
                    (y.core.mdl.BoundingBox.IsBoundingInfoValid(
                      a.getBoundingInfo()
                    )
                      ? this.mGeometryManager.addGeometryMesh(o, a)
                      : (y.utils.Log.warn(
                          'Detected geometry with invalid bounding box: ' + o
                        ),
                        a.dispose())),
                  [3, 8]
                );
              case 7:
                return (
                  (s = e.sent()),
                  y.utils.Log.error('Failed to load geometry ' + o, s),
                  [3, 8]
                );
              case 8:
                return [2];
            }
          });
        });
      }),
      (n.prototype.loadMaterial = function (n, i, a) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.getMaterialId(n, i)];
              case 1:
                return (
                  (t = e.sent()),
                  y.utils.string.isNullOrEmpty(t)
                    ? [2]
                    : null == (r = this.mMaterialManager.getMaterial(t))
                    ? [3, 4]
                    : r.hasFallbackTextures()
                    ? [4, this.loadPbrMaterialTextures(i, r, a)]
                    : [3, 3]
                );
              case 2:
                e.sent(), (e.label = 3);
              case 3:
                return [2];
              case 4:
                return this.isPbrMaterial(i)
                  ? [4, this.loadPbrMaterial(t, n, i, a)]
                  : [3, 6];
              case 5:
                return e.sent(), [3, 8];
              case 6:
                return [4, this.loadLegacyMaterialAsPbr(t, n, i, a)];
              case 7:
                e.sent(), (e.label = 8);
              case 8:
                return [2];
            }
          });
        });
      }),
      (n.prototype.loadLegacyMaterialAsPbr = function (o, l, c, u) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (
                  (t = new y.core.mdl.PbrMaterial(l, this.mMaterialManager)),
                  [4, this.loadPbrMaterialTextures(c, t, u)]
                );
              case 1:
                return (
                  e.sent(),
                  (r = BABYLON.Color3.White()),
                  null == t.albedoTexture &&
                    null != c.dif &&
                    (r = new BABYLON.Color3(
                      y.utils.math.clamp(c.dif[0], 0, 1),
                      y.utils.math.clamp(c.dif[1], 0, 1),
                      y.utils.math.clamp(c.dif[2], 0, 1)
                    )),
                  null == c.tra ||
                    (null != t.albedoTexture && t.albedoTexture.hasAlpha) ||
                    (t.alpha = 1 - c.tra),
                  null != c.emission &&
                    (t.emissiveColor = new BABYLON.Color3(
                      y.utils.math.clamp(c.emission[0], 0, 1),
                      y.utils.math.clamp(c.emission[1], 0, 1),
                      y.utils.math.clamp(c.emission[2], 0, 1)
                    )),
                  (n = BABYLON.Color3.Black()),
                  null != c.spe &&
                    (n = new BABYLON.Color3(
                      y.utils.math.clamp(c.spe[0], 0, 1),
                      y.utils.math.clamp(c.spe[1], 0, 1),
                      y.utils.math.clamp(c.spe[2], 0, 1)
                    )),
                  (i = 30),
                  null != c.shi && (i = c.shi),
                  (a = 0),
                  null != c.reflection &&
                    ((a = (n.r + n.g + n.b) / 3),
                    1 < (a *= c.reflection) && (a = 1)),
                  (s = y.core.mdl.PbrMaterial.ConvertToPbrParameters(
                    r,
                    null != t.albedoTexture,
                    n,
                    i,
                    a,
                    t.alpha,
                    c.type
                  )),
                  (t.albedoColor = s.albedo),
                  (t.metallic = s.metallic),
                  (t.roughness = s.roughness),
                  t.freeze(),
                  this.mMaterialManager.addMaterial(o, t),
                  [2]
                );
            }
          });
        });
      }),
      (n.prototype.loadPbrMaterial = function (a, s, o, l) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return (
                  (t = new y.core.mdl.PbrMaterial(s, this.mMaterialManager)),
                  [4, this.loadPbrMaterialTextures(o, t, l)]
                );
              case 1:
                return (
                  e.sent(),
                  null == t.albedoTexture &&
                    null != (r = null != o.baseColor ? o.baseColor : o.dif) &&
                    ((t.albedoColor = new BABYLON.Color3(
                      y.utils.math.clamp(r[0], 0, 1),
                      y.utils.math.clamp(r[1], 0, 1),
                      y.utils.math.clamp(r[2], 0, 1)
                    )),
                    t.albedoColor.toLinearSpaceToRef(t.albedoColor)),
                  null == o.tra ||
                    (null != t.albedoTexture && t.albedoTexture.hasAlpha) ||
                    (t.alpha = 1 - o.tra),
                  null != o.emission &&
                    (t.emissiveColor = new BABYLON.Color3(
                      y.utils.math.clamp(o.emission[0], 0, 1),
                      y.utils.math.clamp(o.emission[1], 0, 1),
                      y.utils.math.clamp(o.emission[2], 0, 1)
                    )),
                  null == t.metallicTexture &&
                    (1 < (n = null != o.metallic ? o.metallic : 0) && (n = 1),
                    (t.metallic = n)),
                  null == t.microSurfaceTexture &&
                    ((i = null != o.roughness ? o.roughness : 0),
                    (t.roughness = y.core.mdl.PbrMaterial.ConvertLinearRoughness(
                      i
                    ))),
                  t.freeze(),
                  this.mMaterialManager.addMaterial(a, t),
                  [2]
                );
            }
          });
        });
      }),
      (n.prototype.setTexture = function (e, t, r) {
        var n;
        null != e &&
          null != t &&
          ((n = e[r]),
          (e[r] = t),
          null != n &&
            n instanceof y.core.mdl.Texture &&
            n.isClone &&
            n.dispose(),
          e.markDirty());
      }),
      (n.prototype.loadPbrMaterialTextures = function (m, h, p) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l, c, u;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (
                  ((t = this.resolveUrl(m.tex)),
                  (r = this.resolveUrl(m.bumps)),
                  (n = this.resolveUrl(m.metallicTex)),
                  (i = this.resolveUrl(m.roughnessTex)),
                  !y.utils.string.isNotNullOrEmpty(t) || null == m.texChecksum)
                )
                  return [3, 4];
                e.label = 1;
              case 1:
                return (
                  e.trys.push([1, 3, , 4]),
                  (a = null != m.texTransparent && !0 === m.texTransparent),
                  [
                    4,
                    this.loadTexture(
                      h,
                      t,
                      m.texChecksum,
                      'albedoTexture',
                      a,
                      p,
                      m.scale,
                      m.rotate,
                      m.offset
                    ),
                  ]
                );
              case 2:
                return (
                  null != (c = e.sent()) &&
                    (h.useAlphaFromAlbedoTexture = c.hasAlpha),
                  [3, 4]
                );
              case 3:
                return (
                  (s = e.sent()),
                  y.utils.Log.error(
                    'Failed to load albedo texture ' + m.tex,
                    s
                  ),
                  [3, 4]
                );
              case 4:
                if (
                  !y.utils.string.isNotNullOrEmpty(r) ||
                  null == m.bumpsChecksum
                )
                  return [3, 8];
                e.label = 5;
              case 5:
                return (
                  e.trys.push([5, 7, , 8]),
                  [
                    4,
                    this.loadTexture(
                      h,
                      r,
                      m.bumpsChecksum,
                      'bumpTexture',
                      !1,
                      p,
                      null != m.nscale ? m.nscale : m.scale,
                      null != m.nrotate ? m.nrotate : m.rotate,
                      null != m.noffset ? m.noffset : m.offset
                    ),
                  ]
                );
              case 6:
                return (
                  null != (c = e.sent()) && (h.forceIrradianceInFragment = !0),
                  [3, 8]
                );
              case 7:
                return (
                  (o = e.sent()),
                  y.utils.Log.error(
                    'Failed to load bump texture ' + m.bumps,
                    o
                  ),
                  [3, 8]
                );
              case 8:
                if (
                  !y.utils.string.isNotNullOrEmpty(n) ||
                  null == m.metallicChecksum
                )
                  return [3, 12];
                e.label = 9;
              case 9:
                return (
                  e.trys.push([9, 11, , 12]),
                  [
                    4,
                    this.loadTexture(
                      h,
                      n,
                      m.metallicChecksum,
                      'metallicTexture',
                      !1,
                      p,
                      m.scale,
                      m.rotate,
                      m.offset
                    ),
                  ]
                );
              case 10:
                return null != (c = e.sent()) && (h.metallic = 1), [3, 12];
              case 11:
                return (
                  (l = e.sent()),
                  y.utils.Log.error(
                    'Failed to load metalllic texture ' + m.tex,
                    l
                  ),
                  [3, 12]
                );
              case 12:
                if (
                  !y.utils.string.isNotNullOrEmpty(i) ||
                  null == m.roughnessChecksum
                )
                  return [3, 16];
                e.label = 13;
              case 13:
                return (
                  e.trys.push([13, 15, , 16]),
                  [
                    4,
                    this.loadTexture(
                      h,
                      i,
                      m.roughnessChecksum,
                      'microSurfaceTexture',
                      !1,
                      p,
                      m.scale,
                      m.rotate,
                      m.offset
                    ),
                  ]
                );
              case 14:
                return null != (c = e.sent()) && (h.roughness = 1), [3, 16];
              case 15:
                return (
                  (u = e.sent()),
                  y.utils.Log.error(
                    'Failed to load roughness texture ' + m.tex,
                    u
                  ),
                  [3, 16]
                );
              case 16:
                return [2];
            }
          });
        });
      }),
      (n.prototype.loadTexture = function (r, n, i, a, s, o, l, c, u) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [
                  4,
                  this.mMaterialManager.createResourceTexture(i, n, s, o),
                ];
              case 1:
                return (
                  null != (t = e.sent()) &&
                    ((t.name = y.utils.string.getFileName(n)),
                    (t = this.setupTextureMatrix(t, l, c, u)),
                    this.setTexture(r, t, a)),
                  [2, t]
                );
            }
          });
        });
      }),
      (n.prototype.setupTextureMatrix = function (e, t, r, n) {
        var i = e;
        return (
          (null == n && null == t && null == r) ||
            ((i = i.clone()),
            null != t && ((i.uScale = t[0]), (i.vScale = t[1])),
            null != r &&
              ((i.uAng = BABYLON.Tools.ToRadians(r[0])),
              (i.vAng = BABYLON.Tools.ToRadians(r[1])),
              (i.wAng = BABYLON.Tools.ToRadians(r[2]))),
            null != n && ((i.uOffset = n[0]), (i.vOffset = n[1])),
            i.notifyTextureMatrixChanged()),
          i
        );
      }),
      (n.prototype.getMaterialId = function (n, i) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return null == i || y.utils.string.isNullOrEmpty(i.checksum)
                  ? [2, null]
                  : null != i.wcf_id
                  ? [2, i.wcf_id]
                  : [4, y.utils.string.hash(n + i.checksum, 'SHA-256')];
              case 1:
                return (
                  (t = e.sent()), (r = t.substr(0, 32)), [2, (i.wcf_id = r)]
                );
            }
          });
        });
      }),
      (n.prototype.resolveUrl = function (e) {
        return null == e
          ? ''
          : null == this.onResolveUrl
          ? e
          : this.onResolveUrl(e);
      }),
      (n.prototype.isPbrMaterial = function (e) {
        return (
          null != e.metallic ||
          null != e.metallicTex ||
          null != e.roughness ||
          null != e.roughnessTex
        );
      }),
      (r = n),
      (t.GfjLoader = r);
  })((egr = egr || {})),
  (function (e) {
    var p, t, r, n;
    function i() {
      (this.mDoc = null),
        (this.mConfig = null),
        (this.mTopFolder = null),
        (this.mItemRoot = null),
        (this.mLanguages = ['en']),
        (this.mElementData = new Map()),
        (this.mArticleFeatures = new Map());
    }
    (p = e.wcf || (e.wcf = {})),
      (t = p.cf || (p.cf = {})),
      (r = t.io || (t.io = {})),
      Object.defineProperty(i.prototype, 'isAvailable', {
        get: function () {
          return null != this.mDoc;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (i.prototype.getArticleData = function (e) {
        var t = this.getElementData(e);
        if (null == t) throw new Error('Unknown item id ' + e);
        if (null == t.article)
          throw new Error('Item ' + e + 'is not an article.');
        var r = new p.eaiws.basket.ArticleData();
        return (
          (r.manufacturerId = t.article.manufacturerId),
          (r.seriesId = t.article.seriesId),
          (r.shortText = t.article.shortText),
          (r.longText = t.article.longText),
          (r.featureText = t.article.featureText),
          (r.baseArticleNumber = t.article.baseArtNum),
          (r.variantCode = t.article.varCode),
          (r.currency = t.article.currency),
          (r.pdPurchasePrice = t.article.pdPurchasePrice),
          (r.pdPurchasePriceComponents = t.article.pdPurchasePriceComponents),
          (r.pdSalesPrice = t.article.pdSalesPrice),
          (r.pdSalesPriceComponents = t.article.pdSalesPriceComponents),
          (r.properties = this.getProperties(t.article)),
          (r.catalogImage = ''),
          (r.catalogIcon = ''),
          r
        );
      }),
      (i.prototype.getCurrency = function () {
        if (null == this.mConfig) return null;
        var e = this.getChildElement(this.mConfig, 'currency');
        return null != e ? e.getAttribute('unit') : null;
      }),
      (i.prototype.getExchangeRates = function (e) {
        if (null == this.mConfig) return null;
        for (
          var t = new Array(),
            r = this.mConfig.querySelectorAll('convRates > convRate'),
            n = 0;
          n < r.length;
          ++n
        ) {
          var i,
            a = r.item(n),
            s = a.getAttribute('value'),
            o = a.getAttribute('currency');
          (null != e && !p.utils.array.contains(e, o)) ||
            (((i = new p.eaiws.basket.ExchangeRate()).currency = o),
            (i.rate = parseFloat(s)),
            t.push(i));
        }
        return t;
      }),
      (i.prototype.getItems = function (e) {
        for (var t = new Array(), r = 0, n = e; r < n.length; r++) {
          var i,
            a = n[r],
            s = this.getElementData(a);
          null != s &&
            (((i = new p.eaiws.basket.BasketItem()).itemId = s.itemId),
            (i.itemType = s.itemType),
            (i.label = s.label),
            null != s.article
              ? ((i.mainArticleId = s.article.mainArticleId),
                (i.subArticleIds = s.article.subArticleIds),
                (i.geometryId = s.article.geometryId))
              : (i.mainArticleId = '00000000-0000-0000-0000-000000000000'),
            t.push(i));
        }
        return t;
      }),
      (i.prototype.getAllItems = function () {
        return this.getItems(this.getAllItemIds());
      }),
      (i.prototype.getItemProperties = function (e) {
        for (var t = new Array(), r = 0, n = e; r < n.length; r++) {
          var i,
            a = n[r],
            s = this.getElementData(a);
          null != s &&
            (((i = new p.eaiws.basket.ItemProperties()).itemId = s.itemId),
            (i.itemType = s.itemType),
            (i.label = s.label),
            (i.visible = !0),
            (i.composableGeometry = s.composableGeometry),
            'Folder' === i.itemType
              ? ((i.folder = new p.eaiws.basket.FolderProperties()),
                (i.folder.name = i.label))
              : null != s.article &&
                ((i.article = new p.eaiws.basket.ArticleProperties()),
                (i.article.catalogId = ''),
                (i.article.manufacturerId = s.article.manufacturerId),
                (i.article.manufacturerName = s.article.manufacturer),
                (i.article.seriesId = s.article.seriesId),
                (i.article.seriesName = s.article.series),
                (i.article.baseArticleNumber = s.article.baseArtNum),
                (i.article.finalArticleNumber = s.article.finalArtNum),
                (i.article.variantCode = s.article.varCode),
                (i.article.ofmlVariantCode = s.article.ofmlVarCode),
                (i.article.useFinalArticleNumber = s.article.useFinalArtNum),
                (i.article.shortText = s.article.shortText),
                (i.article.longText = s.article.longText),
                (i.article.featureText = s.article.featureText),
                (i.article.currency = s.article.currency),
                (i.article.purchasePrice = s.article.pdPurchasePrice),
                (i.article.salesPrice = s.article.pdSalesPrice),
                (i.article.quantity = s.article.quantity),
                (i.article.alternativePosition = s.article.alternativePosition),
                (i.article.excludedCalculations = void 0),
                (i.article.inconsistencyFlag = s.article.inconsistencyFlag),
                (i.article.inconsistencyReason = s.article.inconsistencyReason),
                (i.article.packagingInfo = void 0),
                (i.article.ofmlUpdateState = 'Unknown'),
                (i.article.geometryId = s.article.geometryId)),
            t.push(i));
        }
        return t;
      }),
      (i.prototype.getAllItemProperties = function () {
        return this.getItemProperties(this.getAllItemIds());
      }),
      (i.prototype.getReferenceCurrency = function () {
        if (null == this.mConfig) return null;
        var e = this.mConfig.querySelector('convRates > refCurrency');
        return null != e ? e.getAttribute('id') : null;
      }),
      (i.prototype.getTopFolderId = function () {
        return null == this.mTopFolder
          ? null
          : this.mTopFolder.getAttribute('basketId');
      }),
      (i.prototype.setLanguages = function (e) {
        null != e &&
          0 < e.length &&
          ((this.mLanguages = e),
          this.isAvailable &&
            (this.mElementData.clear(), this.prepareFeatures()));
      }),
      (i.prototype._loadObk = function (e) {
        var t = this;
        this._clear();
        var r = new JSZip();
        return r
          .loadAsync(e)
          .then(function () {
            return t.loadBskFileFromZip(r);
          })
          .then(function (e) {
            return t.readBskDocument(e)
              ? Promise.resolve()
              : Promise.reject(new Error('Invalid file.'));
          })
          .catch(function (e) {
            return Promise.reject(new Error('Failed to read obk: ' + e));
          });
      }),
      (i.prototype._loadObx = function (e) {
        var r = this;
        return (
          this._clear(),
          p.utils.string
            .fromBlob(e)
            .then(function (e) {
              var t = r.parseXml(e);
              return r.readObxDocument(t)
                ? Promise.resolve()
                : Promise.reject(new Error('Invalid file.'));
            })
            .catch(function (e) {
              return Promise.reject(new Error('Failed to read obx: ' + e));
            })
        );
      }),
      (i.prototype._clear = function () {
        (this.mDoc = null),
          (this.mConfig = null),
          (this.mTopFolder = null),
          (this.mItemRoot = null),
          this.mElementData.clear(),
          this.mArticleFeatures.clear();
      }),
      (i.prototype.getChildElement = function (e, t) {
        if (null == e) return null;
        for (var r = 0; r < e.children.length; ++r) {
          var n = e.children.item(r);
          if (null != n && n.tagName === t) return n;
        }
        return null;
      }),
      (i.prototype.getChildElements = function (e, t) {
        var r = new Array();
        if (null != e)
          for (var n = 0; n < e.children.length; ++n) {
            var i = e.children.item(n);
            null != i && i.tagName === t && r.push(i);
          }
        return r;
      }),
      (i.prototype.queryChildElement = function (e, t) {
        if (null == e) return null;
        var r = e.querySelector(t);
        return null != r && r.parentNode === e ? r : null;
      }),
      (i.prototype.loadBskFileFromZip = function (e) {
        var t = this;
        if (null == e)
          return Promise.reject(new Error(p.utils.ERR_INVALID_ARGUMENT));
        var r = e.file('1.bsk');
        return null == r
          ? Promise.reject(new Error('1.bsk not found.'))
          : r.async('string').then(function (e) {
              return t.parseXml(e);
            });
      }),
      (i.prototype.parseXml = function (e) {
        return new DOMParser().parseFromString(e, 'application/xml');
      }),
      (i.prototype.readBskDocument = function (e) {
        return (
          null != e &&
          null != e.documentElement &&
          'basket' === e.documentElement.tagName &&
          ((this.mDoc = e.documentElement),
          (this.mConfig = this.getChildElement(this.mDoc, 'config')),
          (this.mTopFolder = this.getChildElement(this.mDoc, 'topFolder')),
          (this.mItemRoot = this.mTopFolder),
          this.prepareFeatures(),
          !0)
        );
      }),
      (i.prototype.readObxDocument = function (e) {
        return (
          null != e &&
          null != e.documentElement &&
          'cutBuffer' === e.documentElement.tagName &&
          ((this.mDoc = e.documentElement),
          (this.mItemRoot = this.getChildElement(this.mDoc, 'items')),
          this.prepareFeatures(),
          !0)
        );
      }),
      (i.prototype.getElementData = function (e) {
        if (p.utils.string.isNullOrEmpty(e) || null == this.mItemRoot)
          return null;
        var t = this.mElementData.get(e);
        if (void 0 !== t) return t;
        t = null;
        var r =
          e === this.getTopFolderId()
            ? this.mTopFolder
            : this.mItemRoot.querySelector("[basketId='" + e + "']");
        return (
          null != r &&
            ('bskArticle' === r.tagName || 'usrArticle' === r.tagName
              ? (t = this.getArticleElementData(e, r))
              : ('topFolder' !== r.tagName && 'bskFolder' !== r.tagName) ||
                (t = this.getFolderElementData(r)),
            null != t &&
              ((t.itemId = e),
              (t.composableGeometry = this.getComposableGeometryData(r)))),
          this.mElementData.set(e, t),
          t
        );
      }),
      (i.prototype.getFolderElementData = function (e) {
        if (null == e) return null;
        var t = { itemType: 'Folder' };
        return (
          null != this.getChildElement(e, 'label') && (t.label = e.textContent),
          t
        );
      }),
      (i.prototype.getArticleElementData = function (e, t) {
        if (null == t) return null;
        var r,
          n = {};
        switch (t.getAttribute('itemType')) {
          case 'BasketAggregate':
            n.itemType = 'Aggregate';
            break;
          case 'BasketPartialPlanning':
            n.itemType = 'PartialPlanning';
            break;
          case 'UserArticle':
            n.itemType = 'UserArticle';
            break;
          default:
            n.itemType = 'Article';
        }
        var i = {};
        (n.article = i),
          null != (r = this.getChildElement(t, 'manufacturer')) &&
            ((i.manufacturerId = r.getAttribute('id')),
            (i.manufacturer = this.getLangText('name', r))),
          null != (r = this.getChildElement(t, 'series')) &&
            ((i.manufacturerId = r.getAttribute('id')),
            (i.manufacturer = this.getLangText('name', r))),
          null !=
            (r = this.queryChildElement(t, "description[type='short']")) &&
            ((i.shortText = this.getLangText('text', r)),
            (n.label = i.shortText)),
          null != (r = this.queryChildElement(t, "description[type='long']")) &&
            ((i.longText = this.getLangText('text', r)),
            '1' === r.getAttribute('default') && (n.label = i.longText)),
          null !=
            (r = this.queryChildElement(t, "description[type='features']")) &&
            (i.featureText = this.getLangText('text', r)),
          null != (r = this.queryChildElement(t, "artNr[type='base']")) &&
            (i.baseArtNum = r.textContent),
          null != (r = this.queryChildElement(t, "artNr[type='final']")) &&
            ((i.finalArtNum = r.textContent),
            (i.useFinalArtNum = '1' === r.getAttribute('default'))),
          null != (r = this.queryChildElement(t, "artNr[type='varcode']")) &&
            (i.varCode = r.textContent),
          null !=
            (r = this.queryChildElement(t, "artNr[type='ofmlvarcode']")) &&
            (i.ofmlVarCode = r.textContent),
          (i.quantity = 1),
          null != (r = this.getChildElement(t, 'quantity')) &&
            (i.quantity = parseFloat(r.getAttribute('count'))),
          null !=
            (r = this.queryChildElement(t, "itemPrice[type='sale'][pd='1']")) &&
            ((i.pdSalesPrice = parseFloat(r.getAttribute('value'))),
            (i.currency = r.getAttribute('currency'))),
          (i.pdSalesPriceComponents = this.getPriceComponents('sale', t)),
          null !=
            (r = this.queryChildElement(
              t,
              "itemPrice[type='purchase'][pd='1']"
            )) &&
            ((i.pdSalesPrice = parseFloat(r.getAttribute('value'))),
            (i.currency = r.getAttribute('currency'))),
          (i.pdPurchasePriceComponents = this.getPriceComponents(
            'purchase',
            t
          )),
          (r = this.getChildElement(
            this.getChildElement(t, 'exclOffers'),
            'exclOffer'
          )),
          (i.alternativePosition = null != r),
          (i.features = this.getFeatures(t));
        var a = this.getChildElements(
          this.getChildElement(t, 'inconsistency'),
          'text'
        );
        0 < a.length && (i.inconsistencyReason = new Array());
        for (var s, o, l, c, u = 0, m = a; u < m.length; u++) {
          var h = m[u];
          i.inconsistencyReason.push(h.textContent);
        }
        return (
          (i.inconsistencyFlag =
            null != i.inconsistencyReason && 0 < i.inconsistencyReason.length),
          null ==
            (r = this.queryChildElement(t, "geometryChecksum[aggr='1']")) &&
            (r = this.getChildElement(t, 'geometryChecksum')),
          null != r &&
            ((i.geometryId = r.getAttribute('value')),
            null != (r = this.getChildElement(t, 'geoTransformCksum')) &&
              null != i.geometryId &&
              ((s = atob(i.geometryId)),
              (o = atob(r.getAttribute('value'))),
              (l = btoa(s + o)),
              (i.geometryId = p.utils.string.trimRight(l, '=')))),
          p.utils.string.isNullOrEmpty(i.geometryId) ||
            ((i.geometryId = i.geometryId.replace(/\//g, '_')),
            (i.geometryId = i.geometryId.replace(/\+/g, '-'))),
          (i.mainArticleId = '00000000-0000-0000-0000-000000000000'),
          null == (r = this.getChildElement(t, 'mainItem')) ||
            (null != (c = r.getAttribute('id')) && (i.mainArticleId = c)),
          (i.subArticleIds = this.getSubArticleIds(e)),
          n
        );
      }),
      (i.prototype.getPriceComponents = function (e, t) {
        if (null == t) return null;
        var r = this.queryChildElement(
          t,
          "itemPriceComponents[type='" + e + "']"
        );
        if (null == r) return null;
        var n = r.getElementsByTagName('priceComponent');
        if (null == n || 0 === n.length) return null;
        for (var i = new Array(), a = 0; a < n.length; ++a) {
          var s,
            o,
            l = n.item(a);
          null != l &&
            ((s = this.getLangText('name', l)),
            ((o = new p.eaiws.basket.PriceComponent()).value = parseFloat(
              l.getAttribute('value')
            )),
            (o.name = null != s ? s : ''),
            i.push(o));
        }
        return i;
      }),
      (i.prototype.getFeatures = function (e) {
        if (null == e) return null;
        var t = this.getChildElement(e, 'features');
        if (null == t) return null;
        var r = t.getElementsByTagName('feature');
        if (null == r || 0 === r.length) return null;
        for (var n = new Array(), i = 0; i < r.length; ++i) {
          var a,
            s,
            o = r.item(i);
          null != o &&
            ((a = o.getAttribute('id')),
            p.utils.string.isNullOrEmpty(a) ||
              (null != (s = this.mArticleFeatures.get(a)) && n.push(s)));
        }
        return n;
      }),
      (i.prototype.getProperties = function (e) {
        if (null != e && null != e.features && null != e.features.length) {
          for (var t = new Array(), r = 0, n = e.features; r < n.length; r++) {
            var i = n[r],
              a = new p.eaiws.basket.Property();
            (a.propName = i.name),
              (a.propText = null != i.nameText ? i.nameText : ''),
              (a.value = new p.eaiws.basket.PropertyValue()),
              (a.value.value = i.value),
              (a.value.text = null != i.valueText ? i.valueText : ''),
              (a.visible = i.visible),
              t.push(a);
          }
          return t;
        }
      }),
      (i.prototype.getComposableGeometryData = function (e) {
        if (null == e) return null;
        var t = this.getChildElement(e, 'composableGeometry');
        if (null == t) return null;
        var r = new p.eaiws.basket.ComposableGeometryProperties();
        r.enabled = 'true' === t.getAttribute('enabled');
        var n = t.getAttribute('geometry');
        p.utils.string.isNullOrEmpty(n) || (r.geometry = n);
        var i = this.getChildElement(t, 'position');
        null != i &&
          ((r.position = new p.eaiws.basket.Vector3()),
          (r.position.x = parseFloat(i.getAttribute('x'))),
          (r.position.y = parseFloat(i.getAttribute('y'))),
          (r.position.z = parseFloat(i.getAttribute('z'))));
        var a,
          s,
          o = this.getChildElement(t, 'rotation');
        null != o &&
          ((a = new BABYLON.Quaternion(
            parseFloat(o.getAttribute('x')),
            parseFloat(o.getAttribute('y')),
            -parseFloat(o.getAttribute('z')),
            -parseFloat(o.getAttribute('w'))
          )),
          (s = p.utils.math.quaternionToAxisAngle(a)),
          (r.rotation = new p.eaiws.basket.Rotation()),
          (r.rotation.axis = new p.eaiws.basket.Vector3()),
          (r.rotation.axis.x = s.x),
          (r.rotation.axis.y = s.y),
          (r.rotation.axis.z = -s.z),
          (r.rotation.angle = -s.w));
        var l = this.getChildElement(t, 'scale');
        return (
          null != l &&
            ((r.scale = new p.eaiws.basket.Vector3()),
            (r.scale.x = parseFloat(l.getAttribute('x'))),
            (r.scale.y = parseFloat(l.getAttribute('y'))),
            (r.scale.z = parseFloat(l.getAttribute('z')))),
          r
        );
      }),
      (i.prototype.prepareFeatures = function () {
        var r = this;
        if (null != this.mItemRoot) {
          this.mArticleFeatures.clear();
          var e = this.mItemRoot.querySelectorAll('features > feature');
          if (null != e && 0 !== e.length) {
            for (var t = 0; t < e.length; ++t) {
              var n,
                i = e.item(t),
                a = i.getAttribute('id');
              p.utils.string.isNullOrEmpty(a) ||
                (((n = {}).name = i.getAttribute('name')),
                (n.value = i.getAttribute('value')),
                (n.visible = '1' === i.getAttribute('flags')),
                i.hasAttribute('nameText')
                  ? (n.refNameText = i.getAttribute('nameText'))
                  : (n.nameText = this.getLangText('nameText', i)),
                i.hasAttribute('valueText')
                  ? (n.refValueText = i.getAttribute('valueText'))
                  : (n.valueText = this.getLangText('valueText', i)),
                this.mArticleFeatures.set(a, n));
            }
            this.mArticleFeatures.forEach(function (e) {
              var t;
              p.utils.string.isNullOrEmpty(e.refNameText) ||
                (null != (t = r.mArticleFeatures.get(e.refNameText)) &&
                  (e.nameText = t.nameText)),
                p.utils.string.isNullOrEmpty(e.refValueText) ||
                  (null != (t = r.mArticleFeatures.get(e.refValueText)) &&
                    (e.valueText = t.valueText));
            });
          }
        }
      }),
      (i.prototype.getLangText = function (e, t) {
        if (null == t) return null;
        for (var r = 0, n = this.mLanguages; r < n.length; r++) {
          var i = n[r],
            a = this.queryChildElement(t, e + '[lang="' + i + '"]');
          if (null != a) return a.textContent;
        }
        var s = this.queryChildElement(t, e + '[lang=""]');
        return null != s || null != (s = this.getChildElement(t, e))
          ? s.textContent
          : null;
      }),
      (i.prototype.getAllItemIds = function () {
        var e = new Array();
        if (null == this.mItemRoot) return e;
        for (
          var t = this.mItemRoot.querySelectorAll('[basketId]'), r = 0;
          r < t.length;
          ++r
        ) {
          var n = t.item(r).getAttribute('basketId');
          p.utils.string.isNotNullOrEmpty(n) && e.push(n);
        }
        return e;
      }),
      (i.prototype.getSubArticleIds = function (e) {
        if (null == this.mItemRoot) return null;
        for (
          var t = new Array(),
            r = this.mItemRoot.querySelectorAll(
              "[basketId] > mainItem[id='" + e + "']"
            ),
            n = 0;
          n < r.length;
          ++n
        ) {
          var i,
            a = r.item(n).parentElement;
          null != a &&
            ((i = a.getAttribute('basketId')),
            p.utils.string.isNotNullOrEmpty(i) && t.push(i));
        }
        return t;
      }),
      (n = i),
      (r.ObkReader = n);
  })((egr = egr || {})),
  (function (e) {
    var I, y, h, t;
    function r(e) {
      this.mArticleManager = e;
    }
    (I = e.wcf || (e.wcf = {})),
      (y = I.cf || (I.cf = {})),
      (h = y.io || (y.io = {})),
      (r.prototype.import = function (r, n) {
        return (
          void 0 === n && (n = {}),
          __awaiter(this, void 0, void 0, function () {
            var t;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  if (null == r) throw new Error(I.utils.ERR_INVALID_ARGUMENT);
                  return [4, I.core.io.ZipDocumentContainer.LoadContainer(r)];
                case 1:
                  return (t = e.sent()), [2, this.importFromContainer(t, n)];
              }
            });
          })
        );
      }),
      (r.prototype.importFromContainer = function (n, i) {
        return (
          void 0 === i && (i = {}),
          __awaiter(this, void 0, void 0, function () {
            var t,
              r = this;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  if (null == n) throw new Error(I.utils.ERR_INVALID_ARGUMENT);
                  ((t = { itemProps: null }).loadedElements = new Array()),
                    (t.progress = new I.utils.Progress(i.onProgress, !0)),
                    (t.gfjLoader = new h.GfjLoader(
                      this.mArticleManager.app.model
                    )),
                    (t.gfjLoader.onResolveUrl = function (e) {
                      return r.resolveGfjUrl(e, t);
                    }),
                    (e.label = 1);
                case 1:
                  return (
                    e.trys.push([1, , 6, 7]),
                    this.mArticleManager.app.viewer.beginDisableRendering(),
                    t.progress.startSection(5),
                    (t.container = n),
                    [4, this.readPecXml(t, i.view)]
                  );
                case 2:
                  return (
                    e.sent(), t.progress.startSection(5), [4, this.importObx(t)]
                  );
                case 3:
                  return (
                    e.sent(),
                    t.progress.startSection(60),
                    [4, this.loadArticles(t, i.shouldUpdateCallback)]
                  );
                case 4:
                  return (
                    e.sent(),
                    t.progress.startSection(30),
                    [4, this.loadScene(t)]
                  );
                case 5:
                  return e.sent(), t.progress.setProgress(100), [3, 7];
                case 6:
                  return (
                    this.mArticleManager.app.viewer.requestRenderFrame(),
                    this.mArticleManager.app.viewer.endDisableRendering(),
                    [7]
                  );
                case 7:
                  return [2, t.loadedElements];
              }
            });
          })
        );
      }),
      (r.prototype.importFromCatalog = function (r, n) {
        return (
          void 0 === n && (n = {}),
          __awaiter(this, void 0, void 0, function () {
            var t;
            return __generator(this, function (e) {
              switch (e.label) {
                case 0:
                  if (null == r) throw new Error(I.utils.ERR_INVALID_ARGUMENT);
                  ((t = { itemProps: null }).loadedElements = new Array()),
                    (t.progress = new I.utils.Progress(n.onProgress, !0)),
                    (t.gfjLoader = new h.GfjLoader(
                      this.mArticleManager.app.model
                    )),
                    (e.label = 1);
                case 1:
                  return (
                    e.trys.push([1, , 5, 6]),
                    this.mArticleManager.app.viewer.beginDisableRendering(),
                    t.progress.startSection(10),
                    [4, this.pasteContainerItem(t, r)]
                  );
                case 2:
                  return (
                    e.sent(),
                    t.progress.startSection(60),
                    [4, this.loadArticles(t, n.shouldUpdateCallback)]
                  );
                case 3:
                  return (
                    e.sent(),
                    t.progress.startSection(30),
                    [4, this.loadScene(t)]
                  );
                case 4:
                  return e.sent(), t.progress.setProgress(100), [3, 6];
                case 5:
                  return (
                    this.mArticleManager.app.viewer.requestRenderFrame(),
                    this.mArticleManager.app.viewer.endDisableRendering(),
                    [7]
                  );
                case 6:
                  return [2, t.loadedElements];
              }
            });
          })
        );
      }),
      (r.prototype.readPecXml = function (d, g) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l, c, u, m, h, p;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (null == d.container)
                  throw I.utils.newError(
                    I.utils.ERR_INVALID_STATE,
                    'container is null'
                  );
                return [4, d.container.getFile('pec.xml', !1)];
              case 1:
                if (
                  ((t = e.sent()),
                  (r = new DOMParser()),
                  null == (n = r.parseFromString(t, 'application/xml')) ||
                    null == n.documentElement)
                )
                  throw new Error('Failed to read pec.xml.');
                if ('pec' !== (i = n.documentElement).tagName)
                  throw new Error('Invalid root element in pec.xml.');
                if (
                  ((d.uriResourcePathMap = new Map()),
                  (d.gfjResourcePathMap = new Map()),
                  null != (a = i.querySelectorAll('resources > resource')))
                )
                  for (s = 0; s < a.length; ++s)
                    (o = a.item(s)),
                      null != (l = o.querySelector('path')) &&
                        ((c = l.textContent),
                        I.utils.string.isNullOrEmpty(c) ||
                          ((u = c.endsWith('.gfj')),
                          (p = o.getAttribute('uri')),
                          I.utils.string.isNullOrEmpty(p) ||
                            (d.uriResourcePathMap.set(p, c),
                            u && d.gfjResourcePathMap.set(p, c)),
                          (m = o.getAttribute('geometryChecksum')),
                          !I.utils.string.isNullOrEmpty(m) &&
                            u &&
                            d.gfjResourcePathMap.set(m, c)));
                return (
                  null != (h = i.querySelector('scene')) &&
                    ((p = h.getAttribute('uri')),
                    I.utils.string.isNotNullOrEmpty(p) &&
                      (d.sceneGfjUrl = d.gfjResourcePathMap.get(p))),
                  null != g && this.loadCamera(g, i),
                  [2]
                );
            }
          });
        });
      }),
      (r.prototype.loadCamera = function (e, t) {
        var r,
          n,
          i,
          a,
          s,
          o = t.querySelector('camera');
        null != o &&
          ('orthographic' === o.getAttribute('type')
            ? ((e.cameraControl.cameraMode = 6),
              null != (r = o.querySelector('orthoY')) &&
                e.cameraControl.setCameraOrtho(
                  parseFloat(r.getAttribute('value'))
                ))
            : (e.cameraControl.cameraMode = 7),
          null != (n = o.querySelector('position')) &&
            (((i = BABYLON.Vector3.Zero()).x = parseFloat(n.getAttribute('x'))),
            (i.y = parseFloat(n.getAttribute('y'))),
            (i.z = -parseFloat(n.getAttribute('z'))),
            e.cameraControl.setPosition(i)),
          null != (a = o.querySelector('direction')) &&
            (((s = BABYLON.Vector3.Zero()).x = parseFloat(a.getAttribute('x'))),
            (s.y = parseFloat(a.getAttribute('y'))),
            (s.z = -parseFloat(a.getAttribute('z'))),
            e.cameraControl.setDirection(s)));
      }),
      (r.prototype.importObx = function (m) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l, c, u;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if ((e.trys.push([0, 10, , 11]), null == m.container))
                  throw I.utils.newError(
                    I.utils.ERR_INVALID_STATE,
                    'container is null'
                  );
                return [4, m.container.getFile('document.obx', !0)];
              case 1:
                return (
                  (t = e.sent()),
                  (r = new Blob([t])),
                  (n = this.mArticleManager.session).isValid
                    ? [4, n.uploadFile('CutBuffer', r)]
                    : [3, 7]
                );
              case 2:
                if (((i = e.sent()), I.utils.string.isNullOrEmpty(i)))
                  throw new Error('Failed to upload obx.');
                return [
                  4,
                  n.basket.paste(this.mArticleManager.fatherItemId, null, i),
                ];
              case 3:
                return null == (a = e.sent()) || 0 === a.length
                  ? [2]
                  : [4, n.deleteFile(i)];
              case 4:
                return (
                  e.sent(),
                  ((s = new I.eaiws.basket.GetAllItemsOptions()).subItems = !0),
                  (s.wholeComposite = !0),
                  (s.geometryIds = !0),
                  (s.setArticleIds = !0),
                  (o = m),
                  [4, n.basket.getAllItems(a, s)]
                );
              case 5:
                return (
                  (o.items = e.sent()),
                  (l = m),
                  [4, n.basket.getItemProperties(a, s)]
                );
              case 6:
                return (l.itemProps = e.sent()), [3, 9];
              case 7:
                return [4, (c = new h.ObkReader())._loadObx(r)];
              case 8:
                e.sent(),
                  (m.items = c.getAllItems()),
                  (m.itemProps = c.getAllItemProperties()),
                  (e.label = 9);
              case 9:
                return [3, 11];
              case 10:
                if (!((u = e.sent()) instanceof I.core.io.FileNotFoundError))
                  throw u;
                return [3, 11];
              case 11:
                return [2];
            }
          });
        });
      }),
      (r.prototype.pasteContainerItem = function (g, f) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l, c, u, m, h, p, d;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if ('Container' !== f.type)
                  throw new Error('Invalid catalog item type.');
                if ((t = null) != f.resources)
                  for (r = 0, n = f.resources; r < n.length; r++)
                    if ('XCF:PEC' === (i = n[r]).type) {
                      t = i.value;
                      break;
                    }
                if (I.utils.string.isNullOrEmpty(t))
                  throw new Error(
                    'Catalog item does not have XCF:PEC resource.'
                  );
                return (
                  (a = this.mArticleManager.session),
                  ((s = new I.eaiws.basket.PasteContainerOptions()).setArticleIds = !0),
                  (s.geometryIds = !0),
                  [4, a.basket.pasteContainer(null, null, t, s)]
                );
              case 1:
                if (null == (o = e.sent())) return [2];
                if (
                  ((l = new Array()),
                  (c = new Array()),
                  null != o.items && null != o.itemGeometries)
                )
                  for (h = 0; h < o.items.length; ++h)
                    l.push(o.items[h].itemId),
                      (u = o.itemGeometries[h]),
                      I.utils.string.isNullOrEmpty(u)
                        ? c.push('imp:00000000000000000000000000000000')
                        : c.push(u);
                return (
                  (g.basketIdGfjMap = new Map()),
                  I.utils.string.isNullOrEmpty(o.sceneGeometry) ||
                    c.push(o.sceneGeometry),
                  [4, a.session.resolveURIs(c)]
                );
              case 2:
                for (m = e.sent(), h = 0; h < l.length; ++h)
                  g.basketIdGfjMap.set(l[h], m[h]);
                return (
                  I.utils.string.isNullOrEmpty(o.sceneGeometry) ||
                    (g.sceneGfjUrl = m[m.length - 1]),
                  ((p = new I.eaiws.basket.GetAllItemsOptions()).subItems = !0),
                  (p.wholeComposite = !0),
                  (p.geometryIds = !0),
                  (p.setArticleIds = !0),
                  (g.items = o.items),
                  (d = g),
                  [4, a.basket.getItemProperties(l, p)]
                );
              case 3:
                return (d.itemProps = e.sent()), [2];
            }
          });
        });
      }),
      (r.prototype.loadArticles = function (A, b) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l, c, u, m, h, p, d, g, f;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return null == A.itemProps ||
                  0 === A.itemProps.length ||
                  null == A.items ||
                  0 === A.items.length
                  ? [2]
                  : null == A.gfjResourcePathMap ||
                    0 !== A.gfjResourcePathMap.size
                  ? [3, 2]
                  : [
                      4,
                      y.ArticleImport.Import(
                        this.mArticleManager,
                        A.items,
                        A.itemProps,
                        !1,
                        {
                          shouldUpdateCallback: b,
                        }
                      ),
                    ];
              case 1:
                return (
                  null != (t = e.sent()) &&
                    I.utils.array.addElements(A.loadedElements, t),
                  [2]
                );
              case 2:
                for (r = new Array(), n = 0, i = A.itemProps; n < i.length; n++)
                  null != (o = i[n]).article &&
                    null != o.composableGeometry &&
                    o.composableGeometry.enabled &&
                    r.push(o);
                if (0 === r.length) return [2];
                for (
                  A.itemPropsMap = new Map(), a = 0, s = A.itemProps;
                  a < s.length;
                  a++
                )
                  (o = s[a]), A.itemPropsMap.set(o.itemId, o);
                for (
                  A.itemsMap = new Map(), l = 0, c = A.items;
                  l < c.length;
                  l++
                )
                  (u = c[l]), A.itemsMap.set(u.itemId, u);
                (m = 100 / r.length), (h = 0), (p = r), (e.label = 3);
              case 3:
                if (!(h < p.length)) return [3, 9];
                (d = p[h]), (e.label = 4);
              case 4:
                return e.trys.push([4, 6, , 7]), [4, this.loadArticle(d, A)];
              case 5:
                return (
                  null != (g = e.sent()) && A.loadedElements.push(g), [3, 7]
                );
              case 6:
                return (
                  (f = e.sent()),
                  I.utils.Log.error('Failed to load article ' + d.itemId, f),
                  [3, 7]
                );
              case 7:
                A.progress.setProgress(A.progress.sectionProgress + m),
                  (e.label = 8);
              case 8:
                return h++, [3, 3];
              case 9:
                return [2];
            }
          });
        });
      }),
      (r.prototype.loadArticle = function (h, p) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s, o, l, c, u, m;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (
                  ((t = this.mArticleManager.session),
                  (r = this.getArticleGfjPath(h, p)),
                  I.utils.string.isNullOrEmpty(r))
                )
                  throw new Error('gfj path not found');
                return (
                  (n = this.mArticleManager._getCompositeItems(
                    h.itemId,
                    p.itemsMap
                  )),
                  [4, p.gfjLoader.load(r, h.itemId, n, p.container)]
                );
              case 1:
                for (
                  i = e.sent(),
                    (a = null) != i && 0 < i.length && (a = i[0]),
                    s = null,
                    s =
                      'UserArticle' === h.itemType
                        ? new y.UserArticleElement(
                            h.itemId,
                            this.mArticleManager,
                            a
                          )
                        : new y.MainArticleElement(
                            h.itemId,
                            this.mArticleManager,
                            a
                          ),
                    o = new Array(),
                    l = 0,
                    c = n;
                  l < c.length;
                  l++
                )
                  (u = c[l]),
                    null != (m = p.itemPropsMap.get(u.itemId)) && o.push(m);
                return (
                  s.fillItemPropertiesCache(o),
                  t.isValid && s instanceof y.UserArticleElement
                    ? [4, s._resetImpGeometry()]
                    : [3, 3]
                );
              case 2:
                e.sent(), (e.label = 3);
              case 3:
                return null != s.node
                  ? [3, 5]
                  : [4, s._initPlaceholderGeometry(n)];
              case 4:
                e.sent(), (e.label = 5);
              case 5:
                return s._loadEaiwsTransform(h.composableGeometry), [2, s];
            }
          });
        });
      }),
      (r.prototype.getArticleGfjPath = function (e, t) {
        if (null != t.basketIdGfjMap) return t.basketIdGfjMap.get(e.itemId);
        if (null == t.gfjResourcePathMap) return null;
        if ('UserArticle' === e.itemType) {
          var r = e.composableGeometry.geometry;
          if (null == r) throw new Error('missing geometry for user article');
          return t.gfjResourcePathMap.get(r);
        }
        var n = this.normalizeBase64(e.article.geometryId);
        if (I.utils.string.isNullOrEmpty(n))
          throw new Error('missing geometryId');
        return t.gfjResourcePathMap.get(n);
      }),
      (r.prototype.loadScene = function (o) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r, n, i, a, s;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (I.utils.string.isNullOrEmpty(o.sceneGfjUrl)) return [2];
                e.label = 1;
              case 1:
                return (
                  e.trys.push([1, 3, , 4]),
                  [4, o.gfjLoader.load(o.sceneGfjUrl, null, null, o.container)]
                );
              case 2:
                if (null != (t = e.sent()) && 0 < t.length)
                  for (r = 0, n = t; r < n.length; r++)
                    null != (i = n[r]) &&
                      ((a = new I.core.mdl.BasicElement(
                        this.mArticleManager.app.model,
                        i
                      )),
                      o.loadedElements.push(a));
                return [3, 4];
              case 3:
                if (!((s = e.sent()) instanceof I.core.io.FileNotFoundError))
                  throw s;
                return [3, 4];
              case 4:
                return [2];
            }
          });
        });
      }),
      (r.prototype.resolveGfjUrl = function (e, t) {
        if (null == e) return '';
        if (null != t.uriResourcePathMap && e.startsWith('imp:')) {
          var r = t.uriResourcePathMap.get(e);
          return null != r ? r : '';
        }
        return e;
      }),
      (r.prototype.normalizeBase64 = function (e) {
        if (null == e) return null;
        var t = e;
        return (t = (t = t.replace(/_/g, '/')).replace(/-/g, '+'));
      }),
      (t = r),
      (h.PecImport = t);
  })((egr = egr || {})),
  (function (e) {
    var b, I;
    function y(r, n, i, a, s) {
      return __awaiter(this, void 0, void 0, function () {
        var t;
        return __generator(this, function (e) {
          switch (e.label) {
            case 0:
              if (null == n || null == i || 0 === i.length) return [2];
              e.label = 1;
            case 1:
              return (
                e.trys.push([1, 3, 4, 5]),
                v(r),
                [
                  4,
                  (function h(p, d, g, f, A) {
                    return __awaiter(this, void 0, void 0, function () {
                      var t, r, n, i, a, s, o, l, c, u, m;
                      return __generator(this, function (e) {
                        switch (e.label) {
                          case 0:
                            return null == d || null == g || 0 === g.length
                              ? [2]
                              : [4, d.ensureIsInstanced()];
                          case 1:
                            return (e.sent(), null == d.basketId)
                              ? [
                                  2,
                                  b.utils.rejectError(
                                    b.utils.ERR_INVALID_STATE,
                                    'basketId is null'
                                  ),
                                ]
                              : (((t = new b.eaiws.basket.OAPActionContext()).self =
                                  d.basketId),
                                (t.dpr = 1.5 < window.devicePixelRatio ? 2 : 1),
                                null != f &&
                                  (t.interactor = f.oapInteractor.id),
                                [
                                  4,
                                  p.session.basket.oapProcessActions(g, !0, t),
                                ]);
                          case 2:
                            if (null == (r = e.sent()) || 0 === r.length)
                              throw new Error('Failed to execute oap actions.');
                            for (
                              n = !1, i = null, a = new Array(), s = 0;
                              s < r.length;
                              ++s
                            ) {
                              if ('Failure' === (o = r[s]).state)
                                throw new Error('Action ' + o.id + ' failed');
                              if ('NotResponsible' === o.state) {
                                i = s;
                                break;
                              }
                              P(o)
                                ? a.push(o)
                                : (n =
                                    n ||
                                    (null != o.addedItems &&
                                      0 < o.addedItems.length) ||
                                    (null != o.movedItems &&
                                      0 < o.movedItems.length) ||
                                    (null != o.removedItems &&
                                      0 < o.removedItems.length) ||
                                    (null != o.updatedItems &&
                                      0 < o.updatedItems.length));
                            }
                            return (
                              (l = null) != i && (l = g.slice(i + 1)),
                              [4, E(p, a)]
                            );
                          case 3:
                            return (e.sent() && (n = !0), n)
                              ? ((c = d.getMainArticle())._clearCachedArticleInfo(
                                  c,
                                  !0
                                ),
                                [4, c.updateGeometry()])
                              : [3, 5];
                          case 4:
                            e.sent(),
                              p._notifyArticleChanged(c, !0),
                              d.isInScene() && d.notifyChange(16),
                              (e.label = 5);
                          case 5:
                            return ((u = !0), null == i)
                              ? [3, 7]
                              : ((m = r[i]), [4, C(p, d, m, f, l, A)]);
                          case 6:
                            (u = e.sent()), (e.label = 7);
                          case 7:
                            return u && null != l && 0 < l.length
                              ? [4, h(p, d, l, f)]
                              : [3, 9];
                          case 8:
                            e.sent(), (e.label = 9);
                          case 9:
                            return [2];
                        }
                      });
                    });
                  })(r, n, i, a, s),
                ]
              );
            case 2:
              return e.sent(), [3, 5];
            case 3:
              return (
                (t = e.sent()),
                b.utils.Log.error('Failed to execute oap actions', t),
                [3, 5]
              );
            case 4:
              return w(r), [7];
            case 5:
              return [2];
          }
        });
      });
    }
    function v(e) {
      null != e.app.appCallbacks.beginAsyncOperation &&
        e.app.appCallbacks.beginAsyncOperation(),
        e.app.model.beginModification(),
        e.app.model.beginSelectionChange();
    }
    function w(e) {
      null != e.app.appCallbacks.endAsyncOperation &&
        e.app.appCallbacks.endAsyncOperation(),
        e.app.model.endSelectionChange(),
        e.app.model.endModification();
    }
    function C(r, n, i, a, s, o) {
      return __awaiter(this, void 0, void 0, function () {
        var t;
        return __generator(this, function (e) {
          switch (e.label) {
            case 0:
              return null == i.actionData
                ? [2, !1]
                : (t = i.actionData) instanceof
                  b.eaiws.basket.OAPActionChoiceAction
                ? [
                    4,
                    (function l(c, u, m, h, p, d, g) {
                      return __awaiter(this, void 0, void 0, function () {
                        var t, r, n, i, a, s, o;
                        return __generator(this, function (e) {
                          if (0 === m.actions.length) return [2];
                          for (
                            null != g && 0 < g.length
                              ? ((r = b.utils.array.clone(g)),
                                (t = function () {
                                  var e = b.utils.array.clone(g),
                                    t = e.pop();
                                  l(
                                    c,
                                    u,
                                    t.oapAction,
                                    h,
                                    t.subsequentActions,
                                    d,
                                    e
                                  );
                                }))
                              : (r = new Array()),
                              r.push({ oapAction: m, subsequentActions: p }),
                              n = new Array(),
                              i = function (t) {
                                var e = {};
                                (e.text = t.text),
                                  (e.image = t.imageFile),
                                  (e.execute = function () {
                                    var e;
                                    return (
                                      (e =
                                        null != t.actionIds
                                          ? t.actionIds
                                          : null != t.action
                                          ? [t.action.id]
                                          : []),
                                      null != p &&
                                        0 < p.length &&
                                        e.push.apply(e, p),
                                      y(c, u, e, h, r)
                                    );
                                  }),
                                  n.push(e);
                              },
                              a = 0,
                              s = m.actions;
                            a < s.length;
                            a++
                          )
                            (o = s[a]), i(o);
                          return (
                            setTimeout(function () {
                              if (null != c.app.appCallbacks.showActionChoice) {
                                var e = void 0;
                                if (null != m.tileSize)
                                  switch (m.tileSize) {
                                    case 'Large':
                                      e = 'large';
                                      break;
                                    case 'Medium':
                                      e = 'medium';
                                      break;
                                    default:
                                      e = 'small';
                                  }
                                c.app.appCallbacks.showActionChoice(n, {
                                  title: m.title,
                                  displayMode:
                                    'List' === m.viewType ? 'list' : 'tile',
                                  tileSize: e,
                                  originReference:
                                    null != h
                                      ? h.cachedBoundingClientRect
                                      : void 0,
                                  goBack: t,
                                });
                              }
                            }),
                            [2]
                          );
                        });
                      });
                    })(r, n, t, a, s, i.objects, o),
                  ]
                : [3, 2];
            case 1:
              return e.sent(), [2, !1];
            case 2:
              return t instanceof b.eaiws.basket.OAPPropEditAction
                ? [
                    4,
                    (function (p, d, g, f, A, i) {
                      return __awaiter(this, void 0, void 0, function () {
                        var t,
                          h,
                          r,
                          n = this;
                        return __generator(this, function (e) {
                          switch (e.label) {
                            case 0:
                              return null == g.objects || 1 !== g.objects.length
                                ? [2]
                                : [4, _(p, g.objects, i, d)];
                            case 1:
                              return null == (t = e.sent()) || t.length < 1
                                ? (b.utils.Log.warn(
                                    'Failed to find prop edit target.'
                                  ),
                                  [2])
                                : ((h = t[0]),
                                  (r = function () {
                                    return __awaiter(
                                      n,
                                      void 0,
                                      void 0,
                                      function () {
                                        var t,
                                          r,
                                          n,
                                          i,
                                          a,
                                          s,
                                          o,
                                          l,
                                          c,
                                          u,
                                          m = this;
                                        return __generator(this, function (e) {
                                          switch (e.label) {
                                            case 0:
                                              return (
                                                (t = new Array()),
                                                null == h
                                                  ? [2, t]
                                                  : [4, h.getProperties()]
                                              );
                                            case 1:
                                              if (null == (r = e.sent()))
                                                return [2, t];
                                              for (
                                                n = 0, i = r;
                                                n < i.length;
                                                n++
                                              )
                                                (u = i[n]),
                                                  (a = !1),
                                                  null !=
                                                    (s = I.ArticleElement.GetEaiwsProperty(
                                                      u
                                                    )) &&
                                                    (null != g.properties &&
                                                      (a = b.utils.array.contains(
                                                        g.properties,
                                                        s.propName
                                                      )),
                                                    a ||
                                                      null ==
                                                        g.propertyClasses ||
                                                      (a = b.utils.array.contains(
                                                        g.propertyClasses,
                                                        s.propClass
                                                      ))),
                                                  a && t.push(u);
                                              if (1 === t.length)
                                                (o = t[0].setValue),
                                                  (t[0].setValue = function (
                                                    r
                                                  ) {
                                                    return __awaiter(
                                                      m,
                                                      void 0,
                                                      void 0,
                                                      function () {
                                                        var t;
                                                        return __generator(
                                                          this,
                                                          function (e) {
                                                            switch (e.label) {
                                                              case 0:
                                                                return (
                                                                  e.trys.push([
                                                                    0,
                                                                    ,
                                                                    2,
                                                                    3,
                                                                  ]),
                                                                  v(p),
                                                                  [4, o(r)]
                                                                );
                                                              case 1:
                                                                return (
                                                                  (t = e.sent()),
                                                                  null != A &&
                                                                    0 <
                                                                      A.length &&
                                                                    y(
                                                                      p,
                                                                      d,
                                                                      A,
                                                                      f
                                                                    ),
                                                                  [3, 3]
                                                                );
                                                              case 2:
                                                                return (
                                                                  w(p), [7]
                                                                );
                                                              case 3:
                                                                return [2, t];
                                                            }
                                                          }
                                                        );
                                                      }
                                                    );
                                                  }),
                                                  (t[0].visible = !0),
                                                  (t[0].editable = !0);
                                              else
                                                for (
                                                  l = 0, c = t;
                                                  l < c.length;
                                                  l++
                                                )
                                                  (u = c[l]).visible =
                                                    (u.visible ||
                                                      !g.visibleOnly) &&
                                                    (u.editable ||
                                                      !g.editableOnly);
                                              return [2, t];
                                          }
                                        });
                                      }
                                    );
                                  }),
                                  setTimeout(function () {
                                    null != h &&
                                      null !=
                                        p.app.appCallbacks.showPropertyEditor &&
                                      p.app.appCallbacks.showPropertyEditor(
                                        h,
                                        r,
                                        {
                                          title: g.title,
                                          originReference:
                                            null != f
                                              ? f.cachedBoundingClientRect
                                              : void 0,
                                        }
                                      );
                                  }),
                                  [2]);
                          }
                        });
                      });
                    })(r, n, t, a, s, i.objects),
                  ]
                : [3, 4];
            case 3:
              return e.sent(), [2, !1];
            case 4:
              return t instanceof b.eaiws.basket.OAPCreateObjectAction
                ? [
                    4,
                    (function (u, m, h) {
                      return __awaiter(this, void 0, void 0, function () {
                        var t, r, n, i, a, s, o, l, c;
                        return __generator(this, function (e) {
                          switch (e.label) {
                            case 0:
                              return 'Self' === h.articleSpecMode
                                ? (b.utils.Log.warn(
                                    "articleSpecMode 'Self' not implemented"
                                  ),
                                  [2])
                                : null == h.baseArticleNumber
                                ? (b.utils.Log.warn(
                                    'missing baseArticleNumber'
                                  ),
                                  [2])
                                : [4, d(h.parent, m)];
                            case 1:
                              return ((t = e.sent()),
                              (r = null != t ? t.basketId : null),
                              (n = null),
                              ((i = new b.eaiws.basket.InsertInfo()).articlePackageId =
                                h.packageId),
                              (i.baseArticleNumber = h.baseArticleNumber),
                              (i.ofmlVariantCode = h.ofmlVariantCode),
                              (a = new b.eaiws.basket.InsertArticleOptions()),
                              h.initialPlacement instanceof
                                b.eaiws.basket.OAPDataDefinedPlacement)
                                ? ((a.attachPoint =
                                    h.initialPlacement.attachPoint),
                                  (a.attachmentMode =
                                    null != t ? 'Composite' : 'None'),
                                  [4, d(h.initialPlacement.referenceObject, m)])
                                : [3, 3];
                            case 2:
                              return (
                                null != (s = e.sent()) && (n = s.basketId),
                                [3, 4]
                              );
                            case 3:
                              h.initialPlacement instanceof
                                b.eaiws.basket.OAPAttachAreasPlacement &&
                                b.utils.Log.warn(
                                  'OAPAttachAreasPlacement not implemented'
                                ),
                                (e.label = 4);
                            case 4:
                              return [
                                4,
                                u.session.basket.insertOFMLArticle(r, n, i, a),
                              ];
                            case 5:
                              return (
                                (o = e.sent()),
                                null != t ? [3, 8] : [4, u.createArticleById(o)]
                              );
                            case 6:
                              return (l = e.sent()), [4, p(u, l, null)];
                            case 7:
                              return e.sent(), [3, 10];
                            case 8:
                              return [
                                4,
                                (c = t.getMainArticle()).updateGeometry(),
                              ];
                            case 9:
                              e.sent(),
                                c.notifyArticleChanged(c, !0),
                                (e.label = 10);
                            case 10:
                              return [2];
                          }
                        });
                      });
                    })(r, n, t),
                  ]
                : [3, 6];
            case 5:
              return e.sent(), [2, !0];
            case 6:
              return t instanceof b.eaiws.basket.OAPDeleteObjectAction
                ? [
                    4,
                    (function (m, h, p, d) {
                      return __awaiter(this, void 0, void 0, function () {
                        var t, r, n, i, a, s, o, l, c, u;
                        return __generator(this, function (e) {
                          switch (e.label) {
                            case 0:
                              return [4, _(m, p.objects, d, h)];
                            case 1:
                              if (null == (t = e.sent()) || 0 === t.length)
                                return [2];
                              for (
                                r = new Array(),
                                  n = new Array(),
                                  i = new Array(),
                                  a = 0,
                                  s = t;
                                a < s.length;
                                a++
                              )
                                (o = s[a]) instanceof I.MainArticleElement
                                  ? i.push(o)
                                  : null != o.basketId &&
                                    (r.push(o), n.push(o.basketId));
                              return 0 < r.length
                                ? (((l = new b.eaiws.basket.DeleteItemsOptions()).subArticles = !0),
                                  [4, m.session.basket.deleteItems(n, l)])
                                : [3, 4];
                            case 2:
                              return (
                                e.sent(),
                                [4, (c = h.getMainArticle()).updateGeometry()]
                              );
                            case 3:
                              e.sent(),
                                c.notifyArticleChanged(c, !0),
                                (e.label = 4);
                            case 4:
                              return 0 < i.length
                                ? ((u = new b.core.cmd.DeleteElements(
                                    m.app,
                                    i
                                  )),
                                  [4, m.app.commands.executeCommand(u)])
                                : [3, 6];
                            case 5:
                              e.sent(), (e.label = 6);
                            case 6:
                              return [2];
                          }
                        });
                      });
                    })(r, n, t, i.objects),
                  ]
                : [3, 8];
            case 7:
              return e.sent(), [2, !0];
            case 8:
              return t instanceof b.eaiws.basket.OAPSelectObjectAction
                ? [
                    4,
                    (function (a, s, o, l) {
                      return __awaiter(this, void 0, void 0, function () {
                        var t, r, n, i;
                        return __generator(this, function (e) {
                          switch (e.label) {
                            case 0:
                              return [4, _(a, o.objects, l, s)];
                            case 1:
                              return null == (t = e.sent()) || 0 === t.length
                                ? [2]
                                : ((r = t[0]),
                                  (n = r.getMainArticle()),
                                  (i = null),
                                  n !== r &&
                                    r instanceof I.SubArticleElement &&
                                    (i = r),
                                  null != n &&
                                    (a.app.model.setSelection([n]),
                                    null != i &&
                                      a.app.model.setSubElementSelection(n, i)),
                                  [2]);
                          }
                        });
                      });
                    })(r, n, t, i.objects),
                  ]
                : [3, 10];
            case 9:
              return e.sent(), [2, !1];
            case 10:
              return (
                b.utils.Log.warn(
                  'OAPAction not implemented: ' + JSON.stringify(t)
                ),
                [2, !1]
              );
          }
        });
      });
    }
    function _(u, m, h, p) {
      return __awaiter(this, void 0, void 0, function () {
        var t, r, n, i, a, s, o, l, c;
        return __generator(this, function (e) {
          switch (e.label) {
            case 0:
              if (null != h && 0 < h.length) {
                for (
                  s = new Array(), t = p.getMainArticle(), r = 0, n = h;
                  r < n.length;
                  r++
                )
                  (i = n[r]) === p.basketId
                    ? s.push(p)
                    : i === t.basketId
                    ? s.push(t)
                    : null != (a = t.getSubArticleById(i))
                    ? s.push(a)
                    : null != (c = u.getArticleById(i)) && s.push(c);
                return [2, s];
              }
              if (!(null != m && 0 < m.length)) return [3, 5];
              (s = new Set()), (o = 0), (l = m), (e.label = 1);
            case 1:
              return o < l.length ? [4, d(l[o], p)] : [3, 4];
            case 2:
              null != (c = e.sent()) && s.add(c), (e.label = 3);
            case 3:
              return o++, [3, 1];
            case 4:
              return [2, Array.from(s)];
            case 5:
              return [2, null];
          }
        });
      });
    }
    function d(r, n) {
      return __awaiter(this, void 0, void 0, function () {
        var t;
        return __generator(this, function (e) {
          switch (e.label) {
            case 0:
              if (null == r || null == n) return [2, null];
              switch (((t = null), r.category)) {
                case 'Self':
                  t = n;
                  break;
                case 'TopArticle':
                  t = n.getMainArticle();
                  break;
                case 'ParentArticle':
                  t = n.getParentArticle();
                  break;
                default:
                  b.utils.Log.warn(
                    'OAPObjectDefinition not implemented: ' + r.category
                  );
              }
              return null == t ? [3, 2] : [4, t.ensureIsInstanced()];
            case 1:
              e.sent(), (e.label = 2);
            case 2:
              return [2, t];
          }
        });
      });
    }
    function P(e) {
      return (
        null != e.actionData &&
        e.actionData instanceof b.eaiws.basket.OAPCreateObjectAction &&
        null == e.actionData.parent &&
        null != e.referenceObject &&
        !(null == e.addedItems || e.addedItems.length <= 0) &&
        e.actionData.initialPlacement instanceof
          b.eaiws.basket.OAPAttachAreasPlacement
      );
    }
    function E(a, s) {
      return __awaiter(this, void 0, void 0, function () {
        var t, r, n, i;
        return __generator(this, function (e) {
          switch (e.label) {
            case 0:
              (t = !1), (r = 0), (n = s), (e.label = 1);
            case 1:
              return r < n.length
                ? ((i = n[r]),
                  a.app.commands.beginUndoSection(),
                  [
                    4,
                    (function (u, m) {
                      return __awaiter(this, void 0, void 0, function () {
                        var t, r, n, i, a, s, o, l, c;
                        return __generator(this, function (e) {
                          switch (e.label) {
                            case 0:
                              (t = !1), (e.label = 1);
                            case 1:
                              return (e.trys.push([1, 6, , 7]),
                              null != m.addedItems && 0 < m.addedItems.length)
                                ? (((r = new b.eaiws.basket.GetAllItemsOptions()).wholeComposite = !0),
                                  (r.geometryIds = !0),
                                  (r.setArticleIds = !0),
                                  (n = void 0),
                                  [
                                    4,
                                    u.session.basket.getAllItems(
                                      m.addedItems,
                                      r
                                    ),
                                  ])
                                : [3, 5];
                            case 2:
                              for (
                                i = e.sent(), a = 0, s = i;
                                a < s.length;
                                a++
                              )
                                (o = s[a]).getMainArticleId() === o.itemId &&
                                  o.itemId !== m.referenceObject &&
                                  (n = o.itemId),
                                  null != m.referenceObject &&
                                    o.getMainArticleId() ===
                                      m.referenceObject &&
                                    (t = !0);
                              if (null == n)
                                throw b.utils.newError(
                                  b.utils.ERR_FAILED,
                                  'main article not found'
                                );
                              return [4, u.createArticleById(n, !1, i)];
                            case 3:
                              return (
                                (l = e.sent()),
                                [
                                  4,
                                  p(
                                    u,
                                    l,
                                    (function (e, t) {
                                      if (null == t.referenceObject)
                                        return null;
                                      var r = e.getArticleById(
                                        t.referenceObject
                                      );
                                      if (null == r) return null;
                                      var n = I.Helpers.Vector3FromEaiwsVector(
                                          t.newObjectPosition
                                        ),
                                        i = I.Helpers.QuaternionFromEaiwsRotation(
                                          t.newObjectRotation
                                        ),
                                        a = BABYLON.Matrix.Compose(
                                          new BABYLON.Vector3(1, 1, 1),
                                          i,
                                          n
                                        );
                                      return (
                                        a.multiplyToRef(r.worldTransform, a), a
                                      );
                                    })(u, m)
                                  ),
                                ]
                              );
                            case 4:
                              e.sent(), (e.label = 5);
                            case 5:
                              return [3, 7];
                            case 6:
                              return (
                                (c = e.sent()),
                                b.utils.Log.error(b.utils.ERR_FAILED, c),
                                [3, 7]
                              );
                            case 7:
                              return [
                                2,
                                t ||
                                  (null != m.movedItems &&
                                    0 < m.movedItems.length) ||
                                  (null != m.removedItems &&
                                    0 < m.removedItems.length) ||
                                  (null != m.updatedItems &&
                                    0 < m.updatedItems.length),
                              ];
                          }
                        });
                      });
                    })(a, i),
                  ])
                : [3, 4];
            case 2:
              e.sent() && (t = !0),
                a.app.commands.endUndoSection(),
                (e.label = 3);
            case 3:
              return r++, [3, 1];
            case 4:
              return [2, t];
          }
        });
      });
    }
    function p(n, i, a) {
      return __awaiter(this, void 0, void 0, function () {
        var t, r;
        return __generator(this, function (e) {
          switch (e.label) {
            case 0:
              return (
                (t = [i]),
                null != a && i.setTransform(a),
                (r = new b.core.cmd.InsertElements(n.app, t)),
                [4, n.app.commands.executeCommand(r)]
              );
            case 1:
              return e.sent(), n.app.model.setSelection(t), [2];
          }
        });
      });
    }
    (b = e.wcf || (e.wcf = {})),
      (((I = b.cf || (b.cf = {})).oap || (I.oap = {})).executeActions = y);
  })((egr = egr || {})),
  (function (e) {
    var h, t;
    (h = e.wcf || (e.wcf = {})),
      (function (n) {
        var s,
          e =
            ((s = h.core.tool.AbstractTool),
            __extends(t, s),
            (t.prototype.start = function (e) {
              return (
                (this.mView = this.mApp.viewer.activeView),
                this.prepareDimChange(),
                this.createFeedback(),
                this.setInteractionMode(1),
                this.mView.cameraControl.eventCameraChanged.addListener(
                  this.onCameraChanged
                ),
                s.prototype.start.call(this, e)
              );
            }),
            (t.prototype.stop = function () {
              this.mView.cameraControl.eventCameraChanged.removeListener(
                this.onCameraChanged
              ),
                null != this.mFeedbackNode &&
                  (this.mFeedbackNode.dispose(!1),
                  (this.mFeedbackNode = null),
                  (this.mFeedbackBox = null)),
                null != this.mFeedbackMat &&
                  (this.mFeedbackMat.dispose(), (this.mFeedbackMat = null));
              for (var e = 0, t = this.mLengthFeedback; e < t.length; e++)
                t[e].dispose();
              (this.mLengthFeedback = new Array()), s.prototype.stop.call(this);
            }),
            (t.prototype.handlePointerUp = function (e, t) {
              var r = this;
              t.isPrimaryPointer(e) &&
                this.applyScale().then(function () {
                  r.stop(),
                    null != r.mNextActionIds &&
                      0 < r.mNextActionIds.length &&
                      n.executeActions(
                        r.mInteractors.manager,
                        r.mInteractors.article,
                        r.mNextActionIds,
                        r.mInteractor
                      );
                });
            }),
            (t.prototype.handlePointerMove = function (e, t) {
              if (t.isPrimaryPointer(e)) {
                var r = t.pointers.get(e.pointerId);
                if (null != r) {
                  var n = r.position,
                    i = this.getPlanePickPos(n);
                  if (null != i) {
                    var a = BABYLON.Vector3.TransformCoordinates(
                      i,
                      this.mInteractors.article.worldTransformInverted
                    ).subtract(this.mLocalStartPoint);
                    if (
                      (a.multiplyInPlace(this.mScaleDirection),
                      (a = this.performSnap(a, e, t)),
                      null != this.mFeedbackBox)
                    ) {
                      var s = new BABYLON.Vector3(0, 0, 0);
                      0 < a.x &&
                        null != this.mAxis.x &&
                        ((this.mFeedbackBox.scaling.x = a.x),
                        (s.x = a.x * this.mScaleDirection.x)),
                        0 < a.y &&
                          null != this.mAxis.y &&
                          ((this.mFeedbackBox.scaling.y = a.y),
                          (s.y = a.y * this.mScaleDirection.y)),
                        0 < a.z &&
                          null != this.mAxis.z &&
                          ((this.mFeedbackBox.scaling.z = a.z),
                          (s.z = a.z * this.mScaleDirection.z));
                      for (
                        var o = this.mLocalStartPoint.add(s),
                          l = 0,
                          c = this.mLengthFeedback;
                        l < c.length;
                        l++
                      )
                        c[l].update(r, o);
                      this.mView.viewer.requestRenderFrame();
                    }
                  }
                }
              }
            }),
            (t.prototype.prepareDimChange = function () {
              if (
                ((this.mArticleBounds = this.mInteractors.article.boundingBox.clone()),
                (this.mRefPoint = this.mInteractor.worldPosition.clone()),
                this.mLocalStartPoint.copyFrom(this.mArticleBounds.min),
                (this.mAxis = { x: null, y: null, z: null }),
                null != this.mAction.dimChanges)
              )
                for (
                  var e = 0, t = this.mAction.dimChanges;
                  e < t.length;
                  e++
                ) {
                  var r = t[e],
                    n = h.utils.math.VECTOR3_X,
                    i = r.axis.toLowerCase();
                  'y' === i
                    ? (n = h.utils.math.VECTOR3_Y)
                    : 'z' === i && (n = h.utils.math.VECTOR3_Z);
                  var a = void 0;
                  if (null != r.propChoiceList && 0 < r.propChoiceList.length) {
                    a = new Array();
                    for (var s = 0, o = r.propChoiceList; s < o.length; s++) {
                      var l = o[s];
                      a.push(l * r.multiplier);
                    }
                  }
                  this.mAxis[i] = {
                    axis: i,
                    axisVec: n,
                    minScale: r.minPropValue * r.multiplier,
                    maxScale: r.maxPropValue * r.multiplier,
                    choiceValues: a,
                    dimChange: r,
                  };
                }
              this.preparePickPlane(),
                this.prepareSnapping(),
                this.detectNegativeScale();
            }),
            (t.prototype.preparePickPlane = function () {
              var e = new Array(),
                t = this.mView.cameraControl.direction,
                r = this.mInteractors.article.worldTransform;
              for (var n in this.mAxis) {
                var i,
                  a,
                  s = this.mAxis[n];
                null != s &&
                  ((i = BABYLON.Vector3.TransformNormal(s.axisVec, r)),
                  (a = Math.abs(BABYLON.Vector3.Dot(t, i))),
                  h.utils.math.eq(a, 1) ||
                    e.push({ cameraDirDot: a, data: s, worldAxis: i }));
              }
              var o,
                l = t;
              0 < e.length &&
                (l =
                  1 < e.length
                    ? (e.sort(function (e, t) {
                        return e.cameraDirDot - t.cameraDirDot;
                      }),
                      2 < e.length && e.pop(),
                      BABYLON.Vector3.Cross(e[0].worldAxis, e[1].worldAxis))
                    : ((o = BABYLON.Vector3.Cross(e[0].worldAxis, t)),
                      BABYLON.Vector3.Cross(e[0].worldAxis, o))),
                (this.mPickPlane = BABYLON.Plane.FromPositionAndNormal(
                  this.mRefPoint,
                  l
                )),
                (this.mAxis = { x: null, y: null, z: null });
              for (var c = 0, u = e; c < u.length; c++) {
                var m = u[c];
                this.mAxis[m.data.axis] = m.data;
              }
            }),
            (t.prototype.detectNegativeScale = function () {
              var e = this.mArticleBounds.getCenter(),
                t = BABYLON.Vector3.TransformCoordinates(
                  this.mInteractor.worldPosition,
                  this.mInteractors.article.worldTransformInverted
                );
              this.mScaleDirection.set(1, 1, 1),
                t.x < e.x &&
                  null != this.mAxis.x &&
                  ((this.mLocalStartPoint.x = this.mArticleBounds.max.x),
                  (this.mScaleDirection.x = -1)),
                t.y < e.y &&
                  null != this.mAxis.y &&
                  ((this.mLocalStartPoint.y = this.mArticleBounds.max.y),
                  (this.mScaleDirection.y = -1)),
                t.z < e.z &&
                  null != this.mAxis.z &&
                  ((this.mLocalStartPoint.z = this.mArticleBounds.max.z),
                  (this.mScaleDirection.z = -1));
            }),
            (t.prototype.prepareSnapping = function () {
              for (var e in ((this.mSnapGrip.snapXAxis = !1),
              (this.mSnapGrip.snapYAxis = !1),
              (this.mSnapGrip.snapZAxis = !1),
              this.mAxis)) {
                var t = this.mAxis[e];
                if (null != t)
                  switch (t.axis) {
                    case 'x':
                      (this.mSnapGrip.snapXAxis = !0),
                        (this.mSnapGrip.size.x = t.dimChange.precision);
                      break;
                    case 'y':
                      (this.mSnapGrip.snapYAxis = !0),
                        (this.mSnapGrip.size.y = t.dimChange.precision);
                      break;
                    case 'z':
                      (this.mSnapGrip.snapZAxis = !0),
                        (this.mSnapGrip.size.z = t.dimChange.precision);
                  }
              }
            }),
            (t.prototype.createFeedback = function () {
              (this.mFeedbackMat = new h.core.mdl.PbrMaterial(
                'dim_feedback_mat',
                this.mApp.model.materials
              )),
                (this.mFeedbackMat.albedoColor = BABYLON.Color3.FromHexString(
                  this.mApp.theme.mainColorBright
                ).toLinearSpace()),
                (this.mFeedbackMat.roughness = 1),
                (this.mFeedbackMat.metallic = 0),
                (this.mFeedbackMat.alpha = 0.2);
              var e = this.mArticleBounds.getSize();
              (this.mFeedbackNode = new BABYLON.TransformNode(
                'dim_feedback_node',
                this.mApp.model.scene
              )),
                h.utils.mesh.setLocalMatrix(
                  this.mFeedbackNode,
                  this.mInteractors.article.worldTransform
                );
              var t = BABYLON.MeshBuilder.CreateBox(
                'dim_feedback_mesh',
                { size: 1, updatable: !1 },
                this.mApp.model.scene
              );
              t.bakeTransformIntoVertices(
                BABYLON.Matrix.Translation(
                  0.5 * this.mScaleDirection.x,
                  0.5 * this.mScaleDirection.y,
                  0.5 * this.mScaleDirection.z
                )
              ),
                t.position.copyFrom(this.mLocalStartPoint),
                t.scaling.copyFrom(e),
                (t.parent = this.mFeedbackNode),
                (t.material = this.mFeedbackMat),
                (t.renderingGroupId = 1),
                (this.mFeedbackBox = t),
                (this.mLengthFeedback = new Array());
              var r = BABYLON.Vector3.TransformNormal(
                this.mPickPlane.normal,
                this.mInteractors.article.worldTransformInverted
              );
              r.normalize();
              var n = 1;
              for (var i in this.mAxis) {
                var a = this.mAxis[i];
                if (null != a) {
                  var s = void 0;
                  switch (a.axis) {
                    case 'x':
                      s = '#c00303';
                      break;
                    case 'y':
                      s = '#95c11f';
                      break;
                    default:
                      s = '#0084b4';
                  }
                  var o = new h.core.tool.LengthFeedback(
                    n,
                    this.mLocalStartPoint,
                    a.axisVec,
                    s,
                    r,
                    this.mApp.model.scene,
                    this.mView,
                    this.mInteractors.article.worldTransform,
                    !0
                  );
                  (o.showAbsoluteValues = !0),
                    this.mLengthFeedback.push(o),
                    n--;
                }
              }
            }),
            (t.prototype.getPlanePickPos = function (e) {
              return null != e && null != this.mPickPlane
                ? (this.mView.createPickingRayToRef(e, 1, null, r),
                  h.utils.math.intersectRayPlane(r, this.mPickPlane))
                : null;
            }),
            (t.prototype.performSnap = function (e, t, r) {
              var n = this.mSnapGrip.snap(e, this.mView);
              for (var i in this.mAxis) {
                var a,
                  s = this.mAxis[i];
                null != s &&
                  ((a = this.getVectorAxis(n, s.axis)),
                  (a = this.snapToChoiceValues(s, a)) < s.minScale &&
                    (a = s.minScale),
                  a > s.maxScale && (a = s.maxScale),
                  this.setVectorAxis(n, s.axis, a));
              }
              return n;
            }),
            (t.prototype.getVectorAxis = function (e, t) {
              return e[t];
            }),
            (t.prototype.setVectorAxis = function (e, t, r) {
              e[t] = r;
            }),
            (t.prototype.snapToChoiceValues = function (e, t) {
              if (null == e.choiceValues || e.choiceValues.length < 1) return t;
              for (
                var r = t, n = Number.MAX_VALUE, i = 0, a = e.choiceValues;
                i < a.length;
                i++
              ) {
                var s = a[i],
                  o = Math.abs(t - s);
                o < n && ((n = o), (r = s));
              }
              if (e.dimChange.fixedValue) return r;
              var l = this.getVectorAxis(this.mLocalStartPoint, e.axis),
                c = this.mInteractors.article.worldTransform,
                u = this.mLocalStartPoint.clone(),
                m = this.mLocalStartPoint.clone();
              this.setVectorAxis(u, e.axis, l + t),
                this.setVectorAxis(m, e.axis, l + r);
              var h = this.mView.projectedDistance(u, m, c);
              return (null != h && h) < 15 ? r : t;
            }),
            (t.prototype.applyScale = function () {
              return __awaiter(this, void 0, void 0, function () {
                var t, r, n, i, a, s, o, l;
                return __generator(this, function (e) {
                  switch (e.label) {
                    case 0:
                      for (n in (e.trys.push([0, , 7, 8]),
                      null != this.mApp.appCallbacks.beginAsyncOperation &&
                        this.mApp.appCallbacks.beginAsyncOperation(),
                      this.mApp.model.beginModification(),
                      this.mApp.model.beginSelectionChange(),
                      this.mInteractors.article.beginChange(),
                      (t = !1),
                      (r = []),
                      this.mAxis))
                        r.push(n);
                      (i = 0), (e.label = 1);
                    case 1:
                      return i < r.length
                        ? ((a = r[i]),
                          null == (s = this.mAxis[a]) ||
                          null == this.mFeedbackBox
                            ? [3, 3]
                            : ((o = this.getVectorAxis(
                                this.mFeedbackBox.scaling,
                                s.axis
                              )),
                              (o = h.utils.math.roundTo(
                                o / s.dimChange.multiplier,
                                s.dimChange.propDecDigits
                              )),
                              h.utils.math.eq(o, s.dimChange.propValue)
                                ? [3, 3]
                                : [
                                    4,
                                    this.mInteractors.article.setEaiwsPropertyValue(
                                      null != s.dimChange.propClass
                                        ? s.dimChange.propClass
                                        : '',
                                      s.dimChange.propName,
                                      o.toString(),
                                      !1
                                    ),
                                  ]))
                        : [3, 4];
                    case 2:
                      (l = e.sent()), (t = t || 0 !== l), (e.label = 3);
                    case 3:
                      return i++, [3, 1];
                    case 4:
                      return t
                        ? [
                            4,
                            this.mInteractors.article
                              .getMainArticle()
                              .updateGeometry(),
                          ]
                        : [3, 6];
                    case 5:
                      e.sent(), (e.label = 6);
                    case 6:
                      return [3, 8];
                    case 7:
                      return (
                        this.mInteractors.article.endChange(),
                        this.mApp.model.endSelectionChange(),
                        this.mApp.model.endModification(),
                        null != this.mApp.appCallbacks.endAsyncOperation &&
                          this.mApp.appCallbacks.endAsyncOperation(),
                        [7]
                      );
                    case 8:
                      return [2];
                  }
                });
              });
            }),
            t);
        function t(e, t, r, n, i) {
          var a = s.call(this, e) || this;
          return (
            (a.onCameraChanged = function () {
              for (var e = 0, t = a.mLengthFeedback; e < t.length; e++) {
                t[e].update(null, null);
              }
              a.mApp.viewer.requestRenderFrame();
            }),
            (a.mInteractors = t),
            (a.mInteractor = r),
            (a.mAction = n),
            (a.mNextActionIds = i),
            (a.mPickPlane = new BABYLON.Plane(0, 1, 0, 0)),
            (a.mRefPoint = BABYLON.Vector3.Zero()),
            (a.mLocalStartPoint = BABYLON.Vector3.Zero()),
            (a.mScaleDirection = BABYLON.Vector3.Zero()),
            (a.mSnapGrip = new h.core.tool.SnapGrid()),
            (a.mAxis = { x: null, y: null, z: null }),
            (a.mFeedbackNode = null),
            (a.mFeedbackBox = null),
            (a.mFeedbackMat = null),
            (a.mLengthFeedback = new Array()),
            a
          );
        }
        n.DimChangeTool = e;
        var r = BABYLON.Ray.Zero();
      })((t = h.cf || (h.cf = {})).oap || (t.oap = {}));
  })((egr = egr || {})),
  (function (e) {
    var l, t, c, u, r;
    function m(t, r, e) {
      var n =
        u.call(this, document.createElement('div'), t.manager.app.viewer) ||
        this;
      (n.onUpdateViewPosition = function (e) {
        if (n.mUpdateVisibility) {
          if (null != n.mViewAngle && null != n.mWorldDirection) {
            var t = m._GetDirectionToCamera(n.mWorldPosition, e),
              r = l.utils.math.angleBetweenVectors3(n.mWorldDirection, t);
            if (
              ((n.mCurrentAngleVisibility = r <= n.mViewAngle),
              !n.mCurrentAngleVisibility)
            )
              return void (n.visible = !1);
            n.mHiddenMode || (n.visible = n.mCurrentAngleVisibility);
          } else n.mCurrentAngleVisibility = !0;
          n.mHiddenMode
            ? n.mInteractors.requestVisibilityCheck(n)
            : (n.visible = !0);
        }
      }),
        (n.mInteractors = t),
        (n.mOapInteractor = r),
        (n.mClientRect = void 0),
        (n.mHiddenMode = !1),
        (n.mUpdateVisibility = !0),
        (n.mCurrentAngleVisibility = !0);
      var i = document.createElement('span');
      (i.style.backgroundImage = "url('" + t.spriteUrl + "')"),
        n.mElement.appendChild(i),
        (n.mElement.className =
          'wcf-cf ' + n.getInteractorCssClass(n.mOapInteractor));
      var a,
        s,
        o = null;
      return (
        null != r.directActions &&
          0 < r.directActions.length &&
          null != r.directActions[0].actionData &&
          r.directActions[0].actionData instanceof
            l.eaiws.basket.OAPDimChangeAction &&
          (o = r.directActions[0].actionData),
        (n.type = null != o ? 1 : 2),
        (n.onTriggerAction = function () {
          var e;
          (n.mClientRect = n.mElement.getBoundingClientRect()),
            1 != n.type || null == o
              ? null != r.actionIds &&
                c.executeActions(t.manager, t.article, r.actionIds, n)
              : ((e = new c.DimChangeTool(
                  n.mInteractors.manager.app,
                  n.mInteractors,
                  n,
                  o,
                  r.actionIds
                )),
                n.mInteractors.manager.app.tools.startTool(e));
        }),
        (n.customCssTransform = 'translate(-50%, -50%)'),
        (n.worldMatrix = t.article.worldTransform),
        null != e
          ? null != e.symbolOffset &&
            n.position.set(
              e.symbolOffset.x,
              e.symbolOffset.y,
              -e.symbolOffset.z
            )
          : null != r.symbolOffset &&
            n.position.set(
              r.symbolOffset.x,
              r.symbolOffset.y,
              -r.symbolOffset.z
            ),
        (n.mWorldPosition = n.position.clone()),
        BABYLON.Vector3.TransformCoordinatesToRef(
          n.mWorldPosition,
          n.worldMatrix,
          n.mWorldPosition
        ),
        null != e &&
          (null != e.viewAngle &&
            (n.mViewAngle = l.utils.math.degToRad(0.5 * e.viewAngle)),
          null != e.direction &&
            ((n.mWorldDirection = new BABYLON.Vector3(
              e.direction.x,
              e.direction.y,
              -e.direction.z
            ).normalize()),
            BABYLON.Vector3.TransformNormalToRef(
              n.mWorldDirection,
              n.worldMatrix,
              n.mWorldDirection
            ),
            null != e.orientationX &&
              ((a = new BABYLON.Vector3(
                e.orientationX.x,
                e.orientationX.y,
                -e.orientationX.z
              ).normalize()),
              BABYLON.Vector3.TransformNormalToRef(a, n.worldMatrix, a),
              (s = BABYLON.Vector3.Cross(a, n.mWorldDirection)),
              (n.transform3dRotation = l.utils.math.quaternionFromAxes(
                a,
                n.mWorldDirection,
                s
              )),
              n.transform3dRotation.multiplyInPlace(
                BABYLON.Quaternion.RotationAxis(
                  l.utils.math.VECTOR3_X,
                  l.utils.math.PI_DIV2
                )
              ),
              (n.transform3d = !0))),
          null != e.hiddenMode && (n.mHiddenMode = e.hiddenMode)),
        (n.onBeforeUpdateViewPosition = n.onUpdateViewPosition),
        n
      );
    }
    (l = e.wcf || (e.wcf = {})),
      (t = l.cf || (l.cf = {})),
      (c = t.oap || (t.oap = {})),
      (u = l.core.tool.Interactor),
      __extends(m, u),
      Object.defineProperty(m.prototype, 'oapInteractor', {
        get: function () {
          return this.mOapInteractor;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(m.prototype, 'cachedBoundingClientRect', {
        get: function () {
          return this.mClientRect;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(m.prototype, 'worldPosition', {
        get: function () {
          return this.mWorldPosition;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(m.prototype, 'hiddenMode', {
        get: function () {
          return this.mHiddenMode;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (m.prototype.setHidden = function (e) {
        (this.mUpdateVisibility = !1),
          (this.visible = !e && this.mCurrentAngleVisibility),
          (this.mUpdateVisibility = !0);
      }),
      (m._GetDirectionToCamera = function (e, t) {
        var r;
        return (
          7 === t.cameraControl.cameraMode
            ? (r = t.cameraControl.position.subtract(e)).normalize()
            : (r = t.cameraControl.direction.negate()),
          r
        );
      }),
      (m.prototype.getInteractorCssClass = function (e) {
        var t = 'oap-interactor-';
        switch (e.symbolSize) {
          case 'Small':
            t += 'small-';
            break;
          case 'Medium':
            t += 'medium-';
            break;
          default:
            t += 'large-';
        }
        var r = m.INTERACTOR_NAME_MAP.get(e.symbolType);
        return (t += null != r ? r : 'add');
      }),
      (m.INTERACTOR_NAME_MAP = new Map([
        ['Add', 'add'],
        ['ChangeDimHorizontal', 'change-dim-horizontal'],
        ['ChangeDim2Left', 'change-dim-2-left'],
        ['ChangeDim2Right', 'change-dim-2-right'],
        ['ChangeDimVertical', 'change-dim-vertical'],
        ['ChangeDimDown', 'change-dim-down'],
        ['ChangeDimUp', 'change-dim-up'],
        ['Delete', 'delete'],
        ['Edit', 'edit'],
        ['Flip', 'flip'],
        ['Material', 'material'],
        ['OnOff', 'on-off'],
        ['PosHorizontal', 'pos-horizontal'],
        ['Pos2Left', 'pos-2-left'],
        ['Pos2Right', 'pos-2-right'],
        ['PosVertical', 'pos-vertical'],
        ['PosDown', 'pos-down'],
        ['PosUp', 'pos-up'],
        ['RotateNY90', 'rotate-ny90'],
        ['RotatePY90', 'rotate-py90'],
        ['DeleteObj', 'delete'],
        ['PropChange', 'edit'],
        ['PropEdit', 'edit'],
        ['RotateX180', 'flip'],
        ['RotateY180', 'flip'],
        ['RotateZ180', 'flip'],
      ])),
      (r = m),
      (c.Interactor = r);
  })((egr = egr || {})),
  (function (e) {
    var i, t, a, r;
    function h(e, t) {
      var r = this;
      (this.onInstantVisibilityCheck = function () {
        r.mVisCheckTimeout = null;
        var e = Date.now();
        r.checkInteractorVisibilities(),
          50 < Date.now() - e && (r.mInstantVisCheck = !1);
      }),
        (this.onVisibilityCheck = function () {
          (r.mVisCheckTimeout = null), r.checkInteractorVisibilities();
        }),
        (this.pickPredicate = function (e) {
          return null != e && e[h.PICKING_ID] === r.mCurrentPickingId;
        }),
        (this.mMngr = t),
        (this.mArticle = e),
        (this.mInteractors = new i.core.tool.InteractorManager(
          this.mMngr.app.viewer
        )),
        (this.mGetInteractorsPromise = null),
        (this.mVisCheckTimeout = null),
        (this.mDisableRequestVisCheck = !1),
        (this.mCurrentPickingId = null),
        (this.mInstantVisCheck = !0);
    }
    (i = e.wcf || (e.wcf = {})),
      (t = i.cf || (i.cf = {})),
      (a = t.oap || (t.oap = {})),
      Object.defineProperty(h.prototype, 'manager', {
        get: function () {
          return this.mMngr;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(h.prototype, 'article', {
        get: function () {
          return this.mArticle;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(h.prototype, 'spriteUrl', {
        get: function () {
          return h.sSpriteUrl;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (h.prototype.showInteractors = function (e) {
        var t = this;
        this.clear(),
          (this.mInteractors.enabled = e),
          this.mInteractors.enabled &&
            null == this.mGetInteractorsPromise &&
            (1 < this.mMngr.app.model.selection.length ||
              (this.mGetInteractorsPromise = this.getAndCreateInteractors()
                .then(function () {
                  t.mGetInteractorsPromise = null;
                })
                .catch(function (e) {
                  (t.mGetInteractorsPromise = null),
                    i.utils.Log.error('Failed to get oap interactors.', e);
                })));
      }),
      (h.prototype.dispose = function () {
        this.clearVisCheckTimeout(), this.mInteractors.dispose();
      }),
      (h.prototype.requestVisibilityCheck = function (e) {
        this.mDisableRequestVisCheck ||
          (this.mInstantVisCheck
            ? null == this.mVisCheckTimeout &&
              (this.mVisCheckTimeout = setTimeout(
                this.onInstantVisibilityCheck,
                0
              ))
            : (this.clearVisCheckTimeout(),
              (this.mVisCheckTimeout = setTimeout(
                this.onVisibilityCheck,
                200
              ))));
      }),
      (h.PrepareSprite = function (n) {
        return __awaiter(this, void 0, void 0, function () {
          var t, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return null != h.sSpriteUrl
                  ? [3, 3]
                  : ((t = n + 'cf/images/oap_sprite_v3.svg'),
                    (function () {
                      if (/iP(hone|od|ad)/.test(navigator.platform)) {
                        var e = navigator.appVersion.match(
                          /OS (\d+)_(\d+)_?(\d+)?/
                        );
                        if (null == e) return;
                        var t = [
                          parseInt(e[1], 10),
                          parseInt(e[2], 10),
                          parseInt(e[3] || '0', 10),
                        ];
                        return t[0] < 12 || (12 === t[0] && t[1] < 2);
                      }
                    })()
                      ? ((h.sSpriteUrl = t), [3, 3])
                      : [3, 1]);
              case 1:
                return (r = h), [4, i.utils.dom.loadContentAsBlobUrl(t)];
              case 2:
                (r.sSpriteUrl = e.sent()), (e.label = 3);
              case 3:
                return [2];
            }
          });
        });
      }),
      (h.prototype.clear = function () {
        this.clearVisCheckTimeout(),
          (this.mInstantVisCheck = !0),
          (this.mCurrentPickingId = null),
          this.mInteractors.clear(),
          (this.mInteractors.enabled = !1);
      }),
      (h.prototype.clearVisCheckTimeout = function () {
        null != this.mVisCheckTimeout &&
          (clearTimeout(this.mVisCheckTimeout), (this.mVisCheckTimeout = null));
      }),
      (h.prototype.getAndCreateInteractors = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, h.PrepareSprite(this.manager.app.dataPath)];
              case 1:
                return (
                  e.sent(),
                  [
                    4,
                    this.mArticle
                      .getMainArticle()
                      ._getOapInteractors(this.mArticle),
                  ]
                );
              case 2:
                return (
                  (t = e.sent()),
                  this.mInteractors.enabled && this.createInteractors(t),
                  [2]
                );
            }
          });
        });
      }),
      (h.prototype.createInteractors = function (e) {
        if (null != e) {
          for (var t = !1, r = 0, n = e; r < n.length; r++) {
            var i = n[r];
            if (null != i.symbols && 0 < i.symbols.length)
              for (var a = 0, s = i.symbols; a < s.length; a++)
                var o = s[a], l = this.createInteractor(i, o), t = t || l;
            else (l = this.createInteractor(i)), (t = t || l);
          }
          if (t) {
            this.mCurrentPickingId = h.sPickingIDCounter++;
            for (
              var c = 0, u = this.mArticle.getMainArticle().getNodes(!0);
              c < u.length;
              c++
            ) {
              var m = u[c];
              m instanceof BABYLON.Mesh &&
                null != m.geometry &&
                m.isPickable &&
                m.isVisible &&
                m.isEnabled() &&
                (m[h.PICKING_ID] = this.mCurrentPickingId);
            }
          }
        }
      }),
      (h.prototype.createInteractor = function (e, t) {
        var r = new a.Interactor(this, e, t);
        return this.mInteractors.addInteractor(r), r.hiddenMode;
      }),
      (h.prototype.checkInteractorVisibilities = function () {
        this.mDisableRequestVisCheck = !0;
        for (var e = 0, t = this.mInteractors.interactors; e < t.length; e++) {
          var r = t[e];
          r.hiddenMode && this.checkInteractorVisibility(r);
        }
        this.mDisableRequestVisCheck = !1;
      }),
      (h.prototype.checkInteractorVisibility = function (e) {
        var t, r, n;
        null != this.mInteractors.view &&
          ((t = a.Interactor._GetDirectionToCamera(
            e.worldPosition,
            this.mInteractors.view
          )),
          (r = new BABYLON.Ray(e.worldPosition, t)),
          (n = this.mInteractors.viewer.scene.pickWithRay(
            r,
            this.pickPredicate,
            !0
          )),
          e.setHidden(null != n && n.hit));
      }),
      (h.PICKING_ID = 'cf.OAPInteractors.pickingId'),
      (h.sPickingIDCounter = 0),
      (h.sSpriteUrl = null),
      (r = h),
      (a.Interactors = r);
  })((egr = egr || {}));
